// fa
export const locale = {
  lang: 'fa',
  data: {
    privateNumberShahkar: {
      title: 'اطلاعات شاهکار',
      realTitle: 'اطلاعات شخص حقیقی',
      legalTitle: 'اطلاعات سازمان حقوقی و نماینده',
      requiredDescription:
        'برای ادامه خرید اولین شماره، ثبت اطلاعات شاهکار الزامی است.',
      optionalDescription:
        'می‌توانید اطلاعات شاهکار را ویرایش کنید یا بدون تغییر ادامه دهید.',
      loading: 'در حال دریافت اطلاعات…',
      loadFailed: 'دریافت اطلاعات انجام نشد. دوباره تلاش کنید.',
      retry: 'تلاش مجدد',
      invalidField: 'مقدار معتبر وارد کنید.',
      saveAndContinue: 'ثبت و ادامه',
      skip: 'ادامه بدون تغییر',
      cancel: 'انصراف از خرید',
      legends: {
        representativeInformation: 'اطلاعات نماینده سازمان',
        companyInformation: 'اطلاعات شرکت',
        contactInformation: 'اطلاعات تماس و نشانی',
      },
      fields: {
        firstName: 'نام',
        lastName: 'نام خانوادگی',
        fatherName: 'نام پدر',
        identificationType: 'نوع مدرک شناسایی',
        identificationNo: 'شماره شناسه هویتی مدیر ',
        mobile: 'شماره موبایل',
        birthCertNo: 'شماره شناسنامه',
        birthDate: 'تاریخ تولد',
        birthPlace: 'محل تولد',
        gender: 'جنسیت',
        economicNo: 'شناسه ملی شرکت ',
        corporateNo: 'شماره ثبت شرکت',
        companyName: 'نام شرکت',
        companyType: 'نوع شرکت',
        companyRegDate: 'تاریخ ثبت شرکت',
        address: 'نشانی',
        provinceCode: 'کد استان',
        provinceName: 'استان',
        cityName: 'شهر',
        street: 'خیابان',
        houseNumber: 'پلاک',
        phone: 'شماره تلفن',
        email: 'ایمیل',
        zipCode: 'کد پستی',
        universalNo: 'شماره فراگیر',
      },
      options: {
        nationalCode: 'کد ملی',
        passport: 'گذرنامه',
        refugeeCard: 'کارت پناهندگی',
        amayeshCard: 'کارت آمایش',
        identityCard: 'پروفایل هویتی',
        male: 'مرد',
        female: 'زن',
        PublicStock: 'سهامی عام',
        PrivateEquity: 'سهامی خاص',
        LimitedLiability: 'مسئولیت محدود',
        Collaborative: 'تضامنی',
        NonJointStockMix: 'مختلط غیرسهامی',
        JointStockMix: 'مختلط سهامی',
        Relative: 'نسبی',
        Cooperative: 'تعاونی',
        Governmental: 'دولتی',
        Ministry: 'وزارتخانه',
        Embassy: 'سفارت',
        Mosque: 'مسجد',
        School: 'مدرسه',
        Ngo: 'سازمان مردم‌نهاد',
      },
    },
    proformaInvoice: {
      title: 'پیش‌فاکتور',
      documentKicker: 'سند رسمی پرداخت',
      number: 'شماره',
      invoiceDate: 'تاریخ فاکتور',
      status: 'وضعیت',
      awaitingPayment: 'در انتظار پرداخت',
      seller: 'مشخصات فروشنده',
      customer: 'مشخصات خریدار',
      personName: 'نام شخص حقیقی یا حقوقی',
      economicNumber: 'شماره اقتصادی',
      registrationOrNationalNumber: 'شماره ثبت / شماره ملی',
      province: 'استان',
      county: 'شهرستان',
      postalCode: 'کد پستی',
      city: 'شهر',
      address: 'نشانی',
      phone: 'تلفن',
      itemsCaption: 'مشخصات کالا یا خدمات',
      row: 'ردیف',
      description: 'شرح کالا یا خدمات',
      count: 'تعداد',
      unitPrice: 'مبلغ واحد',
      discount: 'تخفیف',
      tax: 'مالیات',
      total: 'جمع کل',
      grandTotalInWords: 'مبلغ کل به حروف',
      grandTotal: 'مبلغ کل',
      noItems: 'ردیفی برای نمایش وجود ندارد.',
      gateway: 'درگاه پرداخت',
      bank: 'بانک',
      accountNumber: 'شماره حساب',
      subtotal: 'جمع قبل از تخفیف و مالیات',
      totalAfterDiscount: 'جمع بعد از تخفیف',
      payableAmount: 'مبلغ قابل پرداخت',
      rial: 'ریال',
      sellerStamp: 'مهر و امضای فروشنده',
      customerStamp: 'مهر و امضای خریدار',
      legalNote:
        'این پیش فاکتور فاقد ارزش و اعتبار حقوقی جهت اعلام و درج در سایت های امور مالیاتی، دارایی، بیمه و... می باشد.',
      allAmountsInRials: 'تمامی مبالغ به ریال می‌باشد.',
      validityNote: 'اعتبار این پیش فاکتور 48 ساعت می باشد.',
      createAndReview: 'صدور و بررسی پیش‌فاکتور',
      createdTitle: 'پیش‌فاکتور شما آماده است',
      existingTitle: 'پیش‌فاکتور ثبت شد',
      onlyOneActive:
        'در هر زمان فقط یک پیش‌فاکتور فعال دارید. پیش از ادامه پرداخت، اطلاعات آن را بررسی کنید.',
      view: 'مشاهده پیش فاکتور',
      print: 'چاپ',
      downloadPdf: 'دریافت PDF',
      payNow: 'ادامه و پرداخت',
      cancelProforma: 'لغو پیش‌فاکتور',
      loading: 'در حال دریافت پیش‌فاکتور',
      loadFailedTitle: 'دریافت پیش‌فاکتور انجام نشد',
      loadFailed:
        'شناسه پیش‌فاکتور محفوظ است. بدون صدور مجدد، دریافت جزئیات را دوباره امتحان کنید.',
      createFailed: 'صدور پیش‌فاکتور انجام نشد.',
      cancelFailed: 'لغو پیش‌فاکتور انجام نشد.',
      cancelSucceed: 'لغو پیش‌فاکتور با موفقیت انجام شد.',
      paymentFailed: 'شروع پرداخت انجام نشد.',
      paymentDataUnavailable:
        'اطلاعات پرداخت ذخیره‌شده ناقص یا نامعتبر است. پیش از تلاش مجدد با پشتیبانی تماس بگیرید.',
      pdfFailed: 'ساخت فایل PDF انجام نشد.',
      cancelConfirmTitle: 'لغو پیش‌فاکتور',
      cancelConfirmMessage: 'آیا از لغو این پیش‌فاکتور اطمینان دارید؟',
      popupBlocked:
        'مرورگر بازشدن تب جدید را مسدود کرد. دسترسی Pop-up را فعال و دوباره تلاش کنید.',
      invalidIdTitle: 'پیوند پیش‌فاکتور نامعتبر است',
      invalidId: 'شماره پیش‌فاکتور موجود در این پیوند معتبر نیست.',
      backToPanel: 'بازگشت به پنل',
      walletAlt: 'کیف پول',
    },
    appName: 'پیشگام پیامک',
    layout: {
      footer: {
        aboutUs: 'درباره ما',
        contactUs: 'تماس با ما',
        support: 'پشتیبانی',
      },
      asideMenu: {
        Dashboard: 'داشبورد',
        Infrastructure: 'زیرساخت',
        SystemManagement: 'مدیریت سیستم',
        SendingSystem: 'ارسال',
        Configuration: 'پیکربندی',
        SmsReports: 'گزارشات پیامک',
        Facility: 'امکانات',
        Financial: 'امور مالی ',
        Phonebook: 'دفترچه تلفن',
        Setting: 'تنظیمات',
        Services: 'سرویس ها',
        whiteMessages: 'باشگاه مشتریان',
      },
    },
    pages: {
      buyNumber: {
        title: 'خرید خط اختصاصی',
      },
      privateNumberBuy: {
        checkout: {
          title: 'پرداخت خرید خط',
          remaining: 'زمان باقی‌مانده رزرو',
          expired: 'زمان رزرو این خط به پایان رسیده است.',
          selectedNumber: 'خط انتخاب‌شده',
          identifier: 'شناسه خط',
          rondRules: 'قواعد رندی',
        },
        featuresTitle: 'ویژگی‌های شماره',
        rondStatusTitle: 'وضعیت رند بودن',
        title: 'خرید خط اختصاصی',
        storeTitle: 'فروشگاه شماره',
        loadingMore: 'در حال دریافت شماره‌های بیشتر...',
        loadMoreError: 'دریافت شماره‌های بیشتر با خطا مواجه شد.',
        loadError: 'دریافت شماره‌ها با خطا مواجه شد.',
        retry: 'تلاش مجدد',
        numberLabel: 'شماره خط',
        showFullNumber: 'نمایش کامل شماره',
        subtitle: 'خط مناسب کسب‌وکارتان را پیدا و انتخاب کنید.',
        search: 'جستجوی شماره خط',
        clearFilters: 'حذف فیلترها',
        all: 'همه خطوط',
        available: 'آماده خرید',
        compare: 'مقایسه',
        backToNumbers: 'بازگشت به لیست خطوط',
        confirmComparison: 'می‌خواهید دو خط انتخاب‌شده را مقایسه کنید؟',
        selected: 'خط انتخاب‌شده',
        clear: 'پاک کردن انتخاب‌ها',
        price: 'قیمت خرید',
        renewal: 'تمدید سالانه',
        maintenance: 'هزینه نگهداری',
        pattern: 'الگوی شماره',
        digits: 'تعداد رقم',
        digitsValue: '{{count}} رقمی',
        digitUnit: 'رقمی',
        linkSending: 'ارسال لینک',
        enabled: 'فعال',
        disabled: 'غیرفعال',
        sendTypesLabel: 'روش‌های ارسال',
        none: 'ندارد',
        headline: 'سرخط',
        sendTypes: {
          single: 'تکی',
          phonebook: 'دفترچه تلفن',
          bulk: 'انبوه',
          dynamic: 'داینامیک',
          p2p: 'دوطرفه',
          smart: 'هوشمند',
          apiSingle: 'تکی API',
          apiP2P: 'دوطرفه API',
          otp: 'OTP',
          club: 'باشگاه مشتریان',
          bulk2: 'انبوه',
          occasionPhonebook: 'دفترچه مناسبتی',
          smartP2P: 'هوشمند دوطرفه',
          device: 'دستگاه',
          p2pOtp: 'OTP دوطرفه',
        },
        action: 'رزرو',
        requestPrice: 'درخواست پیشنهاد قیمت',
        unavailablePrice: 'استعلام قیمت',
        noResults: 'خطی با این مشخصات پیدا نشد.',
        compareHint: 'برای مقایسه، حداکثر ۳ خط را انتخاب کنید.',
        compareCount: 'از ۳ خط انتخاب شده',
        compareTitle: 'مقایسه خطوط انتخاب‌شده',
        compareDescription: 'ویژگی‌ها و هزینه‌ها را کنار هم بررسی کنید.',
        selectAnother: 'یک خط دیگر انتخاب کنید تا مقایسه نمایش داده شود.',
        currencyUnit: 'ریال',
        noCost: 'بدون هزینه',
        bestPrice: 'مناسب‌ترین قیمت',
        numberIndex: 'گزینه {{index}}',
        removeFromCompare: 'حذف از مقایسه',
        threeYearCost: 'هزینه نگهداری (۳ سال)',
        limitReached: 'برای مقایسه فقط می‌توانید ۳ خط انتخاب کنید.',
        badges: {
          lucky: 'رند',
          semiRound: 'نیمه‌رند',
          link: 'لینک',
          receive: 'دریافت',
          golden: 'طلایی',
          nonLucky: 'غیررند',
          ordinary: 'عادی',
        },
      },
      privateNumbersStore: {
        title: 'فروشگاه شماره',
      },
      imagePicker: {
        title: 'انتخاب تصویر',
        uploadImage: 'بارگذاری تصویر',
        backToGallery: 'بازگشت به گالری',
        availableImages: 'تصاویر موجود',
        imageCount: '{{count}} تصویر در گالری',
        searchPlaceholder: 'جستجو در تصاویر ...',
        imageTitle: 'عنوان تصویر',
        uploadGuide:
          'ابتدا عنوان تصویر را وارد کنید، سپس یک فایل JPG، PNG یا WEBP تا حجم ۱۰ مگابایت انتخاب کنید.',
        titleRequired: 'وارد کردن عنوان تصویر الزامی است.',
        titleMaxLength: 'عنوان تصویر نمی‌تواند بیشتر از ۳۲ کاراکتر باشد.',
        loadError: 'دریافت تصاویر با خطا مواجه شد.',
        retry: 'تلاش مجدد',
        empty: 'تصویری یافت نشد.',
        dropTitle: 'فایل‌های خود را اینجا بکشید و رها کنید',
        dropDescription: 'یا با استفاده از دکمه زیر فایل را انتخاب کنید',
        chooseFiles: 'انتخاب فایل‌',
        allowedFormats: 'فرمت‌های مجاز:png , jpeg , svg , jpg',
        maxSize: 'حداکثر حجم هر فایل: ۱ مگابایت',
        invalidType: 'فقط فایل‌های JPG، PNG و WEBP قابل انتخاب هستند.',
        fileTooLarge: 'حجم فایل نباید بیشتر از ۱۰ مگابایت باشد.',
        uploadFailed: 'آپلود تصویر انجام نشد. دوباره تلاش کنید.',
        selectImage: 'انتخاب تصویر',
        previous: 'قبلی',
        next: 'بعدی',
      },
      fileAttachments: {
        title: 'کتابخانه تصاویر',
        searchPlaceholder: 'جستجو در تصاویر ...',
        fromDate: 'از تاریخ',
        toDate: 'تا تاریخ',
        gridView: 'نمای شبکه‌ای',
        listView: 'نمای لیستی',
        emptyTitle: 'تصویری یافت نشد',
        emptyDescription: 'فایل یا عبارت دیگری را جستجو کنید.',
        clearFilters: 'پاک کردن فیلتر',
        loadError: 'دریافت تصاویر با خطا مواجه شد.',
        retry: 'تلاش مجدد',
        loadingMore: 'در حال بارگذاری تصاویر بیشتر...',
        loadMoreError: 'بارگذاری تصاویر بیشتر انجام نشد.',
        scrollForMore: 'برای مشاهده تصاویر بیشتر به پایین اسکرول کنید',
        showing: 'نمایش {{from}} تا {{to}} از {{total}} مورد',
        itemsPerPage: 'تعداد در صفحه',
        previous: 'قبلی',
        next: 'بعدی',
        imageAlt: 'تصویر {{name}}',
        editTitle: 'ویرایش عنوان تصویر',
        imageTitle: 'عنوان تصویر',
        titleRequired: 'وارد کردن عنوان تصویر الزامی است.',
        titleMaxLength: 'عنوان تصویر نمی‌تواند بیشتر از ۳۲ کاراکتر باشد.',
        copyLink: 'کپی لینک',
        linkCopied: 'لینک تصویر کپی شد.',
        viewImage: 'مشاهده تصویر',
        addImage: 'افزودن تصویر',
      },
      authorizationUpgrade: {
        title: 'ارتقای سطح کاربری',
        eyebrow: 'احراز هویت و اعتبار حساب',
        currentLevel: 'سطح فعلی',
        currentLevelStatement: 'سطح فعلی شما',
        indicatorLabel: 'نمایشگر سطح احراز هویت',
        levelWizardTitle: 'مسیر سطح‌های احراز هویت',
        nextStepTitle: 'با رفتن به سطح بعد چه امکاناتی فعال می‌شود؟',
        upgradeAction: 'ارتقای سطح',
        upgradeActions: {
          0: 'ارتقا به سطح تایید شده',
          1: 'ارتقا به سطح معتبر',
          2: 'درخواست سطح ممتاز',
        },
        actions: {
          continue: 'ادامه',
          previous: 'مرحله قبل',
          tryAgain: 'تلاش دوباره',
          remove: 'حذف',
        },
        progressLabel: 'مراحل سطح احراز هویت',
        mobileProgress: { current: 'فعلی', next: 'بعدی' },
        levels: {
          0: 'پایه',
          1: 'تأییدشده',
          2: 'معتبر',
          3: 'ممتاز',
        },
        levelHints: {
          0: 'اطلاعات شخصی یا حقوقی را تکمیل کنید تا به سطح تایید شده برسید.',
          1: 'مدارک هویتی مورد نیاز را بارگذاری کنید تا به سطح معتبر برسید.',
          2: 'درخواست سازمانی را برای بررسی قراردادی و مالی ثبت کنید.',
          3: 'حساب شما به بالاترین سطح احراز هویت رسیده است.',
        },
        profileHints: {
          0: 'با تکمیل اطلاعات، خرید پلن و خدمات بیشتر را فعال کنید.',
          1: 'برای سطح بعد، مدارک هویتی خود را بارگذاری کنید.',
          2: 'امکان درخواست سطح سازمانی برای حساب شما فعال است.',
          3: 'همه قابلیت‌های احراز هویت برای شما فعال است.',
        },
        profileBenefits: {
          0: 'با تکمیل اطلاعات هویتی، خرید پلن و دسترسی به خدمات بیشتری از پنل برای شما فعال می‌شود.',
          1: 'با تایید مدارک، هویت حساب شما تکمیل و امکانات سطح معتبر فعال می‌شود.',
          2: 'پس از ثبت درخواست، پشتیبانی برای هماهنگی قراردادها، تضامین و امور مالی با شما تماس می‌گیرد.',
        },
        steps: {
          organizationType: 'نوع سازمان',
          additionalInformation: 'اطلاعات تکمیلی',
        },
        organizationType: {
          title: 'نوع سازمان خود را انتخاب کنید',
          real: 'سازمان حقیقی',
          realHint: 'برای فعالیت شخصی با هویت خودتان.',
          legal: 'سازمان حقوقی',
          legalHint: 'برای شرکت‌ها و سازمان‌های ثبت‌شده.',
          selected: 'نوع حساب انتخاب‌شده',
        },
        information: {
          title: 'اطلاعات مورد نیاز را تکمیل کنید',
          description:
            'اطلاعات را با دقت وارد کنید؛ این موارد در فرایند احراز هویت بررسی می‌شوند.',
          manager: 'مشخصات مدیر',
          organization: 'اطلاعات سازمان',
        },
        fields: {
          gender: 'جنسیت',
          identificationType: 'نوع مدرک شناسایی',
          identityNumber: 'شماره مدرک شناسایی',
          isForeigner: 'اتباع خارجی هستم',
          organizationForeigner: 'سازمان خارجی است',
          economicCode: 'کد اقتصادی',
          ceoName: 'نام و نام خانوادگی مدیر عامل',
          ceoMobile: 'تلفن همراه مدیر عامل',
          ceoNationalCode: 'کد ملی مدیر عامل',
        },
        gender: { man: 'مرد', woman: 'زن' },
        identification: {
          nationalCode: 'کد ملی',
          passport: 'گذرنامه',
          asylumCard: 'کارت پناهندگی',
          amayeshCard: 'کارت آمایش',
          identityProfile: 'شناسنامه هویتی',
        },
        submitInformation: 'ثبت اطلاعات',
        loadError: 'دریافت اطلاعات مورد نیاز انجام نشد. دوباره تلاش کنید.',
        digitalContract: {
          title: 'امضای قرارداد استفاده از خدمات',
          subtitle:
            'برای ثبت درخواست احراز هویت، ابتدا قوانین و شرایط استفاده از خدمات را مطالعه کنید و قرارداد را به‌صورت دیجیتال امضا نمایید.',
          steps: {
            terms: 'مطالعه قوانین',
            sign: 'امضای قرارداد',
          },
          acceptTerms: 'قبول قوانین و ادامه',
          otpTitle: 'کد تأیید امضای قرارداد',
          otpDescription:
            'کد تأییدی برای امضای قرارداد به شماره {{mobile}} ارسال شد.',
          otpHint:
            'با وارد کردن کد ۶ رقمی، قرارداد به‌صورت دیجیتال امضا و امضای شما در سامانه ثبت می‌شود.',
          resend: 'ارسال مجدد کد',
          signContract: 'امضا و ثبت قرارداد',
          backToTerms: 'بازگشت به قوانین',
          submitBeforeSign: 'امضای قرارداد و ثبت',
        },
        documents: {
          title: 'بارگذاری مدارک احراز هویت',
          description:
            'تصویری واضح و خوانا از مدارک بارگذاری کنید؛ بدون تاری، بریدگی و انعکاس نور.',
          required: 'مدرک مورد نیاز',
          empty: 'مدرکی برای بارگذاری در انتظار نیست.',
          defaultHint:
            'تصویری واضح که همه جزئیات مدرک را نشان دهد بارگذاری کنید.',
          choose: 'انتخاب فایل',
          noFile: 'فایلی انتخاب نشده است',
          selectFile: 'انتخاب فایل برای',
          formats: 'JPG یا PNG · حداکثر ۵ مگابایت',
          preview: 'مشاهده فایل',
          remaining: '{{count}} مدرک مورد نیاز هنوز فایل ندارد.',
          remainingReupload: '{{count}} مدرک نیاز به بارگذاری مجدد دارد.',
          remainingBoth:
            '{{count}} مدرک هنوز فایل ندارد و {{reuploadCount}} مدرک نیاز به بارگذاری مجدد دارد.',
          submit: 'ثبت مدارک',
          userGroupTitle: 'مدارک هویتی کاربر',
          userGroupDescription: 'مدارک مربوط به صاحب حساب و هویت فردی او.',
          organizationGroupTitle: 'مدارک سازمان',
          organizationGroupDescription: 'مدارک ثبتی و حقوقی مربوط به سازمان.',
          groupCount: 'مدرک',
          errors: {
            type: 'فقط فایل‌های JPG و PNG قابل قبول هستند.',
            size: 'حجم فایل باید حداکثر ۵ مگابایت باشد.',
          },
          user: {
            1: 'کارت ملی',
            2: 'شناسنامه',
            3: 'جواز کسب',
          },
          organization: {
            1: 'جواز کسب',
            2: 'آگهی تأسیس شرکت',
            3: 'آخرین آگهی تغییرات شرکت',
            4: 'کارت ملی مدیرعامل',
            5: 'شناسنامه مدیرعامل',
          },
        },
        documentStatus: {
          pending: 'در انتظار بررسی',
          accepted: 'تأیید شده',
          rejected: 'رد شده — ارسال مجدد',
          nothingUploaded: 'بارگذاری نشده',
        },
        enterprise: {
          title: 'درخواست سطح سازمانی',
          description:
            'پس از ثبت درخواست، تیم پشتیبانی برای هماهنگی قراردادها، تضامین و موارد مالی با شما تماس می‌گیرد.',
          steps: {
            1: 'ثبت درخواست شما',
            2: 'بررسی پشتیبانی و حقوقی',
            3: 'تأیید قرارداد و ارتقای سطح',
          },
          submit: 'ثبت درخواست سازمانی',
          confirmTitle: 'درخواست سطح سازمانی',
          confirmContent:
            'اطمینان دارید که می‌خواهید حساب خود را به سطح سازمانی ارتقا دهید؟ پس از ثبت درخواست، تیم پشتیبانی برای هماهنگی قراردادها و امور مالی با شما تماس می‌گیرد.',
          pendingTitle: 'درخواست شما ثبت شد',
          pendingDescription:
            'تیم پشتیبانی آن را بررسی کرده و با شما تماس می‌گیرد؛ نیازی به ثبت دوباره نیست.',
          requestSubmittedTitle: 'درخواست شما با موفقیت ثبت شد',
          requestSubmittedMessage:
            'پس از تایید اطلاعات و ارتقای سطح شما، برای ادامه استفاده از پنل لازم است پلن مناسب تهیه کنید.',
        },
        completed: {
          title: 'سطح سازمانی فعال است',
          description:
            'شما به بالاترین سطح احراز هویت رسیده‌اید و ارتقای دیگری نیاز نیست.',
        },
        planGuard: {
          title: 'ارتقای سطح احراز هویت لازم است',
          description:
            'حداقل سطح مورد نیاز برای خرید یا ارتقای پلن، سطح ۳ (تایید مدارک) است. ابتدا سطح کاربری خود را ارتقا دهید.',
        },
      },
      authorizationReview: {
        action: 'بررسی و تایید احراز هویت',
        informationTitle: 'بررسی اطلاعات کاربر',
        documentsTitle: 'بررسی مدارک کاربر',
        eyebrow: 'پرونده تایید سطح کاربری',
        informationHeading: 'بررسی اطلاعات تکمیلی',
        documentsHeading: 'بررسی مدارک بارگذاری‌شده',
        informationDescription:
          'پیش از تایید سطح بعد، اطلاعات هویتی و سازمانی ثبت‌شده را با دقت بررسی کنید.',
        documentsDescription:
          'پیش از تایید سطح بعد، مدارک کاربر و سازمان را به تفکیک بررسی کنید. اگر مدرکی مورد تایید نیست، فقط وضعیت همان مدرک را تغییر دهید تا با ثبت وضعیت، مشکل برای کاربر اعلام شود.',
        userId: 'شناسه کاربر',
        userName: 'نام کاربری',
        personalInformation: 'اطلاعات فردی',
        personalInformationHint: 'مشخصات هویتی و ارتباطی ثبت‌شده توسط کاربر.',
        organizationInformation: 'اطلاعات سازمان',
        organizationInformationHint: 'مشخصات ثبتی و ارتباطی سازمان حقوقی.',
        userDocuments: 'مدارک کاربر',
        userDocumentsHint: 'مدارک هویتی متعلق به صاحب حساب کاربری.',
        organizationDocuments: 'مدارک سازمان',
        organizationDocumentsHint: 'مدارک ثبتی و حقوقی متعلق به سازمان.',
        emptyInformation:
          'اطلاعات تکمیلی ثبت‌شده‌ای برای این کاربر دریافت نشد.',
        emptyDocuments: 'مدرک بارگذاری‌شده‌ای برای این کاربر دریافت نشد.',
        loadError: 'دریافت درخواست احراز هویت با خطا مواجه شد.',
        confirmHint:
          'تنها پس از بررسی کامل اطلاعات و مدارک، درخواست را تایید کنید.',
        confirmDocumentsHint:
          'در صورت مورد تایید بودن تمامی مدارک، احراز هویت کاربر را انجام دهید.',
        statusSelect: 'وضعیت مدرک',
        documentDescription: 'توضیحات',
        documentDescriptionPlaceholder: 'توضیح یا دلیل مربوط به این مدرک...',
        openPdf: 'مشاهده فایل PDF',
        fields: { gender: 'جنسیت' },
        values: { yes: 'بله', no: 'خیر' },
        actions: {
          confirm: 'تایید و ارتقای کاربر',
          saveStatus: 'ثبت وضعیت',
          confirmAndUpgrade: 'تایید و احراز هویت',
          view: 'مشاهده مدرک',
        },
        confirmDialog: {
          title: 'تایید درخواست احراز هویت',
          information:
            'آیا از صحت اطلاعات ثبت‌شده کاربر و تایید آن اطمینان دارید؟',
          documents:
            'آیا از صحت مدارک بارگذاری‌شده و تایید آن‌ها اطمینان دارید؟',
          confirmDocuments:
            'آیا از اهراز هویت و ارتقای سطح این کاربر اطمینان دارید؟',
          verifyDocuments:
            'آیا از مورد تایید بودن تمامی مدارک کاربر اطمینان دارید؟ پس از ثبت، کاربر احراز هویت می‌شود.',
        },
      },
      enterpriseRequests: {
        title: 'درخواست‌های سازمانی',
        confirm: 'تایید درخواست سازمانی',
        reject: 'لغو درخواست سازمانی',
        fields: {
          organizationId: 'شناسه سازمان',
          status: 'وضعیت',
          confirmedByUserName: 'تاییدکننده',
          confirmTime: 'زمان تایید',
          rejectedUserName: 'لغوکننده',
          rejectTime: 'زمان لغو',
          rejectionReason: 'دلیل لغو',
        },
      },
      dashboard: {
        dailyCountChart: {
          title: 'آمار ده روز اخیر',
          subTitle:
            'نمودار زیر تعداد پیام های ارسال شده ده روز گذشته را نمایش می‌دهد.',
        },
        dailyTypeChart: {
          title: 'آمار ده روز اخیر به تفکیک نوع پیام',
          subTitle:
            'نمودار زیر تعداد پیام های ارسال شده ده روز گذشته به تفکیک نوع پیام را نمایش می‌دهد.',
        },
        irancellDashboard: {
          theLastCampaignsRun: 'آخرین کمپین های اجرا شده',
          runningCampaigns: 'کمپین های در حال اجرا ',
          theLastTransactionOfTheOrganization: 'آخرین تراکنش سازمان',
          lastTransaction: 'آخرین تراکنش',
          lastPayment: 'آخرین پرداخت',
        },
        latestInformations: {
          latestNews: 'آخرین اخبار',
        },
        percentChart: {
          sentMessages: 'پیامک های ارسال شده ده روز اخیر',
          sentMessagesWithPercent:
            'نمودار زیر درصد پیامک های ارسال شده ده روز اخیر را بر اساس نوع ارسال نمایش می دهد.',
          SentMessagesPercent: 'درصد پیامک های ارسال شده امروز',
          sent: 'ارسال شده',
          notSent: 'ارسال نشده',
          all: 'تعداد کل',
          sendType: 'نوع ارسال',
          sentPercent: 'درصد ارسال شده',
        },
        systemStatistics: {
          organizationInformations: 'اطلاعات سازمان',
          balance: 'موجودی حساب',
          lastloginTime: 'زمان آخرین ورود',
          lastloginIP: 'IP آخرین ورود',
        },
        todayStatistics: {
          sentSmsStatisticsWithType:
            'آمار زیر تعداد پیامک های ارسال شده ده روز اخیر بر اساس نوع ارسال را نمایش می‌دهد.',
          sentMessages: 'پیامک های ارسال شده ده روز اخیر',
        },
      },
      shared: {
        helpPage: {
          menuGuide: 'راهنمای منو',
        },
        editSendReceiversDeliveryStatus: {
          clickHereToGetASampleFile:
            'جهت دریافت نمونه فایل <a class="font-bold cursor-pointer" href="/assets/media/sample/sample.xlsx"download="sampleMobiles.xlsx" id="linkIdSampleMobiles">اینجا</a>کلیک کنید.',
        },
        outboxMessagesDetail: {},
        outboxMessagesSendBulkDetail: {},
      },
      infrastructure: {
        setting: {
          settingForm: {
            ifNumberIsNotServiceSmsWillNotBeSentToBlackList:
              'در صورتی که خط انتخابی خدماتی نباشد، <br /> پیامک برای شماره تلفن هایی که در لیست سیاه هستند ارسال نمی شود.',
          },
        },
        privateNumbers: {
          privateNumbersForm: {
            oneOfTheNumbers1To9: 'یکی از اعداد 1 تا 9',
            twoTo11Times0To9: '2 تا 11 مرتبه 0 تا 9',
            threeTo11Times0To9: '3 تا 11 مرتبه 0 تا 9',
            maximum9Times: 'حداکثر 9 مرتبه ؟',
          },
        },
        menus: {
          menusForm: {
            downloadVideo:
              '<a target="_blank" href="{{fileUrl}}">دانلود ویدیو</a>',
            downloadPDF:
              '<a target="_blank" href="{{fileUrl}}">دانلود پی دی اف</a>',
            downloadFile:
              '<a target="_blank" href="{{fileUrl}}">دانلود فایل</a>',
          },
        },
      },
      ds: { title: 'دیزاین سیستم' },
      facility: {
        phonebook: {
          fromIndex: '<b>از اندیس</b> نباید از<b>تعداد مخاطبین</b> بیشتر باشد.',
          count: '<b>تعداد </b>نباید از <b>تعداد مخاطبین</b> بیشتر باشد.',
          both: 'اندیس گزاری اشتباه است',
        },
      },
      sendingSystem: {
        fastSendSmsPatternByPhonebook: {
          youAreOnlyAbleToSelectTheSMSTemplateAndYouCannotChangeTheTextOfTheMessage:
            ' شما فقط قادر به انتخاب الگوی پیامک هستید و نمی توانید متن پیام را دستی تغییر دهید .',
          toSetTheSMSTextClickOnTheSMSTemplateButtonThenChooseYourSMStemplate:
            'برای تنظیم متن پیامک روی کلید <b class="text-primary"> الگوی پیامک </b><i class="mdi mdi-text-box-plus-outline text-primary mx-1 mdi-20px"></i> کلیک کنید سپس الگوی پیامک خود را <b class="!text-violet-600 font-semibold"> انتخاب </b> کنید.',
        },
        sendBulkSms: {
          chooseAreaAndSetFilters:
            'در ابتدا می بایست در قسمت <b class="text-foreground font-black"> محدوده ارسال </b> انتخاب نمایید می خواهید به کدام مناطق و با چه فیلترهایی پیامک ارسال نمایید. توجه داشته باشید حداقل باید یک استان و نوع سیم کارت هایی که قرار است پیامک به آنها ارسال شود را مشخص نمایید.',
          calculateNumbers:
            'پس از تنظیم فیلترهای مورد نیاز خود از قسمت <b class="text-foreground font-black"> مشخصات ارسال </b> یکبار بر روی کلید <b class="app-badge bg-success    !text-white rounded-[3px]">محاسبه تعداد شماره <i class="mdi mdi-calculator mdi-18px text-white"> </i> </b> کلیک نمایید.',
          chooseNumbersCount:
            'سپس از قسمت <b class="text-foreground font-black"> مشخصات ارسال </b> مشخص نمایید می خواهید از ردیف چندم به چه تعداد شماره ارسال انجام گیرد.',
          addAreaToList:
            'در مرحله آخر منطقه و فیلترهای مورد نظر شما با کلیک بر روی کلید <b class="app-badge bg-primary  rounded-[3px] !text-white "> افزودن <i class="mdi mdi-plus-thick mdi-18px text-white "></i> </b> به لیست پایانی اضافه می شود. شما می توانید این کار را برای چندین منطقه انجام دهید.',
          clickOnNext:
            'در نهایت با کلیک بر روی دکمه <b class="text-foreground font-black"> مرحله بعد </b> به تنظیم پیامک و نحوه ارسال آن منتقل خواهید شد.',
          models: {},
        },
        sendP2PSms: {
          createExcel:
            ' با استفاده از این سرویس می‌توانید متن پیامک‌های ارسالی را برای هر شماره موبایل به‌صورت شخصی‌سازی‌شده تنظیم کنید. برای این کار کافی است یک فایل اکسل ایجاد کرده و ستون‌های موردنظر خود را در آن وارد نمایید.فایل اکسل می‌تواند شامل ستون‌های متنوعی باشد و شما قادر خواهید بود متن پیامک را بر اساس محتوای هر ستون تنظیم کنید. توجه داشته باشید که سطر اول فایل اکسل خوانده نمی‌شود؛ بنابراین می‌توانید از آن برای درج عنوان ستون‌ها استفاده کنید.',
          tipsForExcelTable:
            ' نکته مهم: عنوان ستون‌ها باید از نوع Text بوده، با حروف انگلیسی نوشته شوند و فاقد فاصله باشند.',
          sendWithDuplicateNumbersMsg:
            ' با انتخاب این گزینه شماره های تکراری موجود در فایل اکسل انتخابی حذف نمی گردد. قبل از استفاده از این گزینه اطمینان حاصل نمایید که به ازای گیرندگان ثابت قرار است متن متفاوتی ارسال نمایید.',
          tipsForSendHours:
            'توجه داشته باشید،به دلیل زمان‌ بر بودن ایجاد لینک ها، ساعت پیش‌ فرض ۱۰ دقیقه جلوتر در نظر گرفته شده است.',
          tipsForPrivateNumbers:
            'امکان ارسال با خطوط غیر خدماتی، برای این نوع ارسال وجود ندارد.',
          linkFromExcel: {
            title: 'لینک کوتاه از فایل اکسل',
            description:
              'هر نفر لینک کوتاه اختصاصی خود را از ستون مربوطه در فایل اکسل دریافت می‌کند.',
          },
          linkGeneralNamed: {
            title: 'لینک کوتاه عمومی با نام دلخواه',
            description:
              'یک لینک وارد می‌کنید، سیستم برای هر نفر نسخه کوتاه‌شده تولید می‌کند و نامی برای جایگذاری در متن پیام مشخص می‌شود.',
          },
          noLink: {
            title: 'بدون لینک کوتاه',
            description:
              'پیامک فقط شامل متن ساده است و هیچ لینک کوتاهی به آن اضافه نمی‌شود.',
          },
        },
        sendSmartSmsConfirmRequest: {},
        sendBalkSms: {
          yourSendingIsInUpdateStatus:
            'کاربر گرامی توجه داشته باشید ارسال شما متوقف شد و در وضعیت<b class="text-red-500 dark:text-red-400"> در حال بروزرسانی </b>قرار گرفت.جهت ادامه روند ارسال، انجام عملیات ویرایش الزامی می باشد.',
        },
        base: {
          baseSendSMS: {
            message:
              'کاربر گرامی توجه داشته باشید ارسال شما متوقف شد و در وضعیت<b class="text-red-500 dark:text-red-400"> در حال بروزرسانی </b>قرار گرفت. جهت ادامه روند ارسال، انجام عملیات ویرایش الزامی می باشد.',
          },
        },
        sendSmartSmsCreateRequest: {
          sendSmartSmsAdvanceSearch: {
            searchInPersonalPlaces: ' جستجو در مکان های شخصی',
            personal: 'شخصی',
            category: 'دسته بندی',
            publicSearch: 'جستجوی عمومی',
            public: 'عمومی',
            selectedListPublic: 'مکان های عمومی انتخاب شده',
            selectedListPersonal: 'مکان های شخصی انتخاب شده',
          },
        },
      },
      systemManagement: {
        organizations: {
          organizationDeleteConfirmDialog:
            'توجه داشته باشید تمامی کاربران سازمانی که حذف می گردد نیز حذف خواهد شد.',
          justDeleteOrgan: 'فقط حذف سازمان',
          deleteOrganAndSubsets: 'حذف سازمان و تمامی زیرمجموعه ها',
          organizationsAuthenticationForm: {
            maxSizeIs200kb:
              'حداکثر حجم هر فایل نباید از 200 کیلوبایت بیشتر باشد',
          },
        },
        users: {
          userForm: {
            changeNumber: 'تغییر شماره',
            changeNumberAndAuthenticate: 'تغییر شماره و احرازهویت',
            confirmed: 'تایید شده',
            notConfirmed: 'تایید نشده',
            userAuthMobile: {
              enterVerificationCode:
                'کد تایید ارسال شده به شماره موبایل<b class="text-blue-500 dark:text-blue-400">{{mobile}}</b>را وارد کنید .',
            },
          },
          userPersonalInfo: {
            userPersonalInfoForm: {
              editPersonalInfo: 'ویرایش اطلاعات شخصی',
              submitPersonalInfo: 'ثبت اطلاعات شخصی',
            },
          },
        },
      },
      register: {
        form: {
          fields: {
            isRealPerson: 'نوع ',
            workplaceTitle: 'عنوان محل کار',
            workplacePhone: 'تلفن محل کار',
            workplaceZipCode: 'کدپستی محل کار',
            workplaceAddress: 'آدرس محل کار',
            organName: ' نام سازمان',
            nationalId: 'شناسه ملی',
            economicCode: 'کد اقتصادی',
            ceoName: 'نام و نام خانوادگی مدیر عامل',
            ceoMobile: 'تلفن همراه مدیر عامل',
            ceoNationalCode: 'کد ملی مدیر عامل',
            isForeigner: 'اتباع خارجی',
          },
          legends: {
            organizationInfo: 'مشخصات سازمان {{type}}',
            UserInfo: 'مشخصات کاربری',
          },
          messages: {
            organizationDescription:
              'کاربر گرامی جهت تکمیل فرآیند ثبت نام لازم است مشخصات سازمان {{type}} خود را در فرم زیر وارد نمائید.',
            userDescription:
              'کاربر گرامی جهت نهایی کردن فرآیند ثبت نام لازم است مشخصات کاربری  خود را در فرم زیر وارد نمایید.',
            userNameNotEditable:
              'نام کاربری فعلی بر اساس کد ملی ثبت‌شده در مرحله قبل پر شده است . توجه داشته باشید نام کاربری پس از تکمیل ثبت‌نام غیرقابل تغییر است.',
          },
        },
      },
      blackList: {
        title: 'لیست سیاه',
        form: {
          addTitle: 'افزودن به لیست سیاه',
        },
      },
      sensitiveWords: {
        title: 'کلمات حساس',
        form: {
          addTitle: 'افزودن کلمات حساس',
          editTitle: 'ویرایش کلمات حساس',
        },
      },
      organizationNotificationSettingKeyManagements: {
        title: 'تنظیمات مدیریتی اعلان های سازمان ها',
      },
      userNotificationSettingKeyManagements: {
        title: 'تنظیمات مدیریتی اعلان های کاربران',
      },
      customerDomains: {
        title: 'دامنه های مشتری',
        domainConfigurations: 'تنظیمات دامنه',
        form: {
          addTitle: 'دامنه جدید',
          editTitle: 'ویرایش دامنه',
        },
        detailForm: {
          legend: 'جزئیات دامنه',
        },
      },
      organizationUssdCodesStatistics: {
        title: 'آمار کدهای USSD سازمان',
      },
      ussdCodeStatistics: {
        title: 'آمار کد USSD',
      },
      smsSenderAgents: {
        title: 'عامل ارسال پیامک',
        form: {
          addTitle: 'عامل ارسال پیامک جدید',
          editTitle: 'ویرایش عامل ارسال پیامک',
          fields: {
            defaultNumber: 'شماره پیش فرض',
            type: 'نوع اپراتور ارسال کننده',
            smsSenderAgentReference: 'عامل ارسال پیامک',
            startTime: 'زمان شروع ارسال',
            endTime: 'زمان پایان ارسال',
            sendSmsAlert: 'ارسال هشدار پیامک',
            isSendActive: 'فعال بودن ارسال',
            isReceiveActive: 'فعال بودن دریافت',
            isSendBulkActive: 'فعال بودن ارسال انبوه',
            sendBulkIsAutomatic: 'ارسال انبوه بصورت خودکار',
            checkMessageId: 'چک کردن شناسه پیام',
            isSendSmartActive: 'وضعیت ارسال مکان محور',
            isActiveAllTime: 'در نظر نگرفتن زمان شروع و پایان',
            sendLink: 'لینک ارسال',
            receiveLink: 'لینک دریافت',
            deliveryLink: 'لینک دلیوری',
            domain: 'دامنه/نام شرکت',
            internalCredit: 'اعتبار داخلی',
            externalCredit: 'اعتبار خارجی',
            queueLength: 'طول صف',
            routeActive: 'وضعیت Route',
            isP2p: 'وضعیت ارسال نظیر به نظیر',
            isSmpp: 'وضعیت Smpp',
            isBts: 'وضعیت Bts',
            udhLen: 'وضعیت طول جدا کننده کاراکتر فارسی',
            receiveInboxType: 'نوع دریافت صندوق',
          },
          legends: {
            accessInformation: 'اطلاعات دسترسی',
            generalInformation: 'اطلاعات عمومی',
            socialMediaSmartDetailsMci:
              'جزئیات ارسال مکان محور شبکه اجتماعی همراه اول',
            socialMediaSmartDetailsMtn:
              'جزئیات ارسال مکان محور شبکه اجتماعی ایرانسل ',
            socialMediaSmartDetailsRightel:
              'جزئیات ارسال مکان محور شبکه اجتماعی رایتل ',
          },
        },
      },
      privateNumbers: {
        title: 'شماره اختصاصی',
        addBtns: {
          addSingle: 'افزودن تکی',
          createByRange: 'افزودن به صورت رنجی',
        },
        form: {
          addTitle: 'افزودن خطوط اختصاصی',
          editTitle: 'ویرایش خطوط اختصاصی',
          fields: {
            id: 'شناسه خط',
            priority: 'اولویت ارسال',
            sendToBlackList: 'خط خدماتی',
            deliveryBase: 'کسر هزینه برپایه دلیوری',
            checkFilter: 'بررسی فیلتر پیامک',
            deliveryLevel1: 'کسر هزینه بر پایه دلیوری سطح 1 ',
            deliveryLevel2: 'کسر هزینه بر پایه دلیوری سطح 2 ',
            isAutomaticBulk: 'ارسال اتوماتیک انبوه (فقط صف)',
            confirmP2pAndDynamic: 'ارسال اتوماتیک پویا و نظیر به نظیر',
            isAutomaticGroup: 'ارسال اتوماتیک گروهی',
            isSendBulk: 'ارسال انبوه (آپدیت شماره)',
            isSendGender: 'ارسال جنسیت',
            isSendGroup: 'ارسال گروهی',
            isSendPhonebook: 'ارسال دفترچه تلفن',
            isSendBulk2: 'ارسال انبوه ',
            isSendApiP2P: 'ارسال وب سرویس نظیر به نظیر',
            isSendDynamic: 'ارسال پویا',
            isSendOtp: 'ارسال otp',
            isSendP2P: 'ارسال نظیر به نظیر',
            isSendClub: 'ارسال باشگاه مشتریان',
            isPublic: 'خط عمومی',
            isSendApiSingle: 'ارسال وب سرویس تکی',
            isGeneralBlackList: 'لیست سیاه عمومی',
            isSendSingle: 'ارسال تکی',
            hasSla: 'SLA',
            smsSenderAgentId: 'عامل ارسال ',
            smsSenderAgentName: 'نام عامل ارسال ',
            useForm: 'استفاده بصورت',
            mask: 'نام تجاری',
            range: 'بازه',
            tryCount: 'تعداد سعی مجدد',
            expireTime: 'ساعت انقضا',
            isSendDevice: 'ارسال دستگاه',
            isSendSmart: 'ارسال مکان محور',
            isNeedToSendConfirmationMessage: 'نیاز به ارسال پیام تایید',
            isSendPrivateNumberExpirationMessage:
              'ارسال پیام انقضای شماره اختصاصی',
            refundDeliveryStatusId: 'وضعیت بازگشت هزینه',
            isCanSendFlashSms: 'ارسال فلش',
            tag: 'برچسب',
            isCanSendSmartWithoutConfirmation:
              'امکان ارسال مکان محور بدون تایید',
            isSendOccasionPhonebook: 'ارسال مناسبتی دفترتلفن',
            numberStartOfRange: ' شروع بازه',
            numberEndOfRange: ' پایان بازه',
            baleBenefitPercent: 'درصد افزایش تعرفه بله',
            baleBotType: 'نوع بازوی بله',
          },
          legends: {
            generalSettings: 'تنظیمات کلی',
            messageSenderInformation: 'مشخصات خط',
            bulkSend: 'ارسال انبوه',
            webServiceSend: 'ارسال وب سرویس',
            toNumberSend: 'ارسال به شماره',
          },
        },
      },
      bulkNumberInformation: {
        name: 'لیست شماره های انبوه(شماره آپدیت)',
        name2: 'لیست شماره های انبوه',
        title: 'لیست شماره های انبوه(شماره آپدیت)',
        title2: 'لیست شماره های انبوه',
        importfromfile: {
          title: 'افزودن از فایل',
          fields: {
            selectfile: 'انتخاب فایل',
            empty: 'خالی',
            cellPhone: 'شماره همراه',
            zipCode: 'کدپستی',
            areaName: 'کشور',
            cityName: 'شهر',
            stateName: 'استان',
            genderType: 'جنسیت',
            guildName: 'گروه مشاغل',
            subGuildName: 'زیرگروه مشاغل',
            isBlackList: 'لیست سیاه',
            isBlackListLocal: 'لیست سیاه محلی',
            mobileOperator: 'اپراتور همراه',
            simType: 'نوع سیمکارت',
          },
        },
        deleteFromFile: {
          title: 'حذف با فایل',
          fields: {
            selectfile: 'انتخاب فایل',
            empty: 'خالی',
            cellPhone: 'شماره همراه',
          },
        },
        deleteBtns: {
          deleteMultiple: 'حذف چندتایی',
          deleteFromFile: 'حذف با فایل',
        },
        addBtns: {
          addSingle: 'افزودن تکی',
          addFromFile: 'افزودن از فایل اکسل',
        },
        form: {
          addTitle: 'افزودن شماره',
          legend: 'اطلاعات',
          fields: {
            id: 'شناسه ',
            genderType: ' جنسیت',
            areaName: 'کشور',
            cityName: 'شهر',
            isBlackList: 'لیست سیاه',
            isBlackListLocal: 'لیست سیاه محلی',
            mobile12: 'شماره همراه',
            mobileOperator: 'اپراتور همراه',
            stateName: 'استان',
            guildName: 'گروه مشاغل',
            subGuildName: 'زیرگروه مشاغل',
            simType: 'نوع سیم کارت',
            zipCode: 'کدپستی',
          },
          legends: {
            generalSettings: ' لیست شماره های انبوه',
            generalSettings2: 'لیست شماره های انبوه دو',
          },
        },
      },
      sendSmartDetailsByDelivery: {
        title: 'جزییات وضعیت ارسال مکان محور',
      },
      chatBotHistories: {
        title: 'تاریخچه دستیار هوشمند',
      },
      organizations: {
        title: 'لیست سازمانها',
        authenticatedMobile: 'تایید شماره موبایل',
        organizationsExcel: 'دانلود فایل اکسل سازمان ها',
        form: {
          addTitle: 'سازمان جدید',
          editTitle: 'ویرایش سازمان',
          fields: {
            isRealPerson: 'نوع ',
            name: 'نام و نام خانوادگی',
            workplaceTitle: 'عنوان محل کار',
            workplacePhone: 'تلفن محل کار',
            workplaceZipCode: 'کدپستی محل کار',
            workplaceAddress: 'آدرس محل کار',
            organName: ' نام سازمان',
            nationalId: 'شناسه ملی',
            economicCode: 'کد اقتصادی',
            ceoFullName: 'نام ونام خانوادگی مدیر عامل',
            ceoMobile: 'تلفن همراه مدیر عامل',
            ceoNationalCode: 'کد ملی مدیر عامل',
            maximumUser: 'حداکثر کاربر',
            maxOrganization: 'حداکثر سازمان',
            maxCustomFiled: 'حداکثر فیلد سفارشی',
            maxPhonebook: 'حداکثر دفترچه تلفن',
            parentId: 'والد',
            adminUserId: 'مدیر پنل',
            resellerId: 'فروشنده',
            panelPrice: 'قیمت پنل',
            groupPriceTitle: 'تعرفه',
            blackSenderPrivateNumberId: 'فرستنده لیست سیاه',
            maximumPhoneNumber: 'حداکثر شماره تلفن',
            domainId: 'دامنه مشتری',
            sendStartTime: 'زمان شروع ارسال',
            sendEndTime: 'زمان پایان ارسال',
            expireTime: 'ساعت انقضا',
            isShowGeneralNumbers: 'نمایش شماره عمومی برای کاربران',
            isForeigner: 'اتباع خارجی',
            isActiveSend: 'ارسال فعال',
            isConfirmMessage: 'تایید پیام',
            isActiveAllTime: 'در نظر نگرفتن زمان شروع و پایان ارسال',
            isHaveBlackListDeliveryProcess:
              'پردازش لیست سیاه بر اساس وضعیت تحویل',
            isAllowLink: ' ارسال لینک',
            isTax: 'مالیات',
            isAuthenticated: 'احراز هویت',
            isShowGeneralAccount: 'نمایش درگاه عمومی برای کاربران',
            organizationDocuments: 'نوع سند',
            defineNewUser: 'تعریف کاربر جدید',
            isCanSeePublicParentPhonebook: 'نمایش دفترتلفن های عمومی والد',
            isSendAlertToOrganizationAdmin: 'ارسال هشدار برای مدیر سازمان',
            isSendAlertForCreateSmartSmsRequest:
              'ارسال هشدار برای ایجاد درخواست پیامک مکان محور',
            isSendOrganizationExpirationAlertMessage:
              'ارسال پیام هشدار انقضای سازمان',
            isSendAlertForCreateOnlinePayment:
              'ارسال هشدار برای ایجاد پرداخت آنلاین',
            isSendAlertForCreatePayment: 'ارسال هشدار برای ایجاد پرداخت',
            isPostpaid: 'پس پرداخت',
            allowToDecreaseFromUserCreditWhenSmsPackageFinished:
              'کسر از اعتبار پس از اتمام بسته',
            isCanSendExtraReceivers: 'امکان ارسال به گیرندگان اضافی',
            isCanSetMultipleMobileForUser:
              'امکان تعریف چند شماره موبایل برای کاربر',
            enableSystemDefaultTag: 'فعال بودن تگ پیش فرض',
            enableMessageWaitForOrganizationConfirmation:
              'اجباری بودن تایید پیام توسط سازمان',
            enableSmartSmsFailureAlert:
              'فعال کردن هشدار درخواست های مکان محور ناموفق',
          },
          legends: {
            generalInformation: 'اطلاعات عمومی',
            systemInformation: 'اطلاعات سیستمی',
            organizationAdminUser: 'مدیر پنل',
          },
        },
        organizationAuthentication: {
          title: 'احراز هویت سازمان ',
          form: {
            addTitle: ' فرم احراز هویت سازمان',
            legend: 'احراز هویت سازمان',
            fields: {
              organizationDocuments: 'نوع سند ',
              documentStatus: 'وضعیت سند ',
              image: 'تصویر سند',
              description: 'توضیحات',
              BusinessLicense: 'تصویر مجوز کسب و کار',
              FoundedAnnounce: 'تصویر اطلاعیه ی تاسیس',
              LatestChangesAnnounce: 'تصویر اعلام آخرین تغییرات',
              CeoNationalCard: 'تصویر کارت ملی مدیرعامل',
              CeoBirthCertificate: 'تصویر شناسنامه مدیر عامل',
              OptionalField1: 'تصویر فیلد دلخواه 1',
              OptionalField2: 'تصویر فیلد دلخواه 2',
            },
          },
        },
        organizationDocumentation: {
          title: 'مدارک سازمان',
          form: {
            addTitle: 'تایید احراز هویت',
            legend: 'فرم تایید احراز هویت',
            fields: {
              isAuthenticated: 'تایید احراز هویت ',
              organizationDocuments: 'نوع سند',
              description: 'توضیحات',
              status: 'وضعیت',
              documentStatus: 'وضعیت فایل',
              organizationDocument: 'نوع فایل',
            },
          },
        },
        organizationResellers: {
          title: 'فروشندگان سازمان',
        },
        deleteOrganization: 'حذف سازمان',
        deleteOrganizationWihDescendantList: 'حذف سازمان و تمامی زیر مجموعه ها',
      },
      organizationCustomFields: {
        title: 'فیلدهای سفارشی',
        form: {
          addTitle: 'فیلد جدید',
          editTitle: 'ویرایش فیلد',
          legend: 'اطلاعات فیلد',
          fields: {
            CustomFieldTypes: 'نوع ',
            nameEn: 'نام انگلیسی ',
            nameFa: 'نام فارسی ',
          },
        },
      },
      userOrganizationalInfo: {
        name: 'لیست کاربران',
        title: 'لیست کاربران',
        increaseUserCreditTitle: 'افزایش اعتبار کاربر',
        decreaseUserCreditTitle: 'کاهش اعتبار کاربر',
        usersExcel: 'دانلود فایل اکسل کاربران',
        addBtns: {
          addSingle: 'افزودن تکی',
          addFromFile: 'افزودن از فایل اکسل',
        },
        importfromfile: {
          title: 'افزودن از فایل',
          downloadSample: 'دانلود فایل نمونه',
          uploadAddDescription:
            '<p class="mt-3 mb-1">⁃فایل هایی با پسوند <b>{{fileType}}</b> مجاز به آپلود می باشند.</p><p class="my-1">⁃دقت بفرمایید که سطر اول فایل اکسل خوانده نمی شود بنابراین می بایست از آن برای درج عنوان استفاده کنید.</p><p class="my-1">⁃جهت دریافت نمونه فایل <a class="font-bold cursor-pointer text-blue-500 dark:text-blue-400" href="/assets/media/sample/importUsers.xlsx"download="sampleUsers.xlsx" id="linkIdSampleUsers"> اینجا </a>کلیک کنید.</p><p class="mt-3 mb-1">⁃در صورتی که سازمانی انتخاب نشود، سازمان فعلی به عنوان سازمان کاربران در نظر گرفته می‌شود.</p> <p class="my-1 font-medium">⁃دقت فرمایید در فایل اکسل، برای کاربر در<b class="text-red-500 dark:text-red-400"> سطر اول</b>، اطلاعات فیلدهای اختیاری را با اطلاعات مورد نیاز و یا خط تیره(-) پر کنید.</p>',
          fields: {
            selectfile: 'انتخاب فایل',
            empty: 'خالی',
            userName: 'نام کاربری',
            nationalCode: 'کدملی/شناسه اتباع',
            identityNumber: 'شماره شناسنامه',
            firstName: 'نام',
            lastName: 'نام خانوادگی',
            fatherName: 'نام پدر',
            email: 'ایمیل',
            password: 'کلمه عبور',
            isForeigner: 'اتباع خارجی',
            zipCode: 'کدپستی',
            phone: 'تلفن ثابت',
            mobile: 'شماره موبایل',
            faxNumber: 'شماره فکس',
            address: 'آدرس',
            zoneId: 'شهر',
            birthDate: 'تاریخ تولد',
            expireDate: 'تاریخ انقضا',
            isActiveSend: 'ارسال فعال',
            descriptions: 'توضیحات',
            isDefault: 'پیش فرض',
            roleTemplateId: 'قالب نقش',
            isActive: 'فعال',
          },
        },
        form: {
          addTitle: ' کاربر جدید',
          editTitle: 'ویرایش اطلاعات کاربر',
          fields: {
            foreignerCode: 'کد اتباع',
            zoneId: 'منطقه',
            password: 'کلمه عبور',
            secondPassword: 'کلمه عبور دوم',
            isAdmin: 'مدیر',
            isAuthenticatedMobile: 'تایید موبایل',
            isNeedAuthorizationCheck: 'نیاز به احراز هویت',
            roleTemplateId: 'قالب نقش',
            nationalCode: 'کدملی/کداتباع',
            isSendSmsDescriptionRequired:
              'اجباری بودن توضیحات موقع ارسال کاربران',
            isCanSeeContactsOfPublicPhonebooks:
              'نمایش شماره گروه دفترتلفن عمومی',
            isCanSeeContactsOfPrivatePhonebooks:
              'نمایش شماره گروه دفترتلفن خصوصی',
            isCanSendSmartWithoutConfirmation:
              'امکان ارسال مکان محور بدون تایید',
            mobileCount: 'تعداد موبایل',
          },
          legends: {
            personalInformation: 'مشخصات کاربری',
            systemInformation: 'مشخصات سیستمی',
            authentication: 'احراز هویت ',
            roleInformation: 'نقش ها',
          },
        },
        userInfo: {
          title: 'احرازهویت کاربران',
          userAuthentication: {
            title: 'احراز هویت کاربران ',
            form: {
              addTitle: 'فرم احراز هویت کاربر ',
              legend: ' احراز هویت کاربر',
              fields: {
                BirthCertificate: 'شناسنامه',
                NationalCard: 'کارت ملی',
                OptionalField1: 'فیلد دلخواه 1',
                OptionalField2: 'فیلد دلخواه 2',
                documentStatus: 'وضعیت سند ',
                description: 'توضیحات',
              },
            },
          },
          userDocumentation: {
            title: 'مدارک کاربر',
            form: {
              addTitle: ' تایید احراز هویت ',
              legend: ' فرم تایید احراز هویت',
              fields: {
                isAuthenticated: 'تایید احراز هویت ',
                userDocuments: 'نوع سند',
                description: 'توضیحات',
                status: 'وضعیت',
                documentStatus: 'وضعیت فایل',
              },
            },
          },
        },
        personalInfo: {
          name: 'پروفایل کاربری',
          title: 'پروفایل کاربری',
          editTitle: 'ویرایش اطلاعات شخصی',
          organizationalInfo: 'اطلاعات سازمانی',
          personalInfo: 'اطلاعات شخصی',
          foreigner: 'اتباع خارجی',
          isForeigner: 'اتباع خارجی هستم ',
          foreignerCode: 'کد اتباع',
          firstAlert:
            'کاربر گرامی ، جهت ادامه فرآیند لازم است اطلاعات شخصی خود را تکمیل نمایید .',
          secondAlert:
            'اطلاعات شما با موفقیت ثبت شد .حداکثر تا 48 ساعت آینده نتیجه نهایی به شما اطلاع داده خواهد شد .',
        },
      },
      chatBot: {
        title: 'دستیار هوشمند',
        chatMessagesTitle: 'تاریخچهٔ پیام‌ها',
      },
      activeSessions: {
        title: 'نشست های فعال',
      },
      formBuilderResponses: {
        responsesExcel: 'اکسل پاسخ ها',
      },
      userImpersonated: {
        title: 'تاریخچه جعل هویت کاربر',
        form: {
          fields: {
            impersonatorUserName: 'کاربر جعل هویت کننده',
            impersonatorOrganizationName: 'سازمان کاربر جعل هویت کننده',
            impersonatedUserName: 'کاربر جعل هویت شده',
            impersonatedOrganizationName: 'سازمان جعل هویت شده',
          },
        },
      },
      valueOfPurchases: {
        title: 'آمار RFM',
        resellerTitle: 'آمار RFM فروشندگان',
        form: {
          fields: {
            totalPoint: 'مجموع امتیاز',
            points: 'امتیازات',
            totalUsedCredit: 'ارزش خرید',
            realUsedCredit: 'ارزش خرید واقعی',
            totalSentCount: 'تعداد ارسال',
            realSentCount: 'تعداد ارسال واقعی',
            totalSentParts: 'تعداد بخش',
            realSentParts: 'تعداد بخش واقعی',
            sendSmsFrequency: 'تناوب ارسال',
            isRecentSendSmsDifferenceTillNowMoreThanFrequency:
              'اختلاف آخرین ارسال بیشتر از تناوب',
            recentSendSms: 'تاریخ و زمان آخرین ارسال',
            recentSendDifferenceWithFrequencyStatus:
              'وضعیت آخرین ارسال نسبت به تناوب',
            usedCreditPerEachFrequency: 'ارزش خرید به ازای هر تناوب',
          },
        },
      },
      userValueOfPurchasePoints: {
        title: ' استراتژی های آمار RFM ',
        form: {
          legend: 'امتیاز',
          addTitle: 'امتیاز جدید',
          editTitle: 'ویرایش امتیاز',
          fields: {
            point: 'امتیاز',
            valueEndRange: 'مقدار پایان بازه',
            valueStartRange: 'مقدار شروع بازه',
            index: 'شاخص',
            range: 'بازه',
          },
        },
      },
      userValueOfPurchaseStrategies: {
        title: ' استراتژی های آمار RFM',
        form: {
          legend: 'استراتژی',
          addTitle: 'استراتژی جدید',
          editTitle: 'ویرایش استراتژی',
          fields: {
            point: 'امتیاز',
            valueEndRange: 'مقدار پایان بازه',
            valueStartRange: 'مقدار شروع بازه',
            index: 'شاخص',
            range: 'بازه',
          },
        },
      },
      userPoints: {
        title: 'امتیازات کاربران',
        form: {
          fields: {
            totalPoint: 'مجموع امتیاز',
            points: 'امتیازات',
          },
        },
      },
      alertSetting: {
        title: 'تنظیم اعلان',
        legend: 'تنظیمات',
        form: {
          fields: {
            isEnableSendNotification: 'ارسال اعلان فعال باشد؟',
            daysOfSendFrequencyPeriod: 'تعداد روزهای دوره',
            importanceLevel: 'سطح اهمیت اعلان ها',
            fromDaysMoreThanSendFrequently: 'از چند روز بیشتر از تناوب',
            toDaysMoreThanSendFrequently: 'تا چند روز بیشتر از تناوب ',
          },
        },
      },
      financial: {
        newPayment: {
          invoice: {
            sellerSpecifications: 'مشخصات فروشنده',
            customerSpecifications: 'مشخصات خریدار',
            finalPayment: 'پرداخت نهایی',
            totalAmountRial: 'کل مبلغ (ريال)',
            realLegalPersonName: 'نام شخص حقیقی / حقوقی',
            valueAddedTaxRial: 'ارزش افزوده (ريال)',
            invoiceIssuance:
              'اعتبار این پیش فاکتور به مدت یک روز از تاریخ صدور می باشد',
            noLegalValue:
              'فاقد ارزش و اعتبار حقوقی جهت اعلام و درج در سایت های امور مالیاتی ، دارایی ، بیمه و ... می باشد',
            parliamentTax: 'بند ز مصوب مجلس (ريال)',
          },
        },
      },
      userPasswordHistory: {
        title: 'تاریخچه کلمه عبور کاربر',
        form: {
          fields: {
            createdUserName: 'ویرایش کننده',
          },
        },
      },
      userLogins: {
        title: 'تاریخچه ورودهای کاربر',
      },
      smartDetail: {
        title: 'گزارش وضعیت',
      },
      totalSmartSmsRecipients: {
        title: 'جزییات وضعیت ارسال',
        smartSmsDetailTableExcel:
          'دانلود اکسل جدول گزارش جزییات وضعیت ارسال مکان محور',
        smartSmsDetailExcel: 'دانلود اکسل گزارش جزییات وضعیت ارسال مکان محور',
      },
      assignNumbers: {
        title: 'تخصیص خطوط',
        assignPrivateNumbers: {
          title: 'اختصاص خطوط اختصاصی ',
        },
        publicReceiveKeywords: {
          title: 'اختصاص خطوط عمومی',
          form: {
            editTitle: 'ویرایش اختصاص خط عمومی ',
            addTitle: 'اختصاص خط عمومی',
            legend: 'اطلاعات خط عمومی',
          },
        },
        privateReceiveKeywords: {
          title: 'اختصاص خطوط با کلمه کلیدی ',
          form: {
            editTitle: 'ویرایش اختصاص خطوط با کلمه کلیدی',
            addTitle: 'اختصاص با کلمه کلیدی جدید',
            legend: 'اطلاعات خط اختصاصی',
          },
        },
        privateNumberSendLimit: {
          title: 'اختصاص خط به کاربر',
          form: {
            editTitle: 'ویرایش اختصاص خط به کاربر',
            addTitle: 'اختصاص خط جدید به کاربر ',
            legends: {
              general: 'اطلاعات اختصاص خط به کاربر',
              sendTypesList: 'نوع ارسال',
              users: 'کاربران',
              privateNumbers: 'شماره های اختصاصی',
            },
            fields: {
              canSeeReceivedSms: 'مشاهده ی پیام های دریافتی',
              notShowToAdmin: 'عدم نمایش خط برای مدیر سازمان',
            },
          },
        },
      },
      transferPrivateNumbers: {
        title: 'انتقال خطوط اختصاصی ',
        form: {
          editTitle: 'تغییر مالکیت',
          addTitle: 'تغییر مالکیت',
          legend: 'تغییر مالکیت خط اختصاصی',
          fields: {
            numberType: 'نوع خط',
            newOwner: 'مالک جدید',
            preOwner: 'مالک قبلی',
            privateNumber: 'شماره اختصاصی',
            TransferDateTime: 'تاریخ انتقال خط',
          },
        },
      },
      inboxGroups: {
        title: 'گروه صندوق دریافت',
        form: {
          editTitle: 'ویرایش گروه صندوق دریافت',
          addTitle: 'گروه صندوق دریافت جدید',
          legend: 'گروه صندوق دریافت',
          fields: {
            inboxGroupName: ' نام گروه صندوق دریافت',
          },
        },
      },
      inboxes: {
        title: 'صندوق دریافت',
        organizationInboxesTitle: ' صندوق دریافت سازمان ',
        usersInboxesTitle: ' صندوق دریافت کاربران ',
        addToInboxGroup: 'افزودن به گروه',
        inboxesExcel: 'اکسل صندوق دریافت',
        form: {
          editTitle: 'ویرایش صندوق دریافت',
          addTitle: ' صندوق دریافت جدید',
          legend: 'صندوق دریافت',
          changeStatusTitle: 'تغییر وضعیت',
          fields: {
            inboxGroupName: ' نام گروه صندوق دریافت',
            organizationName: 'نام سازمان',
            receiverNumber: 'شماره گیرنده',
            senderMobile: 'شماره فرستنده',
            Encoding: 'پیام Encoding',
            smsParts: 'تعداد بخش',
            smsText: 'متن پیام',
            isRead: 'خوانده شده',
            dateTimeReceive: 'زمان دریافت',
          },
        },
      },
      customPlace: {
        title: 'مکان های شخصی',
        form: {
          editTitle: 'ویرایش مکان شخصی',
          addTitle: ' مکان شخصی جدید',
          legend: 'مکان شخصی',
          customPlaceCreated: 'مکان شخصی ذخیره شد',
          dialogs: {
            polygonAtLeaseMostHave3Point:
              'برای ثبت یک محدوده جغرافیایی می بایست حداقل سه نقطه را در نقشه انتخاب کرده باشید',
          },
          fields: {
            deletedAt: 'تاریخ حذف',
            coordinates: 'مختصات',
            deletedBy: 'حذف کننده',
            isActive: 'فعال',
            parentName: 'والد',
            geometryType: 'نوع مکان',
            cityName: 'شهر',
            provinceName: 'استان',
          },
        },
      },
      groupPrice: {
        title: 'بازه‌ ها',
        titleWithCategoryName: 'لیست بازه های {{categoryName}}',
        groupPriceCategories: {
          title: 'تعرفه ها',
          categoryName: 'نام تعرفه',
          groupPriceCount: 'تعداد بازه‌ ها',
          form: {
            addTitle: 'تعرفه جدید',
            editTitle: 'ویرایش تعرفه',
          },
        },
        form: {
          legend: 'اطلاعات بازه',
          editTitle: 'ویرایش بازه',
          addTitle: 'بازه جدید',
          currencyNote: 'کلیه مبالغ وارد شده در این صفحه به «ریال» است.',
          legends: {
            international: 'سود بین الملل',
          },
          fields: {
            mtnSmartPercent: ' تعرفه ارسال مکان محور',
            rightelSmartPercent: ' تعرفه ارسال مکان محور',
            mciSmartPercent: ' تعرفه ارسال مکان محور',
            mtnSmartPercentGroupPrice: ' تعرفه ارسال مکان محور ایرانسل',
            rightelSmartPercentGroupPrice: ' تعرفه ارسال مکان محور رایتل',
            mciSmartPercentGroupPrice: ' تعرفه ارسال مکان محور همراه اول',
            irancellSmartBasePrice: 'قیمت پایه ارسال مکان محور فارسی',
            irancellEnglishSmartBasePrice: 'قیمت پایه ارسال مکان محور انگلیسی',
            mciSmartBasePrice: 'قیمت پایه ارسال مکان محور فارسی',
            mciEnglishSmartBasePrice: 'قیمت پایه ارسال مکان محور انگلیسی',
            rightelSmartBasePrice: 'قیمت پایه ارسال مکان محور فارسی',
            rightelEnglishSmartBasePrice: 'قیمت پایه ارسال مکان محور انگلیسی',
            copyGroupPrice: 'کپی تعرفه',
            internationalBenefitType: 'نوع سود بین الملل',
            internationalBenefitValuePercent: 'درصد سود بین الملل',
            internationalBenefitValue: 'مقدار سود بین الملل',
          },
        },
        list: {
          columns: {
            mciSmartPercent: 'درصد تعرفه ارسال مکان محور همراه اول',
            mtnSmartPercent: 'درصد تعرفه ارسال مکان محور ایرانسل',
            rightelSmartPercent: 'درصد تعرفه ارسال مکان محور رایتل',
          },
        },
        detailForm: {
          title: 'جزئیات بازه',
          legend: 'جزئیات بازه',
          editTitle: 'ویرایش جزئیات بازه',
          addTitle: 'جزئیات بازه جدید',
        },
        socialMediaDetailForm: {
          title: 'جزئیات بازه',
          legend: 'جزئیات بازه',
          editTitle: 'ویرایش جزئیات شبکه های اجتماعی بازه',
          addTitle: 'جزئیات بازه شبکه های اجتماعی جدید',
        },
      },
      myGroupPriceDetails: {
        title: 'تعرفه من',
      },
      sendSmsFromMap: {
        title: 'ارسال  پیامک از نقشه(شماره آپدیت)',
        title2: 'ارسال پیامک از نقشه',
        fields: {
          selectCity: 'انتخاب شهر',
          selectPostalCode: 'انتخاب کد پستی',
          selectMessageSettings: 'تنظیمات ارسال',
          regionSettings: 'تنظیمات ارسال منطقه',
          detailOfSendingRegions: 'نمایش مناطق ارسالی',
          Irancell: 'ارسال به ایرانسل',
          total: 'تعداد کل',
          count: 'تعداد ارسال',
          startFrom: 'ارسال از شماره',
          simpleCount: 'تعداد ارسال',
          simpleStartFrom: 'از',
          hamrahAval: 'ارسال به همراه اول',
          totalSendCount: 'مجموع تعداد ارسال',
          acceptAndNext: 'مرحله بعد',
        },
      },
      baseSendSms: {
        legends: {
          messageInformation: 'مشخصات پیامک',
          sendDateTimeType: 'تنظیمات ارسال',
        },
        fields: {
          receivers: 'گیرندگان',
          sendDay: 'روز ارسال',
          sendHour: 'ساعت ارسال',
          startDay: 'روز شروع',
          endDay: 'روز پایان',
          startHour: 'ساعت شروع',
          endHour: 'ساعت پایان',
          sendDirect: 'ارسال مستقیم',
          typeSend: 'نوع ارسال',
          sendPeriod: 'ارسال دوره‌ای',
          sendGradual: 'ارسال تدریجی',
          periodText: 'هر چند {{type}} یکبار',
          everyFewMinutes: 'هر چند دقیقه',
          numberOfSubmissions: 'تعداد ارسالی',
        },
        justSendToWhiteList: 'فقط ارسال به لیست سفید',
        justSendToWhiteListDesc:
          'با فعال سازی این گزینه، شماره های لیست سیاه پردازش نخواهند شد.',
        saveToCampaignDesc:
          'به منظور ذخیره سازی تاریخچه ی ارسال خود، از این گزینه استفاده می‌شود.',
        flashSmsDesc:
          'ارسال فلش باعث می‌شود پیامک شما بلافاصله و مستقیم روی صفحه‌ی گوشی مخاطب ظاهر شود.',
        isFlashSms: 'ارسال فلش',
        gradualAlert: 'حداقل تعداد گیرندگان می بایست 1000 شماره باشد .',
        fastSend: 'ارسال سریع',
        sendSms: 'ارسال پیامک',
        editSendSms: 'ویرایش ارسال',
        warningMessageBeforeClosingEditPage:
          ' کاربر گرامی با بستن این صفحه ، ارسال شما متوقف خواهد شد و امکان ویرایش مجدد امکان پذیر نمی باشد . با این وجود آیا مایل به بستن این صفحه هستید ؟',
      },
      sendSMS: {
        title: 'ارسال پیامک',
        editTitle: 'ویرایش ارسال',
        isRandomSend:
          'با فعال‌سازی این گزینه، ارسال به‌صورت رندوم از بین کل گیرندگان انجام می‌شود و ترتیب در نظر گرفته نمی‌شود.',
        fields: {
          receivers: 'گیرندگان',
        },
        legends: {
          receivers: 'گیرندگان',
          phonebook: 'دفترچه تلفن',
          sendDateTime: 'زمان ارسال',
        },
        sendSms: 'ارسال پیامک',
        addReceivers: 'افزودن شماره',
        removeReceivers: 'حذف شماره',
        missive: 'شماره های حذفی',
      },
      sendSMSWithPhonebook: {
        title: 'ارسال پیامک با دفترچه تلفن',
        editTitle: 'ویرایش ارسال پیامک با دفترچه تلفن ',
        legends: {
          phonebook: 'دفترچه تلفن',
        },
      },
      sendBalkSms: {
        title: 'ارسال انبوه (شماره آپدیت)',
        title2: ' ارسال انبوه  ',
        titlePostalCode: 'ارسال منطقه ای',
        editTitle: 'ویرایش ارسال انبوه ',
        fields: {
          state: 'استان',
          city: 'شهر',
          region: 'منطقه',
          businessGroup: 'گروه مشاغل',
          businessSubGroup: 'زیر گروه مشاغل',
          sendToRegionDetails: 'انتخاب گیرندگان',
          totalMobileNumber: 'تعداد کل شماره ها',
          totalSmsSendOnStep: 'تعداد ارسال',
          startFromOnStep: 'ارسال از شماره',
          mobilePrefixOnStep: 'پیش شماره',
          mobileType: 'نوع شماره ',
          permanentNumber: 'دائمی',
          creditNumber: 'اعتباری',
          id: 'شناسه ',
          operatorType: 'اپراتور',
          hamrahAval: 'همراه اول',
          irancell: 'ایرانسل',
          postalCode: 'کد پستی',
          zonePostalCode: 'کدپستی مناطق',
          gender: 'جنسیت',
          male: 'آقا',
          female: 'خانم',
          none: 'خالی',
          calculateTotalCount: 'محاسبه تعداد شماره',
          addToQueries: 'افزودن',
          selectBalkQueries: 'انتخاب شماره های ارسالی',
          selectMessageSettings: 'تنظیمات ارسال',
          senderNumberId: 'فرستنده',
          sendDateTime: 'زمان ارسال',
          smsBody: 'متن پیام',
          smsBodyWithSignature: 'متن پیامک با امضا',
          receivers: 'گیرندگان',
          sendHour: 'ساعت ارسال',
          sendDay: 'روز ارسال',
          startDay: 'روز شروع',
          endDay: 'روز پایان',
          startHour: 'ساعت شروع',
          endHour: 'ساعت پایان',
          sendPeriod: 'ارسال دوره‌ای',
          sendGradual: 'ارسال تدریجی',
          typeSend: 'نوع ارسال',
          periodText: 'هر چند {{type}} یکبار',
          sendingRegion: 'محدوده ارسال',
          asIfStartWith: 'پیش شماره %s ',
          postalCodeContains: 'کد پستی  %s',
          acceptAndNext: 'مرحله بعد',
          totalCountOfSendingSms: 'تعداد کل پیامک هایی که ارسال می‌شود',
        },
        errors: {
          emptyRegion: 'با تنظیمات انتخابی شما شماره ای در سیستم ثبت نشده است',
          smsCountBiggerThanTotal:
            'تعداد انتخابی از رکوردی که برای شروع انتخاب کرده اید بیشتر از کل شماره ها می باشد',
          pleaseEnterValidDateForSend:
            'لطفاً اطلاعات صحیحی برای ارسال وارد نمایید',
          firstSelectWhereToSendSms:
            'ابتدا انتخاب نمایید به کجا می خواهید پیامک ارسال کنید',
          mostSelectAtLeastState:
            'توجه داشته باشید حداقل می بایست یک استان را برای ارسال پیامک انتخاب نمایید',
          mostSelectAtLeastSimType:
            'توجه باشید حداقل می بایست مشخص نمایید می خواهید به چه نوع سیم کارتی پیامک ارسال شود',
        },
      },
      campaigns: {
        title: 'کمپین ها',
        form: {
          addTitle: 'کمپین جدید',
        },
      },
      campaignsSendSms: {
        title: 'ارسال کمپین',
      },
      sendQueue: {
        title: 'صف ارسال سازمان',
        usersTitle: 'صف ارسال کاربران',
        userTitle: 'صف ارسال کاربر',
        resellerTitle: 'صف ارسال فروشنده',
        fields: {
          id: 'شناسه',
          smsText: 'پیامک',
          failureCode: 'خطا ',
          sendType: 'نوع ارسال',
          sendSubType: 'نوع زمان ارسال ',
          senderNumber: 'فرستنده',
          recipientCount: 'تعداد گیرندگان',
          mciCount: 'همراه اول',
          mtnCount: 'ایرانسل',
          rightelCount: 'رایتل',
          otherCount: 'سایر',
          campaign: 'کمپین',
          sendPrice: 'هزینه ارسال کل',
          resolutionOfParliamentPrice: 'مصوبه مجلس',
          resolutionPrice: 'هزینه ارسال بدون مصوبه',
          pageSize: 'سایز صفحه',
          pageIndex: 'اندیس صفحه',
          fromIndex: 'از اندیس',
          zipCode: 'کد پستی',
          periodType: 'نوع ارسال دوره ای',
          period: 'دوره ای',
          dateTimeStart: 'شروع ارسال',
          dateTimeEnd: 'پایان ارسال',
          dateTimeNext: 'ارسال بعدی',
          dateTimeSend: 'زمان ارسال',
          smsCount: 'تعداد بخش',
          smsParts: 'تعداد بخش',
          operatorNumberCount: ' تعداد اپراتور ',
          blackListCount: 'تعداد لیست سیاه ',
          wrongNumberCount: 'تعداد شماره های اشتباه',
          socialMediaApplicationName: 'برنامه شبکه اجتماعی',
          socialMediaFileTitle: 'فایل شبکه اجتماعی',
          isFlashSms: 'ارسال فلش',
          internationalCount: ' بین الملل',
          processTextResults: 'تحلیل پیامک',
          p2PIsSendDuplicateNumber: 'ارسال با شماره های تکراری نظیر به نظیر',
        },
        detail: {
          title: 'جزئیات ارسال',
        },
        receivers: {
          title: 'لیست گیرندگان ',
          toNumber: 'شماره گیرنده',
          deliveryStatus: 'وضعیت تحویل',
          sendStatus: 'وضعیت ارسال',
          statusDateTime: 'تاریخ وضعیت ',
          receiversExcel: 'دانلود اکسل',
          sendDateTime: 'تاریخ ارسال',
        },
        shortLinkReceiversList: {
          title: 'لیست گیرندگان لینک کوتاه ',
          toNumber: 'شماره گیرنده',
          deliveryStatus: 'وضعیت تحویل',
          sendStatus: 'وضعیت ارسال',
          statusDateTime: 'تاریخ وضعیت ',
          receiversExcel: 'دانلود اکسل',
          sendDateTime: 'تاریخ ارسال',
          shortLinkReceiverTableExcel:
            'دانلود اکسل جدول لیست گیرندگان لینک کوتاه',
        },
        sendBulkDetails: {},
      },
      createSmartSmsRequest: {
        title: 'درخواست ارسال',
        legends: {
          requestProperties: 'مشخصات درخواست',
          publicProperties: 'مشخصات عمومی ارسال',
          requestPublicPlace: 'منطقه مد نظر جهت ارسال',
        },
        errors: {
          forceToEnterDatePeriod: 'انتخاب بازه زمانی حضور اشخاص الزامی می باشد',
          mostSelectPolygon:
            ' حداقل می بایست یک محدوده را در نقشه تعیین نمایید یا مختصات مناطق را در فیلد مختصات مناطق موردنظر وارد کنید',
          mustSelectOperator: 'لطفا اپراتور را انتخاب کنید.',
          titleIsRequired: 'عنوان الزامی است',
        },
        messages: {
          hint: 'بسته به شهر و استان انتخابی، میتوانید حداکثر بازه ی یک ساعته انتخاب کنید. برای استان ها و شهرهای بزرگ زیر 5 دقیقه و برای استان و شهر های کوچک میتوانید حداکثر تا یک ساعت بازه ی زمانی انتخاب کنید. ',
        },
        dialogs: {
          polygonAtLeaseMostHave3Point:
            'برای ذخیره محدوده جغرافیایی می بایست حداقل سه نقطه را در نقشه انتخاب کرده باشید',
        },
        horizontalAccordion: {
          workplace: 'محل کار (اقامت روز)',
          home: 'منزل (اقامت شب)',
          bankProfile:
            'پروفایل بانکی (بر اساس سرشماره پیامک های دریافتی از بانک ها)',
          jobProfile: 'پروفایل شغل',
          travelProfile: ' پروفایل سفر (داخلی/خارجی)',
          customerClub: 'باشگاه مشتریان',
          profile:
            'پروفایل بیشترین تماس و پیامک ورودی/خروجی از یک یا چند شماره خاص',
          hobbies: 'علاقمندی ها (ورزشی، خرید، سفر، ...)',
        },
        filters: {
          title: 'فیلترها',
          gender: 'جنسیت',
          age: 'سن',
          deviceType: 'نوع دستگاه',
          deviceBrand: 'برند دستگاه',
          eghamatgah: 'اقامتگاه',
          residenceState: 'محل سکونت',
          joberState: 'محل فعالیت شغلی',
          gardeshgari: 'گردشگری',
          bankProfile: 'پروفایل بانکی',
          jobs: 'پروفایل شغلی',
          favorites: 'علاقه مندیها',
          ertebatat: 'ارتباطات بر بستر مخابراتی',
          artisticCulture: 'فرهنگی هنری',
          artists: 'هنرمندان',
          writers: 'نویسندگان',
          reporters: 'خبرنگاران',
          actors: 'بازیگران',
          publishers: 'ناشرین',
          notImplemented: 'در حال حاضر این فیلتر غیر فعال می باشد',
          mobilePrefix: 'پیش شماره',
        },
        enterPublicPlaceName: 'نام گذاری منطقه انتخابی',
        publicPlaceName: 'نام مکان عمومی',
        publicPlaceCreated: 'مکان عمومی ذخیره شد',
        deviceTypes: 'نوع دستگاه',
        deviceBrands: 'برند دستگاه',
        requestName: 'عنوان درخواست',
        ageFrom: 'از سن',
        ageTo: 'تا سن',
        residenceState: 'محل سکونت',
        joberState: 'محل فعالیت شغلی',
        travellerState: 'ارسال به مسافرین',
        travellerProvinces: 'استان مبدا مسافر',
        periodicSmartSms: 'کمپین ارسال مکان محور',
        periodicSmartSmsDesc:
          'با فعال‌سازی این گزینه، می‌توانید درخواست را در قالب یک کمپین تعریف کنید و مشخص نمایید ارسال‌ها به‌صورت لحظه‌ای انجام شوند یا مربوط به بازه‌های زمانی گذشته باشند.',
        periodicHourDesc:
          'تفاوت میان ساعت شروع و ساعت پایان باید کوچکتر از 11 ساعت باشد.',
        isShowGrayListExpireHour: 'در نظرگرفتن شماره ی تکراری',
        timingOfRepetitions: 'زمان بندی تکراری ها (ساعت)',
        grayListExpireHour: 'تا چند ساعت، شماره ای تکراری در نظر گرفته شود.',
        smartRequestType: 'نوع درخواست ارسال مکان محور',
        club: 'باشگاه مشتریان',
        operationType: 'نوع عملیات',
        cellList: 'لیست شناسه‌ی دکل ها',
        mobilePrefix: 'پیش شماره',
        deviceModels: 'مدل دستگاه',
        getCellsByNames:
          'برای دریافت لیست شناسه‌ی دکل ها بر اساس نام، روی دکمه‌ی زیر کلیک کنید.',
      },
      confirmSmartSmsRequest: {
        title: 'ایجاد کمپین ارسال مکان محور',
        legends: {
          smsPart: 'تنظیمات پیامک',
          requestData: 'مشخصات دریافت کنندگان',
          requestPublicPlace: 'منطقه مدنظر جهت ارسال',
          publicMap: 'منطقه انتخابی',
          yourCampaignFrom: 'کمپین مدنظر شما از تاریخ ',
          untilDate: 'تا تاریخ ',
          period: 'دوره',
          runAnd: 'اجرا شده و',
          person: 'نفر',
          ofTheTargetNumbersWillReceiveSMS:
            'از شماره های مدنظر پیامک را دریافت می‌کنند',
          every: 'هر',
        },
        errors: {
          couldNotEditRequest:
            'درخواست شما در وضعیتی نیست که شما بتوانید اطلاعات آن را تایید یا رد نمایید.',
          pleaseWaitUntilTheRequestStateChanged:
            'لطفاً تا تغییر وضعیت درخواست منتظر بمانید.',
          mustSelectOperator: 'لطفا اپراتور را انتخاب کنید.',
        },
        dialogs: {},
        fields: {
          sendDay: 'تاریخ ارسال',
          sendHour: 'ساعت ارسال',
          sentDelayType: 'نوع ارسال',
          sentDelayValue: 'زمان پس از دریافت',
          percentageToSend: 'درصد ارسال',
          countToSend: 'تعداد ارسال',
          sendCountType: 'نوع محاسبه تعداد ارسال',
          percentage: 'درصد',
          count: 'تعداد',
          maxSendCount: 'حداکثر تعداد ارسال کمپین مکان محور',
          maxDailySendCount: 'سقف تعداد روزانه',
          socialMediaApplicationName: 'برنامه شبکه اجتماعی',
          socialMediaFileTitle: 'فایل شبکه اجتماعی',
        },
        filter: {
          yourMessageSendTo:
            'پیامک شما برای افرادی با مشخصات زیر در محدوده های انتخابی ارسال خواهد شد:',
          sent: 'در محدوده های انتخابی ارسال خواهد شد',
        },
        periodTypeValue: 'واحد زمان',
        periodText: 'تکرار هر :',
        UsePercentage: 'استفاده از درصد',
        count: 'مقدار',
        createCampain: 'ایجاد و اجرای کمپین',
        editCampaign: ' ویرایش کمپین',
      },
      smsTemplate: {
        title: 'الگوی پیامک',
        form: {
          addTitle: 'الگوی پیامک جدید',
          editTitle: 'ویرایش الگوی پیامک',
        },
      },
      smsTemplateGroup: {
        title: 'گروه الگوی پیامک',
        form: {
          editTitle: 'ویرایش گروه الگوی پیامک',
          addTitle: 'گروه الگوی پیامک جدید',
        },
      },
      accountInformation: {
        title: 'حساب ها',
        form: {
          editTitle: 'ویرایش شماره حساب',
          addTitle: 'شماره حساب جدید',
          legend: 'اطلاعات حساب',
          fields: {
            accountNo: 'شماره حساب',
            branch: 'شعبه',
            cardNo: 'شماره کارت',
            iban: 'شماره شبا',
            owner: 'مالک ',
          },
        },
      },
      bankOnlineGateways: {
        title: 'درگاه‌های پرداخت',
        form: {
          bankOnlineGatewaysForm: 'اطلاعات درگاه پرداخت',
          editTitle: 'ویرایش درگاه پرداخت',
          addTitle: 'درگاه پرداخت جدید',
          fields: {
            accountInformationId: 'شماره حساب',
            accountInformationOwner: 'مالک شماره حساب',
            typeIPG: 'نوع درگاه پرداخت اینترنتی',
            configJson: 'تنظیمات',
            isGeneralUse: 'استفاده عمومی',
            isFactorUse: 'استفاده از فاکتور',
          },
        },
      },
      zones: {
        title: 'مناطق',
        form: {
          editTitle: 'ویرایش منطقه',
          addTitle: 'منطقه جدید',
          legends: {
            generalSettings: 'تنظیمات کلی',
            mapSetting: 'تنظیمات نقشه',
          },
        },
        newCountry: 'کشور جدید',
        newState: 'استان جدید',
        newCity: 'شهر جدید',
        newArea: 'منطقه جدید',
        editCountry: 'ویرایش کشور',
        editState: 'ویرایش استان',
        editCity: 'ویرایش شهر',
      },
      roles: {
        title: 'نقش ها',
        cloneRole: 'کپی نقش',
        form: {
          editTitle: 'ویرایش نقش',
          addTitle: 'نقش جدید',
          cloneTitle: 'کپی نقش',
          legend: 'دسترسی ها',
          editRoleConfirmation: {
            inRole: 'در نقش',
            theFollowingChangesWillBeApplied: 'تغییرات زیر اعمال خواهد شد ',
            accessIsRemoved: 'دسترسی حذف می شود ',
            theOrganizationIsDeleted: 'سازمان حذف می شود ',
            listOfOrganizationsToBeDeleted: 'سازمان هایی که حذف می شوند ',
            description1:
              'با حذف این موارد در تمامی زیرگروه ها و داده های ذخیره شده مرتبط نیز اعمال خواهد شد ',
            enterTheNumberBelowToConfirmTheChanges:
              'جهت تایید تغییرات عدد زیر را وارد کنید ',
          },
        },
        userRoles: {
          title: 'تخصیص نقش به کاربران',
        },
      },
      roleTemplates: {
        title: 'قالب های آماده برای نقش ها',
        form: {
          editTitle: 'ویرایش قالب نقش',
          addTitle: 'قالب نقش جدید',
          legend: 'دسترسی ها',
          secondStep: {
            title:
              'در صورت فعال کردن دکمه ی زیر نقش هایی که برای این قالب نقش ساخته شده اند تغییر میکنند',
            isChangeRoles: 'آیا نقش ها تغییر کند؟',
          },
        },
        organizationRoles: {
          title: 'تخصیص قالب نقش به سازمان ها',
        },
      },
      guilds: {
        title: 'اصناف',
        form: {
          editTitle: 'ویرایش صنف',
          addTitle: 'صنف جدید',
          legend: 'اطلاعات صنف',
        },
      },
      kibanaDashboards: {
        title: 'داشبوردهای kibana',
        form: {
          editTitle: 'ویرایش داشبورد',
          addTitle: 'داشبورد جدید',
          legend: 'اطلاعات داشبورد',
        },
      },
      refundDeliveryStatus: {
        title: 'وضعیت های برگشت هزینه',
        form: {
          editTitle: 'ویرایش وضعیت های برگشت هزینه',
          addTitle: 'وضعیت های برگشت هزینه جدید',
          legend: 'اطلاعات وضعیت های برگشت هزینه',
          fields: {
            deliveryStatuses: ' وضعیت تحویل',
          },
        },
      },
      resellers: {
        title: 'فروشندگان',
        form: {
          editTitle: 'ویرایش فروشنده',
          addTitle: 'فروشنده جدید',
          legend: 'اطلاعات فروشنده',
          fields: {
            reseller: 'فروشنده',
            pricePerSms: 'مبلغ به ازای هر پیامک',
            panelPercent: 'درصد پنل',
            target: 'هدف فروش',
          },
        },
        resellers: {
          title: 'لیست فروشندگان',
        },
        resellerOrganizations: {
          title: 'سازمان های فروشنده',
        },
      },
      resellerTarget: {
        title: 'هدف فروشنده',
        form: {
          editTitle: 'ویرایش هدف فروشنده',
          addTitle: 'هدف فروشنده جدید ',
          legend: ' هدف فروشنده ',
          fields: {
            times: 'زمان',
            targetValue: 'هدف(تعداد پیامک)',
            credit: 'هدف(مبلغ نهایی)',
          },
        },
      },
      systemSetting: {
        title: 'تنظیمات سیستم',
        form: {
          editTitle: 'ویرایش تنظیمات سیستم',
          addTitle: 'تنظیمات جدید',
          legend: ' تنظیمات سیستم',
          description:
            'شما میتوانید در این فرم، تنظیمات مربوط به قسمت های مختلف پنل خود را مقداردهی کنید ',
        },
      },
      panelSetting: {
        title: 'تنظیمات پنل ',
        form: {
          editTitle: 'ویرایش تنظیمات',
          addTitle: 'تنظیمات جدید',
          legend: 'تنظیمات',
          description:
            'شما میتوانید در این فرم، تنظیمات مربوط به قسمت های مختلف پنل خود را مقداردهی کنید ',
        },
      },
      creditNotification: {
        title: 'اطلاع رسانی اعتبار سازمان',
        form: {
          editTitle: 'ویرایش اعتبار سازمان ',
          addTitle: 'اعتبار سازمان جدید ',
          legend: 'اطلاع رسانی اعتبار سازمان',
          fields: {
            lastSendDateTime: 'تاریخ آخرین ارسال',
            isSend: 'ارسال شده',
            scheduledMessageId: 'شناسه آخرین ارسال',
          },
        },
      },
      otp: {
        title: 'قالب پیامک احرازهویت',
        form: {
          editTitle: 'ویرایش قالب پیامک ',
          addTitle: 'قالب پیامک جدید ',
          changeStatusTitle: 'تغییر وضعیت',
          code: '۱۲۳',
          name: 'علی',
          code2: 'کد {0}',
          name2: '{1} عزیز,',
          description: 'به پیشگام رایان خوش آمدید.',
          code3: 'کد 123',
          name3: 'علی عزیز,',
          legends: {
            specifications: 'قالب پیامک',
            help: 'راهنما',
          },
          messages: {
            description1:
              'پارامترهای متغیر در متن پیام را بصورت {#} وارد کنید ',
            description2:
              ' نوع # در مورد بالا عددی بوده و از 0 شروع می‌شود و به ترتیب افزایش می یابد {0},{1},{2},… ',
            description3:
              'هنگام ارسال پیام احرازهویت باید به تعداد پارامترهای متغیر تعریف شده در پیام، پارامتر ارسال شود',
            description4:
              ' برای ارسال { یا } در قالب پیامک، از {{ یا }} استفاده کنید',
            sampleOtp: 'نمونه قالب پیامک',
            sampleParameters: 'نمونه پارامترهای ارسالی برای پیامک بالا ',
            finalMessage: 'پیامک ارسالی به کاربر',
          },
          fields: {
            priority: 'اولویت',
            smsText: 'متن پیام',
            lastModified: 'تاریخ آخرین ویرایش',
            OtpStatus: 'وضعیت',
          },
        },
      },
      menus: {
        name: 'مدیریت منو',
        title: 'مدیریت منو ها',
        form: {
          editTitle: 'ویرایش منو',
          addTitle: 'منو جدید',
          legends: {
            generalMenu: 'مشخصات',
            helpMenu: 'راهنما',
          },
          fields: {
            route: 'مسیر',
            order: 'ترتیب',
            claim: 'دسترسی',
            class: 'کلاس',
            claims: ' دسترسی ها',
            helpText: 'متن راهنما',
            imageHelp: 'تصویر راهنما',
            videoHelp: 'ویدیوی راهنما',
            pdfHelp: 'فایل پی دی اف راهنما',
            fileHelp: 'فایل راهنما',
          },
        },
        uploadFileForm: {
          editTitle: 'ویرایش راهنما',
          addTitle: 'راهنما جدید',
          legend: 'راهنما ',
          fields: {
            helpFileType: 'نوع فایل',
            file: 'فایل',
          },
        },
      },
      help: {
        title: 'راهنما ',
        helpDetail: 'جزئیات راهنما',
      },
      organizationTransactions: {
        title: 'تراکنش ها ',
        resellerTransactionTitle: 'تراکنش های فروشنده',
        outboxTransactionsTitle: 'تراکنش های صندوق ارسال',
        transactionsDetailTitle: 'جزئیات تراکنش',
        resellerTransactionsDetailTitle: 'جزئیات تراکنش فروشنده',
        transactionsExcel: 'دانلود فایل اکسل تراکنش ها',
        resellerTransactionsExcel: 'دانلود فایل اکسل تراکنش های فروشنده',
        form: {
          editTitle: 'ویرایش تراکنش ',
          addTitle: 'تراکنش جدید',
          fields: {
            packageId: 'شناسه بسته',
            packageTitle: 'عنوان بسته',
            outboxId: 'شناسه صندوق ارسال ',
            paymentId: 'شناسه پرداخت',
            isIncrement: 'افزایشی',
            typeTransaction: 'نوع تراکنش',
            typeCreditChange: ' نوع تغییر اعتبار',
            currentCredit: 'اعتبار فعلی',
            createdByUserName: 'ایجاد شده',
          },
          legend: 'اطلاعات تراکنش ',
        },
      },
      sendLimits: {
        title: 'محدودیت ارسال روی خط',
        form: {
          editTitle: 'ویرایش محدودیت ',
          addTitle: 'محدودیت جدید',
          legend: 'اطلاعات محدودیت',
          fields: {
            privateNumberNumber: 'خط',
            dailySendLimit: 'محدودیت ارسال در روز',
            monthlySendLimit: 'محدودیت ارسال در ماه',
          },
        },
      },
      allPrivateNumberSendLimit: {
        title: 'لیست خطوط کاربران',
        form: {
          fields: {
            sendTypesList: 'نوع ارسال',
            privateNumber: 'شماره اختصاصی',
            canSeeReceivedSms: ' مشاهده پیام ورودی',
          },
        },
      },
      automaticResend: {
        title: 'تنظیم ارسال مجدد خودکار',
        form: {
          editTitle: 'ویرایش تنظیم ',
          addTitle: 'تنظیم جدید',
          fields: {
            privateNumber: 'شماره ی اختصاصی',
            deliveryStatus: 'وضعیت تحویل',
            targetPrivateNumbers: 'خط فرستنده',
          },
          legend: 'اطلاعات تنظیم',
        },
      },
      payments: {
        title: 'لیست پرداخت ها',
        resellerTitle: 'لیست پرداخت های فروشنده',
        detail: 'جزئیات پرداخت',
        confirmPayment: 'تایید پرداخت',
        rejectPayment: 'رد پرداخت',
        confirmByFinancialTeam: 'تایید پرداخت مالی',
        rejectByFinancialTeam: 'رد پرداخت مالی',
        paymentsExcel: 'دانلود فایل اکسل پرداخت ها',
        fields: {
          accountInformationId: 'حساب',
          accountInformationOwner: 'مالک حساب ',
          accountInformationAccountNo: 'شماره حساب',
          accountInformationCardNo: 'شماره کارت',
          accountInformationBank: 'بانک',
          paymentDate: 'تاریخ پرداخت',
          typePayment: 'نوع پرداخت',
          typeStatus: 'وضعیت پرداخت',
          billNumber: 'شماره سند',
          isOnlineGeneral: 'درگاه عمومی',
          createdBy: 'ایجاد کننده',
          orderId: 'شماره سفارش',
          adminResellerCode: 'کد نمایندگی ادمین',
          resellerCode: 'کد فروشنده',
          userFirstLastName: 'نام و نام خانوادگی کاربر',
          chequeImageAddress: 'تصویر چک',
          receiverOrganizationName: 'سازمان دریافت کننده',
          userName: 'کاربر پرداخت کننده',
          payerOrganizationName: 'سازمان پرداخت کننده',
          isHaveImage: 'تصویر دارد',
          isNeedLiquidate: 'نیاز به تسویه',
          smsCountPerPriceDescription: 'توضیحات تعداد پیامک',
          smsCount: 'تعداد پیامک',
          resolutionOfParliament: 'مصوبه مجلس',
          groupPriceDetailPrice: 'قیمت جزئیات تعرفه',
          iban: 'شماره شبا',
          payerOrganizationNationalId: 'شناسه/کدملی پرداخت کننده',
          interOrganizationalOrganizationName: 'نام سازمان(میان سازمانی)',
          interOrganizationalUserName: 'نام کاربری(میان سازمانی)',
          typeTransaction: ' نوع تراکنش(میان سازمانی)',
        },
      },
      resellerPayments: {
        title: 'لیست پرداخت ها',
        resellerTitle: 'لیست پرداخت های فروشنده',
        detail: 'جزئیات پرداخت',
        confirmPayment: 'تایید پرداخت',
        rejectPayment: 'رد پرداخت',
        confirmByFinancialTeam: 'تایید پرداخت مالی',
        rejectByFinancialTeam: 'رد پرداخت مالی',
        paymentsExcel: 'دانلود فایل اکسل پرداخت ها',
        fields: {
          accountInformationId: 'حساب',
          accountInformationOwner: 'مالک حساب ',
          accountInformationAccountNo: 'شماره حساب',
          accountInformationCardNo: 'شماره کارت',
          accountInformationBank: 'بانک',
          paymentDate: 'تاریخ پرداخت',
          typePayment: 'نوع پرداخت',
          typeStatus: 'وضعیت پرداخت',
          billNumber: 'شماره سند',
          isOnlineGeneral: 'درگاه عمومی',
          createdBy: 'ایجاد کننده',
          orderId: 'شماره سفارش',
          adminResellerCode: 'کد نمایندگی ادمین',
          resellerCode: 'کد فروشنده',
          userFirstLastName: 'نام و نام خانوادگی کاربر',
          chequeImageAddress: 'تصویر چک',
          receiverOrganizationName: 'سازمان دریافت کننده',
          userName: 'کاربر پرداخت کننده',
          payerOrganizationName: 'سازمان پرداخت کننده',
          isHaveImage: 'تصویر دارد',
          isNeedLiquidate: 'نیاز به تسویه',
          smsCountPerPriceDescription: 'توضیحات تعداد پیامک',
          smsCount: 'تعداد پیامک',
          resolutionOfParliament: 'مصوبه مجلس',
          groupPriceDetailPrice: 'قیمت جزئیات تعرفه',
          interOrganizationalOrganizationName: 'نام سازمان(میان سازمانی)',
          interOrganizationalUserName: 'نام کاربری(میان سازمانی)',
          typeTransaction: ' نوع تراکنش(میان سازمانی)',
        },
      },
      paymentsForConfirm: {
        title: 'لیست پرداخت ها برای تایید',
        resellerTitle: 'لیست پرداخت ها برای تایید فروشنده',
        confirmPayment: 'تایید پرداخت',
        rejectPayment: 'رد پرداخت',
        confirmByFinancialTeam: 'تایید پرداخت مالی',
        rejectByFinancialTeam: 'رد پرداخت مالی',
      },
      resellerPaymentsForConfirm: {
        title: 'لیست پرداخت ها برای تایید',
        resellerTitle: 'لیست پرداخت ها برای تایید فروشنده',
        confirmPayment: 'تایید پرداخت',
        rejectPayment: 'رد پرداخت',
      },
      paymentStatusChangeHistories: {
        title: ' تاریخچه تایید یا رد پرداخت',
        fields: {
          type: 'نوع تغییر وضعیت',
          reservedCreditForGuarantee: 'اعتبار رزرو شده برای ضمانت',
          isCreditOfGuaranteeLiquidated: 'تسویه اعتبار ضمانت',
          liquidationTime: 'زمان تسویه',
        },
      },
      newPayment: {
        title: 'افزایش موجودی ',
        legend: 'مشخصات پرداخت',
        publicPaymentGateway: 'درگاه پرداخت را انتخاب کنید',
        selectCardNumber: 'شماره کارت را انتخاب کنید',
        selectAccountNumber: 'شماره شبا را انتخاب کنید',
        fields: {
          accountInformationId: 'حساب',
          billNumber: 'شماره پیگیری / شماره ارجاع ',
          billNumberPlaceholder: 'شماره تراکنش',
          billNumberHint:
            'شماره سند، تراکنش، پیگیری یا ارجاع دریافت‌شده از بانک یا درگاه را وارد کنید.',
          branchCode: 'کد شعبه',
          chequeAccountNumber: 'شماره شبا صاحب چک',
          chequeImage: 'تصویر چک',
          chequeAmount: 'مبلغ چک ',
          chequeImageAddress: ' تصویر چک ',
          dueDate: ' تاریخ سررسید ',
          holderName: 'نام صاحب حساب ',
          isOnlineGeneral: 'درگاه عمومی',
          serialNumber: 'شماره سریال ',
          sayadNumber: 'شماره صیادی ',
          seriesNumber: 'شماره سری',
          nationalCode: 'کدملی / شناسه ملی  ',
          orderId: 'شماره سفارش',
          referenceId: 'شماره مرجع',
          typePayment: 'نوع پرداخت',
          paymentDate: 'تاریخ پرداخت',
          paymentTime: 'ساعت پرداخت',
        },
        invoice: {
          title: 'پیش فاکتور',
        },
      },
      proformaInvoices: {
        title: 'لیست پیش فاکتورهای کاربر',
        customerTitle: 'لیست پیش فاکتورهای سازمان',
        sellerTitle: 'لیست پیش فاکتورهای کاربران',
        cancelProformaInvoice: 'لغو پیش فاکتور',
        fields: {
          paymentType: 'نوع پرداخت',
          status: 'وضعیت',
          customerOrganizationName: 'سازمان مشتری',
          customerUserName: 'نام کاربری مشتری',
          sellerOrganizationName: 'سازمان فروشنده',
        },
      },
      customerProformaInvoices: {
        title: 'لیست پیش فاکتورهای سازمان',
        cancelProformaInvoice: 'لغو پیش فاکتور',
        fields: {
          paymentType: 'نوع پرداخت',
          status: 'وضعیت',
          customerOrganizationName: 'سازمان مشتری',
          customerUserName: 'نام کاربری مشتری',
          sellerOrganizationName: 'سازمان فروشنده',
        },
      },
      sellerProformaInvoices: {
        title: 'لیست پیش فاکتورهای کاربران',
        cancelProformaInvoice: 'لغو پیش فاکتور',
        fields: {
          paymentType: 'نوع پرداخت',
          status: 'وضعیت',
          customerOrganizationName: 'سازمان مشتری',
          customerUserName: 'نام کاربری مشتری',
          sellerOrganizationName: 'سازمان فروشنده',
        },
      },
      chequePayments: {
        title: 'لیست چک ها ',
        resellerTitle: 'لیست چک های فروشنده',
        detail: 'جزئیات چک',
        fields: {
          branchCode: 'کد شعبه',
          chequeAccountNumber: ' شماره شبا صاحب چک',
          chequeAmount: 'مبلغ چک',
          chequeImageAddress: ' تصویر چک',
          dueDate: 'تاریخ سررسید',
          holderName: 'نام صاحب حساب',
          isPassed: 'پاس شدن',
          nationalCode: 'شناسه ملی / کدملی',
          paymentId: 'شناسه پرداخت',
          sayadNumber: 'شماره صیادی',
          serialNumber: 'شماره سریال',
          seriesNumber: 'شماره سری',
          typeBank: 'بانک',
          payerOrganizationName: 'سازمان پرداخت کننده',
          receiverOrganizationName: 'سازمان دریافت کننده',
        },
      },
      informations: {
        name: 'اطلاعیه',
        title: 'اخبار',
        form: {
          addTitle: 'افزودن خبر',
          editTitle: 'ویرایش خبر',
          fields: {
            id: 'شناسه خط',
            displayForAllSubOrganizations:
              'نمایش برای همه سازمان های زیر مجموعه ',
            customerDomainName: 'دامنه',
            startDate: 'شروع نمایش خبر',
            endDate: 'پایان نمایش خبر',
            isRequiredToSeen: 'نمایش اجباری',
            fileType: 'نوع فایل',
            showOnlyToCurrentDomainOrganizations: 'نمایش فقط برای دامنه',
            displayOnlyForChildrenOrganizations:
              'نمایش فقط برای سازمان های زیرمجموعه مستقیم',
          },
          legend: 'افزودن خبر',
        },
      },
      panelDocumentations: {
        title: 'مستندات پنل',
        webServiceSendHelp: 'راهنما برای ارسال با وب سرویس',
        downloadDocumentations: 'مستندات',
        smartDocumentations: 'مستندات ارسال مکان محور',
      },
      audits: {
        title: ' گزارش تغییرات',
        auditList: 'لیست تغییرات',
        auditDetail: 'جزئیات تغییرات',
        fields: {
          referenceId: 'شناسه جدول',
          remoteIpAddress: 'آدرس  آی پی از راه دور',
          localIpAddress: 'آدرس آی پی محلی',
          osInfo: 'اطلاعات سیستم عامل',
          browserName: 'نام مرورگر',
          operationType: 'نوع عملیات',
          operationCount: 'تعداد عملیات',
          old: 'اطلاعات قبلی',
          new: 'اطلاعات جدید',
          comments: 'پیغام ها',
          timezone: 'منطقه زمانی',
          ip: 'آی پی',
          applicationName: 'نام نرم افزار',
          lat: 'عرض جغرافیایی',
          lon: 'طول جغرافیایی',
          country_iso_code: 'کد ایزو کشور',
          country_name: 'نام کشور',
          continent_code: 'کد قاره',
          userAgent: 'عامل کاربر',
          className: 'محل خطا',
          os: {
            full: 'نام کامل سیستم عامل',
            version: 'ورژن سیستم عامل',
            name: 'نام سیستم عامل',
          },
          device: {
            name: 'نام دستگاه',
          },
          clientUserAgent: {
            name: 'نام عامل کاربر مشتری',
            version: 'ورژن عامل کاربر مشتری',
          },
        },
      },
      superAdminAudits: {
        title: 'لاگ های سوپر ادمین',
        legends: {
          environmentInfo: 'اطلاعات محیط',
          document: 'اطلاعات لاگ',
        },
        fields: {
          startDate: 'تاریخ شروع',
          endDate: 'تاریخ پایان',
          logCode: 'کد لاگ',
          logText: 'متن لاگ',
          logLocation: 'محل لاگ',
          userInfo: {
            userAgent: 'عامل کاربر',
            applicationName: 'نام برنامه',
            remoteIpAddress: 'آدرس آی پی از راه دور',
            userId: 'شناسه کاربری',
            localIpAddress: 'آدرس آی پی محلی',
            userName: 'نام کاربری',
            remoteIpAddressGeo: {
              geo: {
                timezone: 'منطقه زمانی',
                continent_code: 'کد قاره',
                country_name: 'نام کشور',
                country_iso_code: 'کد ایزو کشور',
                location: {
                  lat: 'عرض جغرافیایی',
                  lon: 'طول جغرافیایی',
                },
              },
              ip: 'آی پی',
            },
            clientUserAgent: {
              name: 'نام عامل کاربر مشتری',
              version: 'ورژن عامل کاربر مشتری',
              os: {
                full: 'نام کامل سیستم عامل',
                version: 'ورژن سیستم عامل',
                name: 'نام سیستم عامل',
              },
              device: {
                name: 'نام دستگاه',
              },
            },
          },
          environment: {
            userName: 'نام کاربری محیط',
            machineName: 'نام دستگاه',
            domainName: 'نام دامنه',
            culture: 'زبان',
          },
        },
      },
      apiAudits: {
        title: 'لاگ های وب سرویس',
        legends: {
          environmentInfo: 'اطلاعات محیط',
          userInfo: 'اطلاعات کاربری',
          document: 'اطلاعات لاگ',
        },
        fields: {
          startDate: 'تاریخ شروع',
          endDate: 'تاریخ پایان',
          logCode: 'نوع لاگ',
          logText: 'متن لاگ',
          logLocation: 'محل لاگ',
          userId: 'شناسه کاربری',
          organizationId: 'شناسه سازمان',
          token: 'توکن',
          tokenIp: 'آی پی توکن',
          tokenId: 'شناسه توکن',
          requestMethod: 'متد درخواست',
          requestPath: 'مسیر درخواست',
          scheduledMessageId: 'شناسه ی پیام',
          status: 'وضعیت',
          requestBody: 'درخواست',
          userInfo: {
            userAgent: 'عامل کاربر',
            applicationName: 'نام برنامه',
            remoteIpAddress: 'آدرس آی پی از راه دور',
            userId: 'شناسه کاربری',
            localIpAddress: 'آدرس آی پی محلی',
            userName: 'نام کاربری',
            remoteIpAddressGeo: {
              geo: {
                timezone: 'منطقه زمانی',
                continent_code: 'کد قاره',
                country_name: 'نام کشور',
                country_iso_code: 'کد ایزو کشور',
                location: {
                  lat: 'عرض جغرافیایی',
                  lon: 'طول جغرافیایی',
                },
              },
              ip: 'آی پی',
            },
            clientUserAgent: {
              name: 'نام عامل کاربر مشتری',
              version: 'ورژن عامل کاربر مشتری',
              os: {
                full: 'نام کامل سیستم عامل',
                version: 'ورژن سیستم عامل',
                name: 'نام سیستم عامل',
              },
              device: {
                name: 'نام دستگاه',
              },
            },
          },
          environment: {
            userName: 'نام کاربری محیط',
            machineName: 'نام دستگاه',
            domainName: 'نام دامنه',
            culture: 'زبان',
          },
        },
      },
      loginAudits: {
        title: 'لاگ های ورود کاربران',
        legends: {
          environmentInfo: 'اطلاعات محیط',
          userInfo: 'اطلاعات کاربری',
          document: 'اطلاعات لاگ',
        },
        fields: {
          logDateTime: 'تاریخ لاگ',
          startDate: 'تاریخ شروع',
          endDate: 'تاریخ پایان',
          logCode: 'نوع لاگ',
          logText: 'متن لاگ',
          logLocation: 'محل لاگ',
          userId: 'شناسه کاربری',
          organizationId: 'شناسه سازمان',
          token: 'توکن',
          tokenIp: 'آی پی توکن',
          tokenId: 'شناسه توکن',
          requestMethod: 'متد درخواست',
          requestPath: 'مسیر درخواست',
          scheduledMessageId: 'شناسه ی پیام',
          status: 'وضعیت',
          requestBody: 'درخواست',
          resultData: 'دیتای نتیجه',
          entryData: 'دیتای ورودی',
          userInfo: {
            userAgent: 'عامل کاربر',
            applicationName: 'نام برنامه',
            remoteIpAddress: 'آدرس آی پی از راه دور',
            userId: 'شناسه کاربری',
            localIpAddress: 'آدرس آی پی محلی',
            userName: 'نام کاربری',
            remoteIpAddressGeo: {
              geo: {
                timezone: 'منطقه زمانی',
                continent_code: 'کد قاره',
                country_name: 'نام کشور',
                country_iso_code: 'کد ایزو کشور',
                location: {
                  lat: 'عرض جغرافیایی',
                  lon: 'طول جغرافیایی',
                },
              },
              ip: 'آی پی',
            },
            clientUserAgent: {
              name: 'نام عامل کاربر مشتری',
              version: 'ورژن عامل کاربر مشتری',
              os: {
                full: 'نام کامل سیستم عامل',
                version: 'ورژن سیستم عامل',
                name: 'نام سیستم عامل',
              },
              device: {
                name: 'نام دستگاه',
              },
            },
          },
          environment: {
            userName: 'نام کاربری محیط',
            machineName: 'نام دستگاه',
            domainName: 'نام دامنه',
            culture: 'زبان',
          },
        },
      },
      shortLinkLandingPage: {
        title: 'صفحه وب لینک کوتاه',
      },
      rulesAudits: {
        title: 'لاگ قوانین توکن',
        legends: {},
        fields: {
          startDate: 'تاریخ شروع',
          endDate: 'تاریخ پایان',
          logCode: 'نوع لاگ',
          logText: 'متن لاگ',
          requestMethod: 'متد درخواست',
          requestPath: 'مسیر درخواست',
          requestToken: 'توکن درخواست',
          status: 'وضعیت',
          userInfo: {
            userAgent: 'عامل کاربر',
            applicationName: 'نام برنامه',
            remoteIpAddress: 'آدرس آی پی از راه دور',
            userId: 'شناسه کاربری',
            localIpAddress: 'آدرس آی پی محلی',
            userName: 'نام کاربری',
            remoteIpAddressGeo: {
              geo: {
                timezone: 'منطقه زمانی',
                continent_code: 'کد قاره',
                country_name: 'نام کشور',
                country_iso_code: 'کد ایزو کشور',
                location: {
                  lat: 'عرض جغرافیایی',
                  lon: 'طول جغرافیایی',
                },
              },
              ip: 'آی پی',
            },
            clientUserAgent: {
              name: 'نام عامل کاربر مشتری',
              version: 'ورژن عامل کاربر مشتری',
              os: {
                full: 'نام کامل سیستم عامل',
                version: 'ورژن سیستم عامل',
                name: 'نام سیستم عامل',
              },
              device: {
                name: 'نام دستگاه',
              },
            },
          },
          environment: {
            userName: 'نام کاربری محیط',
            machineName: 'نام دستگاه',
            domainName: 'نام دامنه',
            culture: 'زبان',
          },
        },
      },
      systemNumbers: {
        title: 'کلیه خطوط سیستم',
        systemNumbersExcel: 'دانلود اکسل کلیه خطوط سیستم ',
        legend: 'کلیه خطوط سیستم',
        fields: {
          number: 'شماره خط',
          numberType: 'نوع خط',
          organizationName: 'نام سازمان',
          smsSenderAgentName: 'نام عامل ارسال ',
          refundDeliveryStatusesTitle: 'سطح برگشت هزینه',
        },
      },
      webhook: {
        title: 'وب هوک',
        form: {
          editTitle: 'ویرایش وب هوک',
          addTitle: 'وب هوک جدید',
          legend: 'اطلاعات وب هوک',
          encoding: 'کدینگ',
          messageId: 'شناسه صندوق ارسال',
          status: 'وضعیت',
          sampleCode: 'نمونه کد',
          to: 'خط اختصاصی',
          from: 'شماره ارسال کننده',
          text: 'متن پیام',
          toNumber: 'شماره تلفن گیرنده پیام',
          receivedDate: 'تاریخ دریافت',
          fields: {
            url: 'آدرس',
            tryCount: 'تعداد سعی مجدد',
            webhookType: 'نوع',
          },
          legends: {
            specifications: 'مشخصات',
            address: 'آدرس webhook',
          },
          messages: {
            description1:
              'برای اطلاع از جزئیات پارامترها به راهنما مراجعه کنید.',
            description3: 'آدرس باید با http یا https شروع شده باشد.',
            description2: 'اعتبارسنجی آدرس وارد شده به عهده کاربر می باشد.',
            description4:
              'توجه : وب هوک وضعیت، فقط برای ارسال های وب سرویس ارسال خواهد شد.',
          },
        },
      },
      apiToken: {
        title: 'توکن ',
        ipRules: 'کل قوانین آی پی',
        createIpRules: 'تنظیم قوانین آی پی',
        clientRules: ' قوانین کاربر',
        safeIps: 'آی پی های امن',
        form: {
          editTitle: 'ویرایش توکن',
          addTitle: 'توکن جدید',
          changeStatusTitle: 'تغییر وضعیت توکن',
          legend: 'اطلاعات توکن',
          fields: {
            ip: 'آی پی',
            token: 'توکن',
            status: 'وضعیت',
            isCanSend: 'ارسال',
            isCanSendSmart: 'ارسال مکان محور',
            isIgnoreCheckIp: 'چک نکردن آی پی',
            canUseSmartClass: 'کلاس هوشمند',
            enableUseHmac: 'فعال کردن HMAC',
          },
        },
      },
      ipRules: {
        title: 'کل قوانین آی پی ',
        allIpRules: 'کل قوانین',
        form: {
          addTitle: 'جدید',
          editTitle: 'ویرایش',
          legend: 'اطلاعات قانون',
          fields: {
            ip: 'آی پی',
            limit: 'نرخ فراخوانی',
            period: 'دوره فراخوانی',
            periodType: 'نوع دوره فراخوانی',
            endpoint: 'آدرس Api',
            apiTokenId: 'آیدی Api',
            ipRulesFromWebService: 'قوانین آی پی از کش',
            ipRulesFromTable: 'قوانین آی پی از جدول',
          },
        },
      },
      clientRules: {
        title: 'قوانین کاربر ',
        form: {
          addTitle: 'جدید',
          editTitle: 'ویرایش',
          legend: 'اطلاعات قانون',
          fields: {
            ip: 'آی پی',
            limit: 'نرخ فراخوانی',
            period: 'دوره فراخوانی',
            endpoint: 'آدرس Api',
            apiTokenId: 'آیدی Api',
            clientId: 'آیدی کاربر',
            clientRulesFromWebService: 'قوانین کاربر از کش',
            clientRulesFromTable: 'قوانین کاربر از جدول',
          },
        },
      },
      pollParsersInboxes: {
        title: 'ارسال کنندگان',
        inboxesExcel: 'دانلود فایل اکسل',
      },
      ussdCalls: {
        title: 'فراخوانی های USSD',
        ussdCallsExcel: 'دانلود اکسل فراخوانی ها',
      },
      modules: {
        title: 'ماژول ها',
        modules: {
          title: 'ماژول ها',
        },
        modulesOrganizations: {
          title: 'ماژول های سازمان ها',
          form: {
            editTitle: 'ویرایش ماژول سازمان',
            addTitle: 'اختصاص ماژول به سازمان',
            legend: 'مشخصات',
            fields: {
              moduleId: 'شناسه ماژول',
              organizationId: 'شناسه سازمان',
            },
          },
        },
      },
      filterWords: {
        title: 'کلمات فیلتر شده',
        form: {
          editTitle: 'ویرایش کلمات',
          addTitle: 'کلمات جدید',
          fields: {
            userFirstName: 'نام کاربر',
            userLastName: 'نام خانوادگی کاربر',
          },
        },
      },
      organizationsBlackListExceptions: {
        title: 'لیست استثناها',
        form: {
          addTitle: 'استثناهای جدید',
        },
      },
      phonebook: {
        title: 'دفترچه تلفن',
        form: {
          addTitle: 'افزودن به دفترچه تلفن',
          editTitle: 'ویرایش دفترچه تلفن',
          fields: {
            title: 'عنوان',
            isPublic: 'وضعیت عمومی',
            isShowNumber: 'وضعیت نمایش شماره',
            canSeeContacts: 'امکان مشاهده مخاطبین',
            contactsCount: 'تعداد مخاطبین',
            whiteMessageId: 'شناسه باشگاه ',
            deviceConnectionPort: 'شناسه دستگاه باشگاه مشتریان',
            isSendMessageAfterAddFromDevice:
              'ارسال پیام پس از افزودن از دستگاه',
          },
          legends: {
            phonebookInformation: 'اطلاعات دفترچه تلفن',
            organizationsWhichCanUse: 'سازمان‌های دارای دسترسی',
          },
          hints: {
            canSeeContacts:
              'مشخص کنید کدام سازمان‌ها مجاز به مشاهده مخاطبین این دفترچه تلفن هستند.',
          },
        },
        customFieldsForm: {
          title: ' فیلدهای سفارشی دفترچه تلفن',
          searchInCustomFields: 'جستجو در فیلدهای سفارشی',
        },
      },
      contacts: {
        title: ' مخاطبین',
        deleteContactsFormPhonebooks: {
          title: 'حذف مخاطب از گروه ها',
          message:
            'گروه هایی که قصد دارید مخاطبین از آنها حذف شوند را انتخاب نمائید. ',
          selectCurrentGroup: 'انتخاب گروه فعلی',
        },
        addBtns: {
          addSingle: 'افزودن تکی',
          addListNumber: 'افزودن شماره لیستی',
          addFromFile: 'افزودن از فایل اکسل',
        },
        form: {
          addTitle: 'افزودن مخاطب',
          editTitle: 'ویرایش مخاطب',
          fields: {
            job: 'شغل  ',
            birthdate: 'تاریخ تولد',
            telephone: 'تلفن ',
            cellphone: 'شماره همراه',
            phonebookGroup: 'گروه دفترچه تلفن',
            createType: 'نوع ایجاد',
          },
          legends: {
            contactInfo: 'اطلاعات مخاطب',
            customFields: 'فیلد های دلخواه',
          },
        },
        importfromfile: {
          title: 'افزودن مخاطبین از فایل',
          legends: {
            importFromFile: 'افزودن مخاطبین از فایل',
            previewFile: 'پیش نمایش',
          },
          fields: {
            selectfile: 'انتخاب فایل',
            firstNameFieldName: 'فیلد نام',
            lastNameFieldName: 'فیلد نام خانوادگی',
            emailFieldName: 'فیلد پست الکترونیکی',
            birthDateFieldName: 'فیلد تاریخ تولد',
            telephoneFieldName: 'فیلد تلفن ثابت',
            jobFieldName: 'فیلد شغل',
            addressFieldName: 'فیلد آدرس',
            empty: 'خالی',
            cellPhone: 'فیلد تلفن همراه',
            phonebookGroup: 'گروه دفترچه تلفن',
          },
        },
      },
      dynamicTemplate: {
        title: ' قالب های پویا ',
        form: {
          addTitle: 'قالب پویا جدید',
          editTitle: 'ویرایش قالب پویا',
          fields: {
            customText: 'متن دلخواه',
            format: 'قالب',
          },
          messages: {
            description1:
              'جهت افزودن فیلدهای ثابت روی نام فیلد در لیست بالا کلیک کنید.',
            description2:
              'همچنین از قسمت مشخصات می توانید جهت افزودن متن و فیلد دلخواه اقدام نمائید  .',
            note1: 'در طراحی قالب پویا به نکات زیر توجه داشته باشید :',
            note2:
              ' اگر فیلد دلخواه یا فیلد ثابتی در قالب پویا تعریف شد که مقداری در مخاطب برای آن ثبت نشده باشد، در پیامک متن آن خالی ارسال می شود .',
            note3:
              'اگر فیلد دلخواهی در قالب پویا تعریف شد که در گروه مخاطبین (دفترچه تلفن) وجود نداشته باشد، در پیامک متن آن خالی ارسال می شود .',
          },
        },
      },
      outboxMessages: {
        title: ' صندوق ارسال سازمان ',
        usersTitle: ' صندوق ارسال کاربران',
        userTitle: ' صندوق ارسال کاربر',
        resellerTitle: ' صندوق ارسال کاربران فروشنده فعلی',
        resellersTitle: ' صندوق ارسال کاربران فروشنده ',
        usersOutboxMessages: ' تمامی کاربران',
        userOutboxMessages: 'فقط سوپرادمین',
        editStatusTitle: 'ویرایش انتخابی وضعیت تحویل گیرندگان',
        getNewDeliveryStatusTitle: 'درخواست آخرین وضعیت تحویل',
        outboxExcel: 'دانلود فایل اکسل صندوق ارسال',
        outboxExcelWithMoreDetail:
          ' دانلود فایل اکسل صندوق ارسال با جزئیات بیشتر',
        advancedSearch: {
          title: 'جستجوی پیشرفته',
          zipCode: 'کدپستی',
          phonebookIds: 'گروه دفترتلفن',
          toNumber: 'گیرنده',
          guild: 'گروه مشاغل',
          zone: 'منطقه',
          startDate: 'تاریخ شروع',
          endDate: 'تاریخ پایان',
          description: 'توضیحات',
          smsText: 'متن پیام',
          sendStartDate: 'تاریخ شروع ارسال',
          sendEndDate: 'تاریخ پایان ارسال',
          sendStartHour: 'ساعت شروع ارسال',
          sendEndHour: 'ساعت پایان ارسال',
          sendStatus: 'وضعیت ارسال ',
          deliveryStatus: 'وضعیت تحویل گیرندگان',
          trackingNumber: 'کد پیگیری',
        },
        resendDetail: {
          title: 'جزئیات ارسال مجدد',
          createdBy: 'ایجاد کننده',
          scheduledMessageId: 'شناسه قبلی',
          newScheduledMessageId: 'شناسه جدید',
          deliveryStatuses: 'نوع ارسال مجدد',
        },
        fields: {
          countSendBlackList: 'تعداد ارسال لیست سیاه',
          blackListCount: 'تعداد لیست سیاه',
          countResendOther: 'تعداد ارسال مجدد',
          cpType: 'عامل ارسال',
          exportDataStatus: 'وضعیت خروجی داده',
          receiverCount: 'گیرندگان',
          organizationId: 'شناسه سازمان',
          scheduledMessageId: 'شناسه',
          sendingTryCount: 'تعداد تلاش برای ارسال',
          campaign: 'کمپین',
          mciCount: 'همراه اول',
          mtnCount: 'ایرانسل',
          otherCount: 'سایر',
          rightelCount: 'رایتل',
          internationalCount: 'بین الملل',
          smsEncoding: 'نوع رمزگذاری',
          smsParts: 'بخش',
          smsText: 'پیامک',
          status: 'وضعیت',
          contactsCount: 'تعداد مخاطبین',
          resellerName: 'فروشنده',
          sendSubType: 'نوع زمان ارسال ',
          sendType: 'نوع ارسال ',
          isResend: 'ارسال مجدد',
          senderNumber: 'فرستنده',
          wrongNumberCount: 'تعداد شماره های اشتباه',
          isWhiteMessage: 'ارسال سفید',
          isFlashSms: 'ارسال فلش',
          period: 'دوره ای',
          processTextResults: 'تحلیل پیامک',
          p2PIsSendDuplicateNumber: 'ارسال با شماره های تکراری نظیر به نظیر',
          isP2PWithShortLink: 'نظیر به نظیر لینک کوتاه',
        },
        detail: {
          title: 'جزئیات ارسال',
          PhonebookRecipientTitle: 'جزئیات ارسال با دفترچه تلفن',
        },
        resendByDeliveryStatus: {
          title: 'ارسال مجدد بر اساس وضعیت',
          statues: 'وضعیت ها',
          isSendFromMyPanel: 'ارسال از پنل من',
          extraReceivers: 'گیرندگان اضافی',
          selectDeliveryStatus: 'انتخاب وضعیت',
          messageInformation: 'مشخصات پیامک',
          receiversAndSendDateTime: 'گیرندگان و زمان ارسال',
          deliveryStatusRequiredMsg: 'انتخاب حداقل یک وضعیت الزامی می باشد.',
          sendDirect: 'ارسال مستقیم',
          sendGradual: 'ارسال تدریجی',
          isFlashSms: 'ارسال فلش',
        },
      },
      dynamicSendSms: {
        title: 'ارسال پویا',
        form: {
          addTitle: 'ارسال پویا',
          editTitle: 'ویرایش ارسال پویا',
          fields: {
            customText: 'متن دلخواه',
            format: 'قالب',
            dynamicTemplates: 'قالب های پویا',
          },
        },
        messages: {
          warningMessageBeforeClosingEditPage:
            'توجه داشته باشید با زدن کلید (بازگشت) ارسال شما متوقف خواهد شد. ',
          note1: 'در ارسال پویا به نکات زیر توجه داشته باشید :',
          note2:
            ' اگر فیلد دلخواه یا فیلد ثابتی در قالب پویا تعریف شد که مقداری در مخاطب برای آن ثبت نشده باشد، در پیامک متن آن خالی ارسال می شود .',
          note3:
            'اگر فیلد دلخواهی در قالب پویا تعریف شد که در گروه مخاطبین (دفترچه تلفن) وجود نداشته باشد ، در پیامک متن آن خالی ارسال می شود .',
        },
        legends: {
          messageInformation: 'مشخصات پیامک',
          phonebook: 'دفترچه تلفن',
        },
      },
      sendP2pSms: {
        title: 'ارسال نظیر به نظیر',
        trackingNumberTitle: 'ارسال نظیر به نظیر با کد پیگیری',
        editTitle: 'ویرایش ارسال نظیر به نظیر',
        legends: {
          selectFile: 'انتخاب فایل',
          smsTextSetting: ' متن پیامک',
          smsSetting: 'تنظیمات پیامک',
        },
        fields: {
          toNumberFieldName: 'ستون شماره موبایل',
          linkFieldName: 'ستون لینک',
          trackingNumberFieldName: 'ستون کد پیگیری',
          enterForLinkUrlColumnForGenerateShortLink:
            'یک نام برای فیلد لینک انتخاب کنید',
        },
        messages: {
          description1:
            'جهت تنظیم متن پیامک ، می توانید ستون موردنظر را با کلیک کردن از لیست ستون ها انتخاب نمائید.',
          description2:
            ' همچنین برای جابجایی ستون ها در کادر آبی ، ستون را گرفته و جابجا کنید.',
          description3:
            ' لازم به ذکر است جهت افزودن متن دلخواه می توانید متن موردنظر خود را داخل فیلد متن دلخواه تایپ کنید و با زدن کلید افزودن ',
          description4: 'متن خود را به پیامک اضافه کنید.',
          sendWithDuplicateNumbersMsg:
            '  با انتخاب این گزینه شماره های تکراری موجود در فایل اکسل انتخابی حذف نمی گردد. قبل از استفاده از این گزینه اطمینان حاصل نمایید که به ازای گیرندگان ثابت قرار است متن متفاوتی ارسال نمایید.',
        },
      },
      sendP2pSmartSms: {
        title: 'ارسال مکان محور نظیر به نظیر',
        editTitle: 'ویرایش ارسال مکان محور نظیر به نظیر',
        legends: {
          selectFile: 'انتخاب فایل',
          smsTextSetting: ' متن پیامک',
          smsSetting: 'تنظیمات پیامک',
          publicMap: 'منطقه انتخابی',
        },
        fields: {
          toNumberFieldName: 'ستون شماره موبایل ها',
        },
        messages: {
          description1:
            'جهت تنظیم متن پیامک ، می توانید ستون موردنظر را با کلیک کردن از لیست ستون ها انتخاب نمائید.',
          description2:
            ' همچنین برای جابجایی ستون ها در کادر آبی ، ستون را گرفته و جابجا کنید.',
          description3:
            ' لازم به ذکر است جهت افزودن متن دلخواه می توانید متن موردنظر خود را داخل فیلد متن دلخواه تایپ کنید و با زدن کلید افزودن ',
          description4: 'متن خود را به پیامک اضافه کنید.',
          sendWithDuplicateNumbersMsg:
            ' با انتخاب این گزینه شماره های تکراری موجود در فایل اکسل انتخابی حذف نمی گردد. قبل از استفاده از این گزینه اطمینان حاصل نمایید که به ازای گیرندگان ثابت قرار است متن متفاوتی ارسال نمایید.',
        },
        errors: {
          couldNotEditRequest:
            'درخواست شما در وضعیتی نیست که شما بتوانید اطلاعات آن را تایید یا رد نمایید.',
          pleaseWaitUntilTheRequestStateChanged:
            'لطفا تا تغییر وضعیت درخواست منتظر بمانید.',
          mustSelectOperator: 'لطفا اپراتور را انتخاب کنید.',
        },
      },
      sendSmartSMS: {
        title: 'شروع درخواست ارسال',
        detail: 'جزئیات درخواست',
        smartSmsDetailExcel: 'دانلود اکسل جزئیات ارسال مکان محور ',
        smartSmsDetailTableExcel: 'دانلود اکسل جدول جزئیات ارسال مکان محور',
        form: {
          addTitle: 'ارسال مکان محور جدید',
          editTitle: 'ویرایش ارسال مکان محور',
          legend: 'ارسال مکان محور',
          fields: {
            status: 'وضعیت ',
            statusDatetime: 'تاریخ وضعیت',
            startDatetime: 'تاریخ شروع',
            endDatetime: 'تاریخ پایان',
            title: 'عنوان',
            responseData: 'پاسخ',
          },
        },
      },
      smartSmsRequests: {
        title: 'لیست درخواست ها',
        detail: 'جزئیات درخواست',
        smartSmsRequestExcel: 'دانلود اکسل درخواست ارسال مکان محور',
        form: {
          addTitle: 'ارسال مکان محور جدید',
          editTitle: 'ویرایش ارسال مکان محور',
          legend: ' لیست درخواست های ارسال مکان محور',
          fields: {
            status: 'وضعیت ',
            statusDatetime: 'تاریخ وضعیت',
            startDatetime: 'تاریخ شروع',
            endDatetime: 'تاریخ پایان',
            title: 'عنوان',
            responseData: 'پاسخ',
          },
        },
        exportRequest: 'ذخیره درخواست در فایل',
        exportStatus: 'ذخیره وضعیت در فایل',
        importRequestStatus: 'به روزرسانی وضعیت از فایل',
        importRequestFromFile: 'ایجاد در خواست از فایل',
      },
      resellerSmartSmsRequests: {
        title: 'لیست درخواست فروشنده',
        form: {
          fields: {
            status: 'وضعیت ',
            statusDatetime: 'تاریخ وضعیت',
            startDatetime: 'تاریخ شروع',
            endDatetime: 'تاریخ پایان',
          },
        },
      },
      sendOccasionSms: {
        title: 'ارسال مناسبتی',
        isActiveDesc:
          'جهت ثبت نهایی درخواست و ارسال پیام در زمان مقرر باید فعال شود.',
        toConsiderYearDesc:
          'در صورت فعال‌سازی، فقط روز و ماه تاریخ‌ها ملاک قرار می‌گیرد و سال محاسبه نمی‌شود.',
        legends: {
          messageInformation: 'مشخصات پیامک',
          phonebook: 'دفترچه تلفن',
        },
        fields: {
          howManyDaysSendItBeforeDueDate: 'ارسال قبل از تاریخ  رویداد (روز)',
          calendarEvents: 'مناسبت تقویمی',
          calenderOrganizationEvents: 'مناسبت سازمانی',
          toConsiderYear: 'سال در نظر گرفته شود',
        },
      },
      fastSendSmsPatternByPhonebook: {
        title: 'ارسال پیام الگو',
        manual: 'ارسال دستی',
        phonebook: 'ارسال دفترچه تلفن',
      },
      fastSendSmsPatternManual: {
        title: 'ارسال پیام الگو دستی',
        fields: {
          receivers: 'گیرندگان',
        },
      },
      pollParsers: {
        surveyTitle: 'نظرسنجی',
        competitionTitle: 'مسابقه',
        options: 'گزینه ها',
        selectOption: 'انتخاب گزینه',
        form: {
          pollAddTitle: 'نظرسنجی جدید',
          pollEditTitle: 'ویرایش نظرسنجی',
          competitionAddTitle: 'مسابقه جدید',
          competitionEditTitle: 'ویرایش مسابقه',
          legends: {
            surveySpecifications: 'مشخصات نظرسنجی',
            surveyResponse: 'پاسخ به شرکت کنندگان در نظرسنجی',
            surveyMatchOptions: 'گزینه های نظرسنجی',
            competitionSpecifications: 'مشخصات مسابقه',
            competitionResponse: 'پاسخ به شرکت کنندگان در مسابقه',
            competitionMatchOptions: 'گزینه های مسابقه',
          },
          fields: {
            privateNumberId: 'ورود از شماره',
            senderPhonebookId: 'عضو',
            optionTitle: 'عنوان گزینه',
            answerValue: 'کلمه کلیدی',
            phonebookName: 'ذخیره در دفترچه تلفن',
            isCorrect: 'صحیح',
            isJustTrueAnswer: 'فقط پاسخ صحیح',
            isMainQuestion: 'سوال اصلی',
          },
          messages: {
            emptyOption: 'هنوز گزینه ای ثبت نشده!',
            onlyOneCorrectOption: 'گزینه صحیح قبلاً ثبت شده است.',
            optionTitleRequired: 'عنوان گزینه را وارد کنید',
            keywordRequired: 'کلمه کلیدی را وارد کنید',
            uniqueTitle: 'عنوان گزینه نمی تواند تکراری باشد',
            uniqueKeyword: 'کلمه کلیدی نمی تواند تکراری باشد',
          },
        },
        stats: {
          title: 'مشاهده آمار',
          correctAnswerCount: 'تعداد پاسخ صحیح',
          incorrectAnswerCount: 'تعداد پاسخ غلط',
          surveyStats: 'آمار نظرسنجی',
          competitionStats: 'آمار مسابقه ',
          doughnutChartTitle: 'نمودار گزینه های انتخاب شده',
          pieChartTitle: 'نمودار تعداد انتخاب های صحیح و غلط',
        },
      },
      textParsers: {
        title: 'تحلیلگر پیامک',
        form: {
          addTitle: 'تحلیلگر جدید',
          editTitle: 'ویرایش تحلیلگر',
          fields: {
            isChildrenChange: 'اعمال برای همه زیرمجموعه ها',
            title: 'عنوان فیلتر پیامک',
            privateNumberId: 'شماره گیرنده',
            senderConditionType: 'شرط',
            senderConditionValue: 'مقدار',
            senderPhonebookId: 'عضو',
            ifConditionType: 'اگر',
            ifConditionValue: 'مقدار',
            thenConditionType: 'آنگاه',
            thenConditionValue: 'مقدار',
            senderNumber: 'شماره فرستنده',
            mobileNumber: 'شماره گیرنده',
            email: 'ایمیل گیرنده',
            matchingDynamicTemplateId: 'استفاده از قالب در صورت تطابق',
            noMatchingDynamicTemplateId: 'استفاده از قالب در صورت عدم تطابق',
            ipAndPort: 'آی پی و پورت',
            sentDelayType: 'نوع ارسال',
            sentDelayValue: 'زمان پس از دریافت',
          },
          legends: {
            filterConditions: 'شرایط فیلتر',
            generalInformation: 'مشخصات عمومی',
            senderNumber: 'شماره فرستنده',
            duplicateMessageResponse: 'پاسخ پیام تکراری',
          },
        },
      },
      safeIps: {
        safeIpsTitle: 'آی پی های امن',
        detail: 'جزئیات آی پی های امن',
        confirmUserSafeIpsTitle: 'تایید آی پی های امن',
        confirmUserSafeIps: 'تایید آی پی ',
        rejectUserSafeIps: 'رد آی پی ',
        form: {
          addTitle: 'آی پی امن جدید',
          editTitle: 'ویرایش آی پی',
        },
        details: {
          as: 'شناسه شبکه اینترنت',
          asName: 'نام شبکه اینترنت',
          city: 'شهر',
          continent: 'قاره',
          continentCode: 'کد قاره',
          country: 'کشور',
          countryCode: 'کد کشور',
          hosting: 'هاستینگ',
          isp: 'ارائه‌دهنده اینترنت',
          mobile: 'موبایل',
          org: 'سازمان',
          proxy: 'پروکسی',
          region: 'شناسه منطقه',
          regionName: 'استان',
          reverse: 'دامنه معکوس',
          timeZone: 'منطقه زمانی',
        },
      },
      whiteMessages: {
        title: 'لیست درخواست ها',
        form: {
          addTitle: 'درخواست تنظیمات جدید',
          editTitle: 'ویرایش وضعیت درخواست',
          fields: {
            enterSms: 'پیامک ورود مجدد به باشگاه',
            exitSms: 'پیامک خروج از باشگاه',
            returnText: 'متن برگشت ',
            cancelText: 'متن لغو',
            status: 'وضعیت تایید',
            dailyAddLimit: 'حداکثر تعداد افزودن روزانه به دفترچه باشگاه',
            monthlyAddLimit: 'حداکثر تعداد افزودن ماهانه به دفترچه باشگاه',
            isSendCancelText: 'ارسال متن لغو آخر هر پیامک',
            rejectComment: 'توضیحات رد کردن',
            repeatTextDay: 'تکرار متن در هر روز',
          },
          legends: {
            requestDetail: 'جزئیات درخواست',
            defineScenario: 'تعریف سناریو',
          },
        },
      },
      organizationWhiteMessages: {
        title: 'لیست تنظیمات',
        form: {
          addTitle: 'تنظیمات جدید',
          editTitle: 'ویرایش تنظیمت',
          fields: {
            enterSms: 'پیامک ورود به باشگاه',
            exitSms: 'پیامک خروج از باشگاه',
            returnText: 'متن برگشت ',
            cancelText: 'متن لغو',
          },
        },
      },
      sendWhiteMessage: {
        title: 'ارسال پیامک باشگاه',
        editTitle: 'ویرایش ارسال پیامک باشگاه ',
        legends: {
          phonebook: 'دفترچه تلفن',
        },
      },
      aggregators: {
        title: 'پیش شماره اپراتور',
        numberAggregator: 'یافتن اپراتور شماره همراه',
        isValidNumber: 'اعتبارسنجی شماره همراه',
        form: {
          addTitle: 'پیش شماره جدید',
          editTitle: 'ویرایش پیش شماره',
          updateRegexTitle: 'ویرایش regex',
          fields: {
            regex: 'regex',
            smsAggregator: 'اپراتور',
          },
        },
      },
      documentsManagement: {
        title: 'مدیریت مستندات',
        form: {
          addTitle: 'مستندات جدید',
          editTitle: 'ویرایش مستندات ',
          fields: {},
        },
      },
      currentOrganizationSentCountStatistics: {
        title: 'گزارش آماری ارسال سازمان فعلی ',
      },
      currentUserSentCountStatistics: {
        title: 'گزارش آماری ارسال کاربر فعلی ',
      },
      sentCountStatistics: {
        title: 'گزارش آماری ارسال',
      },
      currentOrganizationSendStatusStatistics: {
        title: 'گزارش آماری وضعیت ها سازمان فعلی ',
      },
      currentUserSendStatusStatistics: {
        title: 'گزارش آماری وضعیت ها کاربر فعلی ',
      },
      sendStatusStatistics: {
        title: 'گزارش آماری وضعیت‌ها',
      },
      currentOrganizationOperatorStatistics: {
        title: 'گزارش آماری اپراتورها سازمان فعلی ',
      },
      currentUserOperatorStatistics: {
        title: 'گزارش آماری اپراتورها کاربر فعلی ',
      },
      operatorStatistics: {
        title: 'گزارش آماری اپراتورها',
      },
      smartStatistics: {
        title: 'آمار ارسال مکان محور',
      },
      statisticsByPartLength: {
        title: 'گزارش جزییات ارسال',
      },
      currentUserStatisticsByPartLength: {
        title: 'گزارش جزییات ارسال کاربر فعلی',
      },
      currentOrganizationStatisticsByPartLength: {
        title: 'گزارش جزییات ارسال سازمان فعلی',
      },
      complexStatistics: {
        title: 'گزارش آماری جامع',
      },
      currentOrganizationComplexStatistics: {
        title: 'گزارش آماری جامع سازمان فعلی',
      },
      currentUserComplexStatistics: {
        title: 'گزارش آماری جامع کاربر فعلی',
      },
      todayStatistics: {
        title: 'گزارش آماری امروز',
      },
      currentOrganizationTodayStatistics: {
        title: 'گزارش آماری امروز سازمان فعلی',
      },
      currentUserTodayStatistics: {
        title: 'گزارش آماری امروز کاربر فعلی',
      },
      currentUserSentCountAggregateCompareStatistics: {
        title: 'گزارش ارسال مقایسه ای تجمیعی کاربر فعلی',
      },
      currentOrganSentCountAggregateCompareStatistics: {
        title: 'گزارش ارسال مقایسه ای تجمیعی سازمان فعلی',
      },
      superAdminSentCountAggregateCompareStatistics: {
        title: 'گزارش ارسال مقایسه ای تجمیعی سوپرادمین',
      },
      currentUserSentCountSeasonsCompareStatistics: {
        title: 'گزارش ارسال مقایسه ای فصل به فصل کاربر فعلی',
      },
      currentOrganSentCountSeasonsCompareStatistics: {
        title: 'گزارش ارسال مقایسه ای فصل به فصل سازمان فعلی',
      },
      superAdminSentCountSeasonsCompareStatistics: {
        title: 'گزارش ارسال مقایسه ای فصل به فصل سوپرادمین ',
      },
      currentUserSentStatusAggregateCompareStatistics: {
        title: 'گزارش وضعیت مقایسه ای تجمیعی کاربر فعلی',
      },
      currentOrganSentStatusAggregateCompareStatistics: {
        title: 'گزارش وضعیت مقایسه ای تجمیعی سازمان فعلی',
      },
      superAdminSentStatusAggregateCompareStatistics: {
        title: 'گزارش وضعیت مقایسه ای تجمیعی سوپرادمین',
      },
      currentUserSentStatusSeasonsCompareStatistics: {
        title: 'گزارش وضعیت مقایسه ای فصل به فصل کاربر فعلی',
      },
      currentOrganSentStatusSeasonsCompareStatistics: {
        title: 'گزارش وضعیت مقایسه ای فصل به فصل سازمان فعلی',
      },
      superAdminSentStatusSeasonsCompareStatistics: {
        title: 'گزارش وضعیت مقایسه ای فصل به فصل سوپرادمین',
      },
      currentUserOperatorSeasonsCompareStatistics: {
        title: 'گزارش اپراتورهای مقایسه ای فصل به فصل کاربر فعلی ',
      },
      currentOrganOperatorSeasonsCompareStatistics: {
        title: 'گزارش اپراتورهای مقایسه ای فصل به فصل سازمان فعلی ',
      },
      superAdminOperatorSeasonsCompareStatistics: {
        title: 'گزارش اپراتورهای مقایسه ای فصل به فصل سوپرادمین',
      },
      currentUserOperatorAggregateCompareStatistics: {
        title: 'گزارش اپراتورهای مقایسه ای تجمیعی کاربر فعلی',
      },
      currentOrganOperatorAggregateCompareStatistics: {
        title: 'گزارش اپراتورهای مقایسه ای تجمیعی سازمان فعلی',
      },
      superAdminOperatorAggregateCompareStatistics: {
        title: 'گزارش اپراتورهای مقایسه ای تجمیعی سوپرادمین',
      },
      statisticalReports: {
        lineComplexDescription: 'نمودار کل پیام های ارسال شده به تفکیک زمان',
        doughnutChartDescription: 'نمودار تعداد پیام های ارسال شده',
        barChartDescription: 'نمودار پیام های ارسال شده ',
        successful: 'موفق',
        unsuccessful: 'ناموفق',
        allCount: 'مجموع',
        sendingStatusDoughnutChart: 'نمودار وضعیت ارسال',
        sendingStatusBarChart: 'نمودار وضعیت ارسال به تفکیک وضعیت',
        untilTargetCount: 'باقیمانده تا هدف',
        targetCount: 'تعداد پیامک هدف',
        sentCount: 'تعداد پیامک ارسالی',
        lineResellersDescription:
          'نمودار تعداد پیامک های ارسالی و هدف فروشندگان',
        barChartResellersDescription:
          'نمودار مجموع تعداد پیامک های ارسالی و هدف',
      },
      operatorsTodayStatistics: {
        title: 'گزارش امروز اپراتورها',
      },
      currentOrganizationResellersStatistics: {
        title: 'آمار فروشندگان سازمان',
      },
      packageSales: {
        title: 'مدیریت بسته های پیامک',
        form: {
          addTitle: 'بسته پیامک جدید',
          editTitle: 'ویرایش بسته پیامک',
          priceErrorMessage: 'میزان شارژ باید بیشتر از مبلغ پرداختی باشد',
          steps: {
            information: 'اطلاعات بسته',
            amount: 'مبالغ و ضریب',
            salesWindow: 'پنجره فروش و سقف‌ها',
            publish: 'انتشار',
          },
          fields: {
            expirationType: 'نوع',
            expiration: 'مدت اعتبار',
            packageInformations: 'اطلاعات بسته',
            created: 'زمان ایجاد',
            identifier: 'شناسه',
            category: 'دسته',
            sendType: 'نوع ارسال',
            cardLabel: 'برچسب کارت',
            validityPeriod: 'دوره اعتبار (روز)',
            nominalCredit: 'مبلغ بسته',
            ratio: 'ضریب',
            savings: 'صرفه‌جویی کاربر',
            visibleFor: 'قابل نمایش برای',
            realPerson: 'حقیقی',
            legalPerson: 'حقوقی',
            authenticated: 'احراز هویت شده',
            agent: 'نماینده',
            saleStartDate: 'شروع فروش',
            saleEndDate: 'پایان فروش',
            totalSalesCap: 'سقف تعداد کل فروش',
            organizationPurchaseCap: 'سقف خرید هر سازمان',
            unlimited: 'بدون محدودیت',
            allowedCategoryRange: 'بازه مجاز دسته',
            approxSmsCountLabel: 'تعداد تقریبی پیامک',
            approxSmsCount: 'تقریباً {{count}} پیامک',
            showInCatalog: 'نمایش در کاتالوگ',
            availableForRealOrganization: 'نمایش برای سازمان حقیقی',
            availableForLegalOrganization: 'نمایش برای سازمان حقوقی',
          },
          messages: {
            saleWindowErrorMessage:
              'تاریخ پایان فروش نمی‌تواند قبل از تاریخ شروع فروش باشد',
            capsErrorMessage:
              'سقف خرید هر سازمان نمی‌تواند بیشتر از سقف تعداد کل فروش باشد',
            bothAmountsRequired: 'هر دو مبلغ باید وارد شوند.',
            paymentGreaterThanNominal: 'مبلغ پرداختی از مبلغ بسته بیشتر است.',
            ratioOutsideAllowedRange:
              'ضریب {{ratio}}٪ خارج از بازه‌ی مجاز دسته است.',
            expirationDaysMustBePositive:
              'دوره اعتبار باید بزرگ‌تر از صفر باشد.',
            amountsGuide:
              'برای محاسبه دقیق بسته، مبلغ بسته و مبلغ پرداختی را وارد کنید. ضریب به‌صورت «۱۰۰ × (مبلغ پرداختی ÷ مبلغ بسته)» محاسبه می‌شود.',
            ratioHint:
              'فیلد ضریب قابل تایپ نیست: ضریب = 100*(مبلغ پرداختی ÷ مبلغ بسته).',
          },
          publish: {
            changesSummary: 'خلاصه وضعیت تغییرات',
            versionWarning:
              'با تغییر مبالغ، نسخه جدیدی از این بسته ایجاد خواهد شد و سازمان‌هایی که این بسته را خریداری کرده‌اند تحت تأثیر قرار می‌گیرند.',
            changed: 'تغییر یافته',
            saveDraft: 'ذخیره پیش‌نویس',
            publishToCatalog: 'انتشار در کاتالوگ',
          },
          preview: {
            title: 'پیش‌نمایش کارت',
            noTitle: 'نام بسته',
            choosePackage: 'انتخاب بسته',
          },
          tags: {
            0: 'بدون برچسب',
            1: 'پرفروش',
            2: 'جدید',
            3: 'فروش محدود',
            4: 'بیشترین صرفه‌جویی',
          },
        },
      },
      packages: {
        buySmsPackage: {
          title: 'خرید بسته',
          filters: {
            all: 'همه',
            sendType: 'همه‌ی نوع‌های ارسال',
            title: 'انتخاب بسته مناسب',
            resultsCount: '{{count}} بسته برای انتخاب',
            sendTypeLabel: 'نوع ارسال',
            sort: 'مرتب‌سازی',
          },
          sorts: {
            mostValuable: 'بیشترین صرفه‌جویی',
            cheapest: 'ارزان‌ترین',
            mostNominalAmount: 'بیشترین مبلغ بسته',
            shortestExpiration: 'کوتاه‌ترین دوره',
          },
          card: {
            choosePackage: 'خرید بسته',
            smsApprox: 'تقریباً {{count}} پیامک فارسی',
            nominalCredit: 'مبلغ بسته',
            priceSummary: 'خلاصه اعتبار و مبلغ بسته',
            payableAmount: 'مبلغ قابل پرداخت',
            validity: 'مدت اعتبار',
            sendType: 'نوع ارسال',
            ratio: 'ضریب پرداخت',
            validityDays: 'روز اعتبار',
            savings: 'صرفه‌جویی',
          },
          buyConfirm: 'آیا از خرید این بسته مطمئن هستید؟',
          empty: 'بسته‌ای برای نمایش وجود ندارد',
          emptyHint: 'فیلترهای انتخاب‌شده را تغییر دهید و دوباره بررسی کنید.',
          noteTitle: 'نحوه محاسبه تعداد پیامک',
          note: 'تعداد پیامک نمایش‌داده‌شده برای هر بسته تقریبی است و بر اساس تعرفه {{price}} ریال به‌ازای هر بخش پیامک فارسی و {{resolutionPrice}} ریال مصوبه مجلس با سرشماره های پیشگام رایان محاسبه می‌شود.',
          dialog: {
            title: 'خرید بسته پیامک',
            gateway: 'درگاه پرداخت',
            pay: 'پرداخت',
          },
          checkout: {
            back: 'بازگشت به بسته‌ها',
            title: 'سبد و پرداخت',
            selectedPackage: 'بسته انتخابی',
            returnedCreditNote:
              'اگر این بسته پیش از مصرف کامل منقضی شود، مانده × ضریب به اعتبار برگشتی شما اضافه می‌شود و در خرید بعدی قابل استفاده است.',
            payment: {
              onlineDescription: 'پرداخت امن با درگاه‌های بانکی',
              credit: 'پرداخت از کیف پول',
              onlinePayment: 'پرداخت آنلاین',
              creditDescription: 'پرداخت از اعتبار موجود سازمان',
              title: 'روش پرداخت',
              anotherMethodOfPayment: 'روش های دیگرِ پرداخت',
              otherMethodsNotice:
                'پرداخت با این روش نیازمند بررسی و تأیید است؛ بنابراین تکمیل آن ممکن است نسبت به سایر روش‌های پرداخت زمان بیشتری ببرد.',
              online: 'درگاه بانکی',
              deposit: 'فیش، کارت‌به‌کارت یا چک',
              organizational: 'پیش‌فاکتور سازمانی',
              gateway: 'درگاه بانکی',
              selectGateway: 'درگاه بانکی را انتخاب کنید',
              account: 'حساب مقصد',
              selectAccount: 'حساب مقصد را انتخاب کنید',
            },
            bill: {
              availableCredit: 'اعتبار موجود',
              insufficientCredit: 'اعتبار سازمان برای خرید این بسته کافی نیست.',
              title: 'صورت‌حساب',
              packageAmount: 'مبلغ بسته',
              vat: 'مالیات بر ارزش افزوده (۱۰٪)',
              returnedCredit: 'اعتبار برگشتی',
              payable: 'مبلغ قابل پرداخت',
              availableReturnedCredit: 'اعتبار برگشتی موجود',
              returnedCreditCap: 'سقف استفاده ۳۰٪ مبلغ بسته',
              discount: 'تخفیف',
            },
            issueProforma: 'صدور پیش‌فاکتور',
          },
        },
        salesDashboard: {
          title: 'داشبورد فروش بسته‌ها',
          subtitle: 'نمای کلی عملکرد فروش و وضعیت بسته‌های پیامکی',
          analyticsLabel: 'تحلیل فروش بسته‌ها',
          filters: {
            label: 'انتخاب بازه زمانی',
            oneMonth: '۱ ماه',
            threeMonths: '۳ ماه',
            sixMonths: '۶ ماه',
            oneYear: '۱ سال',
          },
          stats: {
            title: 'خلاصه فروش',
            description: 'شاخص‌های کلیدی فروش در بازه انتخاب‌شده',
            sales: 'فروش',
            activePackages: 'بسته‌های فعال',
            expiringPackages: 'بسته‌های در آستانه انقضا',
            averageCoefficient: 'میانگین ضریب فروش',
          },
          chart: {
            title: 'روند فروش بسته‌ها',
            description: 'مقایسه فروش ماهانه به تفکیک دسته‌بندی',
          },
          categories: {
            title: 'سهم دسته‌ها از فروش',
            description: 'توزیع مبلغ فروش بین دسته‌بندی‌های بسته',
            alert:
              'درصدها بر اساس مبلغ کل فروش در بازه انتخاب‌شده محاسبه شده‌اند.',
          },
          states: {
            statsError: 'دریافت آمار فروش با خطا مواجه شد.',
            statsEmpty: 'آماری برای نمایش وجود ندارد.',
            chartError: 'دریافت نمودار فروش با خطا مواجه شد.',
            chartEmpty: 'داده‌ای برای نمودار فروش وجود ندارد.',
            categoriesError: 'دریافت سهم دسته‌ها با خطا مواجه شد.',
            categoriesEmpty: 'داده‌ای برای سهم دسته‌ها وجود ندارد.',
          },
          months: {
            farvardin: 'فروردین',
            ordibehesht: 'اردیبهشت',
            khordad: 'خرداد',
            tir: 'تیر',
            mordad: 'مرداد',
            shahrivar: 'شهریور',
            mehr: 'مهر',
            aban: 'آبان',
            azar: 'آذر',
            dey: 'دی',
            bahman: 'بهمن',
            esfand: 'اسفند',
          },
        },
        mySmsPackages: {
          title: 'بسته‌های من',
          activePackages: 'بسته‌های فعال',
          reservedPackages: 'بسته‌های رزرو',
          search: 'جست‌وجو بر اساس نام بسته',
          history: 'تاریخچه بسته‌ها',
          financialSummary: 'خلاصه وضعیت مالی بسته‌ها',
          totalNominalAmount: 'ارزش اسمی کل',
          totalRemainingAmount: 'اعتبار باقی‌مانده',
          totalRemainingPercent: 'درصد اعتبار باقی‌مانده کل',
          totalPaymentAmount: 'مبلغ پرداختی',
          totalSavingAmount: 'میزان صرفه‌جویی',
          loading: 'در حال دریافت بسته‌های پیامکی',
          loadError: 'دریافت بسته‌های پیامکی با خطا مواجه شد.',
          empty: 'بسته‌ای برای نمایش وجود ندارد',
          activePackage: 'بسته فعال',
          otherPackages: 'سایر بسته‌ها',
          smsCount: 'تعداد پیامک',
          packageAmount: 'مبلغ باقی مانده',
          nominalAmount: 'مبلغ اسمی',
          paymentRatio: 'ضریب پرداخت',
          remainingPercent: 'مانده از بسته',
          approximateSmsCount: 'تقریباً {{count}} پیامک',
          daysRemaining: '{{count}} روز مانده',
          expiresToday: 'امروز منقضی می‌شود',
          daysExpired: '{{count}} روز از انقضا گذشته',
          remaining: 'باقی‌مانده',
          startDate: 'تاریخ خرید',
          endDate: 'تاریخ پایان',
          statuses: {
            active: 'فعال',
            expired: 'منقضی شده',
            finished: 'تمام شده',
            reserved: 'رزرو شده',
            unknown: 'نامشخص',
          },
        },
        mySmsPackagesHistory: {
          title: 'تاریخچه بسته‌ها',
          fields: {
            packageName: 'نام بسته',
            category: 'دسته‌بندی',
            status: 'وضعیت',
            nominalAmount: 'مبلغ اسمی',
            paymentAmount: 'مبلغ پرداختی',
            remainingAmount: 'اعتبار باقی‌مانده',
            assignDateTime: 'تاریخ شروع',
            expireDate: 'تاریخ پایان',
          },
        },
      },
      organizationsSmsPackages: {
        title: 'بسته‌های پیامکی سازمان‌ها',
        fields: {
          organizationName: 'نام سازمان',
          packageName: 'نام بسته',
          category: 'دسته‌بندی',
          status: 'وضعیت',
          nominalAmount: 'مبلغ اسمی',
          paymentAmount: 'مبلغ پرداختی',
          remainingAmount: 'اعتبار باقی‌مانده',
          sendType: 'نوع ارسال',
          tag: 'برچسب',
          assignDateTime: 'تاریخ تخصیص',
          expireDate: 'تاریخ انقضا',
        },
      },
      smsPackageCategories: {
        title: 'دسته بندی پکیج ها',
        form: {
          addTitle: 'دسته بندی پکیج جدید',
          editTitle: 'ویرایش دسته بندی پکیج',
          legends: {
            categoryInformation: 'اطلاعات دسته بندی',
          },
          fields: {
            latinId: 'شناسه لاتین',
            minimumCoefficient: 'حداقل ضریب',
            maximumCoefficient: 'حداکثر ضریب',
            order: 'ترتیب نمایش',
            organizationsForFilter: 'فیلتر سازمان ها',
            smsPackagesCount: 'تعداد بسته',
            showInCatalog: 'نمایش در کاتالوگ',
          },
        },
      },
      smsPackageDiscounts: {
        title: 'کد های تخفیف پکیج ها',
        form: {
          addTitle: 'افزودن کد تخفیف پکیج',
          editTitle: 'ویرایش کد تخفیف پکیج',
          legends: {
            discountInformation: 'مشخصات کد تخفیف',
            calculationType: 'نوع محاسبه تخفیف',
            percentageSettings: 'تنظیمات تخفیف درصدی',
            amountSettings: 'تنظیمات تخفیف مبلغی',
          },
          hints: {
            calculationType:
              'انتخاب کنید تخفیف به صورت درصدی یا مبلغ ثابت محاسبه شود.',
          },
          fields: {
            code: 'کد تخفیف',
            smsPackageCategory: 'دسته بندی پکیج',
            smsPackageCategoryTitle: 'دسته بندی پکیج',
            isPercentage: 'تخفیف درصدی',
            percentage: 'درصدی',
            percentageDescription: 'کاهش درصدی از مبلغ بسته پیامک',
            amount: 'مبلغی',
            amountDescription: 'کسر مبلغ ثابت از قیمت بسته پیامک',
            discountPercent: 'درصد تخفیف',
            discountAmount: 'مبلغ تخفیف',
            maximumDiscountAmount: 'حداکثر میزان تخفیف',
            maximumUseCount: 'حداکثر تعداد استفاده',
            maximumUseCountPerOrganization: 'حداکثر تعداد استفاده هر سازمان',
            description: 'توضیحات',
          },
          preview: {
            title: 'پیش‌نمایش',
            subtitle: 'خلاصه زنده از تنظیمات تخفیف شما',
            noCode: 'کد تخفیف',
            percentUnit: 'درصد',
            allOrganizations: 'همه سازمان‌ها',
            selectedOrganizations: 'سازمان‌های انتخاب‌شده',
            percentageBadge: 'تخفیف درصدی',
            amountBadge: 'تخفیف مبلغی',
            discountWord: 'تخفیف',
            note: 'این یک پیش‌نمایش است و پس از ایجاد، تخفیف در سیستم اعمال خواهد شد.',
          },
        },
      },
      packageOrganizations: {
        title: 'خرید بسته پیامک',
        expirationTypes: {
          0: 'ساعته',
          1: 'روزه',
          2: 'هفته ای',
          3: 'ماهه',
        },
        expirationNames: {
          0: 'ساعتی',
          1: 'روزانه',
          2: 'هفتگی',
          3: 'ماهانه',
        },
        packageOrganizationsCard: {
          legend: 'خرید بسته پیامک',
          discountCodeForOrganizationPackagePrice: 'کد تخفیف',
          packageOrganizationPrice: 'قیمت بسته پیامک',
          buyPackage: 'خرید بسته',
          discountCode: 'کد تخفیف',
          discountPercent: 'درصد تخفیف',
          typeName: 'نوع بسته',
          discount: 'تخفیف',
          expirationType: 'نوع انقضا',
          organizationPackagePriceDetailsBought:
            'مشخصات بسته پیامکی خریداری شده',
          expiration: 'نوع بسته',
          wrongDiscountCodeMessage: 'کد تخفیف وارد شده صحیح نمی‌باشد',
          successfulDiscountSubmitation: 'کد تخفیف با موفقیت ثبت شد.',
        },
      },
      privateNumbersPrice: {
        title: 'قیمت خطوط',
        form: {
          addTitle: 'افزودن قیمت خط',
          editTitle: 'ویرایش قیمت خط ',
          fields: {
            isRound: 'شماره رند',
            numberOfDigits: 'تعداد ارقام',
            reservationPeriod: 'مدت زمان رزرو (روز)',
            reservationPeriodWithoutDay: 'مدت زمان رزرو',
          },
          legends: {
            privateNumberPriceInformation: 'مشخصات خرید خط',
          },
          messages: {
            alert1:
              'در صورت انتخاب <b class="font-bold">شماره رند</b>، <b class="text-danger">در فیلد عنوان نوع رند بودن مشخص شود</b>.( مثال : رند 2 رقمی )',
            alert2:
              'در صورت انتخاب عدد صفر برای فیلد مدت زمان رزرو ، مدت زمان رزرو اعمال نخواهد شد.',
          },
        },
      },
      privateNumberPricePolicies: {
        title: 'قوانین قیمت گذاری و تمدید',
        automaticRenewConfiguration: {
          title: 'تنظیمات تمدید خودکار',
          openButton: 'تنظیمات تمدید خودکار',
          fields: {
            cardTitle: 'پیکربندی تمدید خودکار',
            daysGuide:
              'تعداد روزهای باقی‌مانده تا انقضای خط را برای هر عملیات مشخص کنید. با رسیدن به زمان تعیین‌شده برای یادآوری، به کاربر اطلاع داده می‌شود که خط در آستانهٔ انقضاست. با رسیدن به زمان تعیین‌شده برای تمدید خودکار، سیستم بدون نیاز به اقدام دستی خط را تمدید و هزینه را کسر می‌کند.',
            startSendNotificationDays:
              'چند روز مانده به انقضا، یادآوری آغاز شود؟',
            decreasePriceDays:
              'چند روز مانده به انقضا، تمدید خودکار انجام شود؟',
            retryType: 'تعداد تلاش مجدد برای تمدید خودکار',
            hourOfExecution: 'ساعت اجرا',
            enableAutomaticRenewForServiceNumbers:
              'تمدید خودکار برای خطوط خدماتی',
          },
        },
        form: {
          addTitle: 'افزودن سیاست قیمت‌گذاری خط اختصاصی',
          editTitle: 'ویرایش سیاست قیمت‌گذاری خط اختصاصی',
          fields: {
            cardTitle: 'سیاست قیمت‌گذاری',
            privateNumberHeadline: 'سرشماره خط اختصاصی',
            percentOfBasePriceForRenew: 'درصد تمدید سالانه',
            graceDaysAfterDueDate: 'تعداد روز ارفاق',
            digitPricePolicies: 'قوانین قیمت‌گذاری تعداد ارقام',
            digitsCount: 'تعداد ارقام',
            price: 'قیمت',
            addDigitPricePolicy: 'افزودن سیاست قیمت',
          },
        },
      },
      existPrivateNumbers: {
        title: 'موجودی خط',
        form: {
          editTitle: 'ویرایش قیمت خط',
          addTitle: 'تعریف دستی سطح',
          legend: 'تعریف سطح',
          fields: {
            id: 'شناسه',
            number: 'شماره خط',
            privateNumberHeadline: 'سرشماره',
            digitsCount: 'تعداد ارقام',
            price: 'قیمت',
            created: 'تاریخ ثبت',
            totalScore: 'امتیاز کل',
            rondTier: 'سطح رندی',
            rondRuleCodes: 'قوانین رندی',
            enableSendTypes: 'نوع ارسال‌های مجاز',
            refundDeliveryStatusId: 'وضعیت بازگشت هزینه',
            smsSenderAgentId: 'عامل ارسال',
            createdManually: 'ثبت دستی',
            ruleCode: 'کد قانون',
            sample: 'نمونه',
          },
        },
      },
      privateNumberForBuyRanges: {
        title: 'بازه‌های خرید خط',
        detail: {
          title: 'جزئیات بازه خرید خط',
        },
        form: {
          addTitle: 'تعریف بازه خرید خط',
          legend: 'بازه خرید خط',
          fields: {
            id: 'شناسه',
            prefixNumber: 'بخش ثابت',
            privateNumberHeadline: 'سرشماره خط اختصاصی',
            fromSuffix: 'از شماره',
            toSuffix: 'تا شماره',
            buyByRangeEnable: 'فعال بودن خرید بازه‌ای',
            buyRangeDiscountPercents: 'تخفیف خرید بازه‌ای',
            lowerBound: 'حداقل تعداد ',
            discountPercent: 'درصد تخفیف',
            canSendLink: 'امکان ارسال لینک',
            created: 'تاریخ ثبت',
            enableSendTypes: 'نوع ارسال‌های مجاز',
            organizationMaximumBuyCount: 'حداکثر خرید هر سازمان',
            refundDeliveryStatusTitle: 'وضعیت بازگشت هزینه',
            refundDeliveryStatusId: 'وضعیت بازگشت هزینه',
            removeGoldRondNumbersFromStore: 'حذف خطوط رند طلایی از فروشگاه',
            showInStore: 'نمایش در فروشگاه',
            singleBuyEnable: 'فعال بودن خرید تکی',
            smsSenderAgentName: 'عامل ارسال پیامک',
            smsSenderAgentId: 'عامل ارسال پیامک',
            temporaryReservationMinutes: 'مدت رزرو موقت (دقیقه)',
            temporaryReservationMinutesForRange: 'مدت رزرو موقت بازه (دقیقه)',
            addDiscountPercent: 'افزودن ردیف تخفیف',
          },
        },
      },
      privateNumbersPriceForUser: {
        title: 'خرید خط برای کاربران',
        form: {
          fields: {
            isRound: 'شماره رند',
            numberOfDigits: 'تعداد ارقام',
            reservationPeriod: 'مدت زمان رزرو (روز)',
            reservationPeriodWithoutDay: 'مدت زمان رزرو',
            privateNumberPriceNumber: 'شماره خط',
            numberPrice: 'قیمت خط',
          },
          legend: 'خرید خط',
          messages: {
            privateNumberPriceDetailsBought: 'مشخصات خط خریداری شده',
            privateNumberPriceAuthenticationAfterBuy:
              'کاربر گرامی برای ارسال پیامک با این شماره لازم است جهت احراز هویت خط اقدام نمائید.',
            privateNumberPriceAuthentication:
              'کاربر گرامی بعد از خرید خط لازم است جهت احراز هویت خط خریداری شده اقدام نمائید.',
            privateNumberPriceNumber: 'شماره خط موردنظر خود را وارد کنید',
            discountCodeForPrivateNumberPrice:
              'اگر برای خرید خط کد تخفیف دارید وارد کنید',
            PrivateNumberPriceWithoutAuthentication:
              'توجه داشته باشید امکان استفاده از خطوط احراز هویت نشده وجود ندارد.',
            notPossibleToChangeTheRequestedRegistrationNumber:
              'با توجه به عدم امکان تغییر در سرشماره درخواستی، لطفا دقت داشته باشد که شماره تکراری نباشد.',
            PrivateNumberPriceDeleteOrCancel:
              '<span class="text-danger">*</span> <span>درخواست ثبت سرشماره انتخاب شده، قابل تغییر، حذف یا انصراف <b class="text-danger">نمی‌باشد</b>. لذا خواهشمند است در این مورد دقت لازم را بعمل آورید. </span>',
            PrivateNumberPriceDeleteOrCancelAfterBuy:
              '<span class="text-danger">*</span> <span>ضمن تشکر از حسن انتخاب شما؛ به اطلاع میرساند درخواست ثبت سرشماره انتخاب شده، قابل تغییر، حذف یا انصراف <b class="text-danger">نمی‌باشد</b>. لذا خواهشمند است در این مورد دقت لازم را بعمل آورید.</span>',
          },
        },
        rules: {
          buyNumberRule1:
            'با اصول و مبانی دین اسلام و قانون اساسی جمهوری اسلامی ایران مغایرت نداشته و در تضاد نباشد.',
          buyNumberRule2: 'باعث تشویش اذهان عمومی نگردد.',
          buyNumberRule3: 'مخل نظم و آرامش حاکم بر جامعه نباشد.',
          buyNumberRule4: 'به اخلاق حسنه حاکم برجامعه آسیب نرساند.',
          buyNumberRule5:
            'با سیاست‌های فرهنگی، اجتماعی و اقتصادی کشور مغایرت نداشته باشد.',
          buyNumberRule6:
            'مغایر بااصول انتخاباتی و قوانین حاکم بر جامعه نباشد.',
          buyNumberRule7:
            'عدم تحریک، تشویق، ترغیب، تهدید یا دعوت به فساد و فحشاء و ارتکاب جرایم منافی عفت یا انحرافات جنسی(قانون جرائم رایانه‌ای و ماده639 قانون مجازات اسلامی)',
          buyNumberRule8:
            'عدم اشاعه فحشاء و منکرات در جامعه (بند2 ماده6 قانون مطبوعات)',
          buyNumberRule9:
            'عدم انتشار، توزیع و معامله محتوای خلاف عفت عمومی (مبتذل و مستهجن) (بند2 ماده 6 قانون مطبوعات و ماده14 قانون جرائم رایانه‌ای) تحریک، تشویق، ترغیب، تهدید یا تطمیع افراد به دستیابی به محتویات مستهجن و مبتذل (ماده515 قانون جرایم رایانه ای)',
          buyNumberRule10:
            'عدم اهانت به امام خمینی (ره) و تحریف آثار ایشان (ماده514 قانون مجازات اسلامی)',
          buyNumberRule11:
            'عدم اهانت به مقام معظم رهبری و سایر مراجع تقلید (بند7 ماده6 قانون قانون مطبوعات)',
          buyNumberRule12:
            'عدم انتشار محتوا علیه اصول قانون اساسی (بند12 ماده6 قانون مطبوعات)',
          buyNumberRule13:
            'عدم فاش نمودن و انتشار غیر مجاز اسرار نیروهای مسلح و نقشه و استحکامات نظامی (بند 6 ماده 6 قانون مطبوعات)',
          buyNumberRule14:
            'عدم انتشار هرگونه محتوا با هدف ترغیب و تشویق مردم به تحریم و یا کاهش مشارکت در انتخابات (بند 3 و 8ماده 66 قانون انتخابات مجلس شورای اسلامی و ماده46 آیین نامه اجرایی)',
          buyNumberRule15:
            'رعایت کلیه ضوابط محتوایی نشر دیجیتال (ضوابط ارائه محصولات فرهنگی دیجیتال)',
          buyNumberRule16:
            'انتشار محتوای دیجیتال که به شرح ذیل، مخل مبانی اسلام و حقوق عمومی باشد ممنوع است:',
          buyNumberRule16_1:
            'تخریب هویت ملی و تمسخر باورها، آیین ها و زبان های دینی',
          buyNumberRule16_2:
            'ترویج ناهنجاری های اجتماعی، منبهات اجتماعی و خرده فرهنگ های مغایر با شریعت اسلامی',
          buyNumberRule16_3:
            'تبلیغ و ترویج فرقه‌های انحرافی، عرفان‌های کاذب و سبک‌های زندگی مخالف با شریعت اسلامی',
        },
      },
      childrenPrivateNumberBuyRequests: {
        title: 'لیست درخواست های خرید خط',
        updateStatusPrivateNumberPriceTitle: 'ویرایش وضعیت درخواست خرید خط',
        form: {
          fields: {
            rejectionDescription: 'دلیل رد درخواست',
            payAmount: 'مبلغ پرداخت',
            isAllowedSendLink: ' ارسال لینک',
            isService: 'خط خدماتی',
            privateNumberPriceIsRound: 'شماره رند',
            privateNumberPriceNumberOfDigits: 'تعداد ارقام',
            privateNumberPriceTitle: 'عنوان خط',
            reservationDate: 'تاریخ رزرو',
            assignmentDate: 'تاریخ اختصاص',
            cancellationDate: 'تاریخ لغو',
          },
        },
      },
      privateNumberRondRules: {
        title: 'قوانین رند و قیمت',
      },
      rondRules: {
        title: 'قوانین رند و قیمت',
        form: {
          calculateTitle: 'تست شماره',
          fields: {
            rondTier: 'سطح رندی',
            lowerBoundOfScore: 'حداقل امتیاز',
            coefficient: 'ضریب',
            fullNumber: 'شماره کامل',
            isExists: 'موجود در فروشگاه',
            totalScore: 'امتیاز کل',
            price: 'قیمت',
            digits: 'رقمی',
          },
          numberRequired: 'برای محاسبه، لطفاً شمارهٔ موردنظر را وارد کنید.',
          calculationInfo:
            'امتیاز، سطح رندی و قیمت شماره بر اساس مقادیر ثبت‌شده در جدول‌های «قوانین رند» و «تعریف سطح» محاسبه می‌شوند. برای اعمال تغییرات این جدول‌ها در نتیجه، ابتدا آن‌ها را ثبت کنید و سپس محاسبه را دوباره انجام دهید.',
          scoreValidationInfo:
            'امتیاز هر قانون باید عدد صحیحی بین ۰ تا ۲۰ باشد.',
          coefficientValidationInfo:
            'حداقل امتیاز باید عدد صحیحی بین ۰ تا ۱۰۰ باشد؛ ضریب نیز باید بین ۰ تا ۱۰۰ باشد و مقدار اعشاری می‌پذیرد.',
        },
      },
      privateNumberBuyRequests: {
        title: 'درخواست های خرید',
        form: {
          fields: {
            rejectionDescription: 'دلیل رد درخواست',
            payAmount: 'مبلغ پرداخت',
            isAllowedSendLink: 'ارسال لینک',
            isService: 'سرویس',
          },
        },
        privateNumberUploadDocuments: {
          title: 'آپلود مدارک',
          form: {
            title: ' مدارک',
            addTitle: 'آپلود مدارک',
            fields: {
              FoundedAnnounce: 'اطلاعیه ی تاسیس',
              CertificateAddedValue: 'گواهی ارزش افزوده',
              CompanyStatute: 'اساسنامه شرکت',
              MinutesCompanyChanges: 'دقایق تغییرات شرکت',
              NationalCard: 'کارت ملی',
              BirthCertificate: 'شناسنامه',
              documentStatus: 'وضعیت',
              description: 'توضیحات',
            },
          },
        },
        privateNumberDocuments: {
          title: ' مدارک',
          form: {
            title: 'تایید احراز هویت',
            addTitle: 'تایید احراز هویت',
            legend: 'فرم تایید احراز هویت',
            fields: {
              FoundedAnnounce: 'اطلاعیه ی تاسیس',
              CertificateAddedValue: 'گواهی ارزش افزوده',
              CompanyStatute: 'اساسنامه شرکت',
              MinutesCompanyChanges: 'دقایق تغییرات شرکت',
              NationalCard: 'کارت ملی',
              BirthCertificate: 'شناسنامه',
              documentStatus: 'وضعیت',
              description: 'توضیحات',
            },
          },
        },
      },
      organizationPackages: {
        title: 'بسته های سازمان',
      },
      childrenOrganizationsPackages: {
        title: 'بسته های سازمان های زیرمجموعه',
      },
      landingPageList: {
        title: 'لیست صفحات وب',
        form: {
          fields: {
            shortUrl: 'آدرس لینک کوتاه',
          },
        },
      },
      readyTemplates: {
        title: 'قالب های آماده',
        form: {
          fields: {
            templatePreview: 'پیش نمایش قالب',
          },
        },
      },
      landingPage: {
        title: 'مدیریت صفحه وب',
        goFullScreen: 'تمام صفحه',
        exitFullScreen: 'حالت عادی',
        desginer: 'ویرایشگر بصری',
        cssEditor: 'ویرایشگر CSS',
        jsEditor: 'ویرایشگر Javascript',
        compileAndInjectScss: 'کمپایل و تزریق به صفحه',
        injectJs: 'تزریق کد جاوا اسکریپت به صفحه',
        previewInDesktop: 'پیش نمایش در مانیتور',
        previewInTablet: 'پیش نمایش در تبلت',
        previewInMobile: 'پیش نمایش در تلفن همراه',
        previewMode: 'پیش نمایش یا ویرایشگر',

        emptyDesignArea: 'خالی شدن کل طراحی',
        htmlEditor: 'ویرایشگر Html',
        selectFromTemplates: 'انتخاب از قالب های آماده',
        saveLandingPage: 'ذخیره لندینگ پیج',
        saveAsTemplate: 'ذخیره به عنوان قالب جدید',
        saveAsShortLinkTemplate: 'ثبت به عنوان قالب لینک کوتاه',
        ShortLinkAddress: 'آدرس لینک کوتاه',
        selectPageFavIcon: 'انتخاب تصاویر',
        save: 'ذخیره',
        ok: 'اعمال',
        isPublic: 'آیا برای سایرین در دسترسی باشد',
        templatePreview: 'پیش نمایش قالب',
        templateTitle: 'عنوان قالب',
        NoTemplateDeclared: 'هیچ قالبی تعریف نشده است',
        readyTemplateImported: 'قالب آماده بارگذاری شد',
        saveAsReadyTemplate: 'ذخیره به عنوان قالب آماده',
        readyTemplateSaved: 'قالب با موفقیت ثبت گردید',
        landingPageSaved: 'صفحه شخصی ذخیره شد',
        selectTemplatePreview: 'انتخاب قالب پیش نمایش',
        ComponentMostNotRunOnMobileDevice:
          'کاربر گرامی طراحی صفحات فقط با کامپیوتر و لپتاپ امکان پذیر می باشد.',
        selectTemplate: 'انتخاب قالب',
        pageSettings: 'تنظیمات صفحه',
        ide: {
          categories: {
            writing: 'نوشتار',
            H1: 'H1',
            H2: 'H2',
            H3: 'H3',
            H4: 'H4',
            H5: 'H5',
            H6: 'H6',
            Image: 'تصاویر',
            Text: 'پاراگراف',
            Div: 'Div',
            Row: 'سطر',
            Col: 'ستون',
            BlockQuate: 'نقل قول',
            Alert: 'هشدار',
            Button: 'کلید',
            ButtonGroup: 'لیست کلیدها',
            Cards: 'کارت ها',
            EmptyCard: 'کارت خالی',
            DefaultCard: 'کارت معمولی',
            CardWithLink: 'کارت با لینک',
            ProductCard: 'کارت معرفی محصول',
            CardBody: 'بدنه کارت',
            CardHeader: 'سربرگ کارت',
            CardFooter: 'پاورقی کارت',
            ProductProperties: 'مشخصات محصول',
            Property: 'ویژگی',
            CardLink: 'لینک کارت',
            Forms: 'فرم ها',
            EmptyForm: 'فرم خالی',
            TextInput: 'ورودی متن',
            NumberInput: 'ورودی عددی',
            EmailInput: 'ورودی ایمیل',
          },
          element: {
            pleaseentertitle: 'عنوان را بنویسید',
            h1: 'سرفصل 1',
            h2: 'سرفصل 2',
            h3: 'سرفصل 3',
            h4: 'سرفصل 4',
            h5: 'سرفصل 5',
            h6: 'سرفصل 6',
            image: 'تصاویر',
            text: 'متن',
            html: 'محتوای html',
            row: 'سطر',
            col: 'ستون',
            blockquata: 'نقل قول',
            blockquatatitle: 'عنوان نقل قول',
            blockquatasource: 'منبع نقل قول',
            blockquatasourcetext: 'منبع ',
            blockquatasourcetitle: 'عنوان منبع',
            alerttext: 'متن هسدار',
            button: 'کلید',
            buttentitle: 'عنوان کلید',
            buttongroup: 'لیست کلید ها',
            defaultcard: 'کارت معمولی',
            cardheader: 'سربرگ کارت',
            cardbody: 'بدنه کارت',
            cardfooter: 'پاورقی کارت',
            cardtext: 'متن کارت',
            paragraphtext: 'متن درون پاراگراف',
            cardwithlink: 'کارت با لینک',
            subtitle: 'زیر عنوان',
            pleaseenetersubtitle: 'متن عنوان ثانویه را وارد کنید',
            firstlink: 'لینک اول',
            product: 'محصول',
            productdescription: 'توضیحات محصول',
            prodcutproperties: 'ویژگی های محصول',
            secondlink: 'لینک دوم',
            productproperty: 'ویژگی محصول',
            property: 'ویژگی',
            properties: 'ویژگی ها',
            link: 'لینک',
            linktext: 'متن لینک',
            form: 'فرم',
            textinput: 'ورودی متن',
            numberinput: 'ورودی عددی',
            emailinput: 'ورودی پست الکترونیکی',
          },
        },
      },
      voiceMessagesGroup: {
        title: 'گروه صداها',
        form: {
          editTitle: 'ویرایش گروه صدا ',
          addTitle: 'گروه صدا جدید',
        },
      },
      voiceMessages: {
        title: 'صداها',
        form: {
          addTitle: 'افزودن پیام صوتی ',
          editTitle: 'ویرایش وضعیت',
          fields: {
            voiceFile: 'فایل صوتی',
            voiceText: 'متن موردنظر',
            sendingMethod: 'روش ارسال',
          },
          legends: {
            voiceInformation: 'مشخصات فایل صوتی',
            uploadVoiceFile: 'آپلود فایل',
            voiceReader: 'آواخوان',
          },
          messages: {
            generalExplanation:
              '<span> ● جهت ایجاد فایل صوتی ، در ابتدا یک عنوان برای فایل صوتی خود انتخاب نمائید.</span><span class="mt-1"> ● در ادامه می توانید با یکی از روش های ارسال <b>آپلود فایل</b> یا <b>آواخوان (ابزار تبدیل متن به گفتار ) </b>فایل صوتی خود را ایجاد نمایید.</span><b class="text-danger mt-1"> ● توجه داشته باشید هر بخش پیامک معادل 30 ثانیه است .</b>',
            fileUploadGuid:
              '<span> ● در این روش شما می توانید فایل صوتی خود را بارگذاری کنید.</span><span> ● فرمت مجاز فایل صوتی<b>MP3 , WAV</b>و حداکثر حجم مجاز فایل<b> 5 مگابایت </b>می باشد.</span>',
            textToVoiceGuid:
              '<span> ● در این روش شما می توانید فایل صوتی خود را با استفاده از ابزار تبدیل متن به گفتار ایجاد نمائید.</span><span> ● در ابتدا جنسیت صدای گوینده گفتار را مشخص کنید.</span><span> ● در ادامه متن موردنظر خود را بنوسید . برای اینکه گفتار واضح تری داشته باشید از حروف تنوین استفاده نمائید.</span><span> ● در نهایت با زدن کلید پخش متن موردنظر به گفتار تبدیل می شود.</span>',
          },
        },
        textToVoiceConvertor: {
          delay: 'تاخیر',
          kasre: 'کسره',
          fathe: 'فتحه',
          zame: 'ضمه',
          tashdid: 'تشدید',
          sokoon: 'سکون',
        },
      },
      medias: {
        title: 'فایل های شبکه اجتماعی',
        form: {
          addTitle: 'افزودن فایل های شبکه اجتماعی ',
          editTitle: 'ویرایش وضعیت',
          fields: {
            fileSizePerKilobyte: 'سایز فایل(Kb)',
            fileTypes: 'نوع فایل',
            url: 'فایل',
          },
        },
      },
      resellerUsers: {
        title: 'کاربران فروشنده',
        form: {
          addTitle: ' کاربر جدید',
          editTitle: 'ویرایش اطلاعات کاربر',
          fields: {
            foreignerCode: 'کد اتباع',
            zoneId: 'منطقه',
            password: 'کلمه عبور',
            secondPassword: 'کلمه عبور دوم',
            isAdmin: 'مدیر',
            isAuthenticatedMobile: 'تایید موبایل',
            roleTemplateId: 'قالب نقش',
            nationalCode: 'کدملی/کداتباع',
            isActiveSend: 'ارسال فعال',
            isAuthenticated: 'احرازهویت',
            parentOrganizationName: 'سازمان والد',
            roles: 'نقش ها',
            isSendSmsDescriptionRequired:
              'اجباری بودن توضیحات موقع ارسال کاربران',
            isCanSeeContactsOfPrivatePhonebooks: 'مشاهده مخاطبین دفترچه خصوصی',
            isCanSeeContactsOfPublicPhonebooks: 'مشاهده مخاطبین دفترچه خصوصی',
            isCanSendSmartWithoutConfirmation:
              'امکان ارسال مکان محور بدون تایید',
          },
          legends: {
            personalInformation: 'مشخصات کاربری',
            systemInformation: 'مشخصات سیستمی',
            authentication: 'احراز هویت ',
            roleInformation: 'نقش ها',
          },
        },
      },
      resellerOrganization: {
        title: 'لیست سازمان فروشنده',
        organizationsExcel: 'دانلود اکسل سازمان های فروشنده',
        form: {
          fields: {
            isActiveSend: 'ارسال فعال',
            isActive: 'فعال',
            isRealPerson: 'حقیقی',
            isAuthenticated: 'احرازهویت',
            groupPriceCategoryTitle: 'تعرفه',
            groupPriceTitle: 'بازه',
            domainName: 'دامنه',
            panelPrice: 'قیمت پنل',
            isPostpaid: 'پس پرداخت',
          },
        },
      },
      userStatuses: {
        title: 'لیست وضعیت کاربران ',
        form: {
          addTitle: 'وضعیت جدید',
          editTitle: 'ویرایش وضعیت',
        },
      },
      discount: {
        title: 'تخفیف ها',
        discountUse: 'تخفیف های اعمال شده',
        form: {
          addTitle: 'افزودن تخفیف',
          editTitle: 'ویرایش تخفیف',
          fields: {
            discountCode: 'کد تخفیف',
            discountType: 'نوع تخفیف',
            isPercentage: 'تخفیف درصدی',
            discountPercentageValue: 'درصد تخفیف',
            discountValue: 'مبلغ تخفیف',
            maximumAmount: 'حداکثر میزان تخفیف',
            maximumUse: 'حداکثر تعداد استفاده',
            specialOrganization: 'سازمان ویژه',
          },
          legends: {
            discountInformation: 'مشخصات تخفیف',
          },
        },
      },
      excelRequest: {
        title: 'درخواست اکسل',
        form: {
          changeStatusTitle: 'تغییر وضعیت',
          fields: {
            path: 'مسیر',
            type: 'نوع',
            isReadyForDownload: 'آماده دانلود',
            errors: 'خطا ها',
          },
        },
      },
      plans: {
        title: 'پلن ها',
        plansManagementTitle: 'مدیریت پلن ها',
        form: {
          addTitle: 'تعریف پلن جدید',
          editTitle: 'ویرایش پلن',
          legends: {
            planSpecifications: 'مشخصات پلن',
            modules: 'ماژول ها',
          },
          tabs: {
            planSpecifications: 'مشخصات پلن',
            menusClaims: 'منوها و دسترسی ها',
          },
          fields: {
            planType: 'نوع پلن',
            extentionPrice: 'هزینه تمدید',
            planInformation: 'اطلاعات پلن',
            planPrice: 'قیمت پلن',
            subTitle: 'زیرعنوان',
            tag: 'برچسب',
            discountValue: 'تخفیف',
            availableModules: 'ماژول های موجود',
          },
        },
        planListModuleForUser: {
          title: 'خرید ماژول',
          form: {
            legend: 'خرید ماژول',
            PlanModuleBought: 'مشخصات پلن خریداری شده',
          },
        },
        planListPackageForUser: {
          title: 'خرید پکیج',
          form: {
            legend: 'خرید پکیج',
            PlanModuleBought: 'مشخصات پلن خریداری شده',
          },
          pricingPlans: {
            emptyPlans: 'در حال حاضر پلنی برای نمایش وجود ندارد.',
            loadError: 'دریافت پلن‌ها با خطا مواجه شد.',
            tryAgain: 'تلاش دوباره',
            currentPlan: 'پلن فعلی شما',
            free: 'رایگان',
            currency: 'ریال',
            discount: '٪ تخفیف',
            daysRemaining: 'روز تا پایان اعتبار',
            startFree: 'شروع رایگان',
            upgradePlan: 'ارتقا پلن',
          },
        },
      },
      zonePostalCodes: {
        title: 'کدپستی مناطق',
        form: {
          addTitle: 'ایجاد کدپستی مناطق',
          editTitle: 'ویرایش کدپستی مناطق',
          legend: 'اطلاعات کدپستی مناطق',
          fields: {
            otherCount: 'سایر',
            rightelCount: 'رایتل',
            mtnCount: 'ایرانسل',
            mciCount: 'همراه اول',
          },
        },
      },
      informationUsersSeen: {
        title: 'کاربران مشاهده کننده اخبار',
        fields: {
          seenDateTime: 'تاریخ مشاهده',
        },
      },
      sendSmartSmsToResidents: {
        title: 'ارسال مکان محور به ساکنین محدوده',
        createRequest: 'ایجاد درخواست',
        errors: {
          mostSelectPolygon:
            'برای ثبت درخواست می بایست حداقل یک محدوده را در نقشه مشخص کرده باشید.',
          mustSelectOperator: 'لطفا اپراتور را انتخاب کنید.',
        },
      },
      entireClubSmartSmsRequest: {
        title: 'درخواست ارسال مکان محور به تمامی شماره‌های باشگاه',
      },
      occasionScheduledMessage: {
        title: 'لیست درخواست های ارسال مناسبتی',
        form: {
          fields: {
            phonebookCustomFieldNameEn: 'فیلد سفارشی',
            calenderEvent: ' مناسبت تقویمی',
            toConsiderYear: '  سال در نظر گرفته شود',
            calenderOrganizationEvent: 'مناسبت سازمانی ',
            dynamicTemplateTitle: 'قالب پویا',
            howManyDaysSendItBeforeDueDate: 'ارسال قبل از تاریخ رویداد (روز)',
          },
        },
      },
      shortLinks: {
        title: 'لینک های کوتاه',
        descendantTitle: 'لینک های کوتاه سازمان های زیرمجموعه',
        form: {
          addTitle: 'ایجاد لینک کوتاه',
          legend: 'لینک کوتاه',
          advanceLegend: 'تنظیمات پیشرفته',
          smsAntiSpamDesc:
            'در صورتی که می خواهید از این لینک کوتاه در ارسال پیامک استفاده نمایید برای کاهش آمار اسپم شدن پیامک های ارسالی خود این ویژگی را فعال کنید. توجه داشته باشید فعال‌سازی این گزینه تنها به کاهش احتمال اسپم شدن پیامک‌های ارسالی کمک می کند.',
          constantPathDesc:
            'آدرس دلخواه به شما امکان می‌دهد علاوه بر لینک کوتاه با بخش تصادفی، یک عبارت دلخواه برای بخش پایانی لینک تعریف کنید. این آدرس اختصاصی به‌صورت موازی با لینک کوتاه ایجاد شده و هر دو شما را به مقصد موردنظر هدایت می‌کنند. توجه داشته باشید حداقل طول آدرس دلخواه باید ۵ کاراکتر باشد.',
          mostAppendQueryStringDesc:
            'پس از انجام ریدایرکت، تمامی Query String‌های موجود در لینک اصلی، کامل به لینک مقصد منتقل (Forward) می‌شوند.',
          fields: {
            shortUrl: 'لینک کوتاه',
            mainUrl: 'لینک اصلی',
            urlType: 'نوع سرویس',
            ShortLinkTypeOfUrl: 'نوع لینک کوتاه',
            customPageId: 'لیست قالب ها',
          },
        },
      },
      phonebookFileProgresses: {
        title: 'وضعیت ایجاد مخاطبین',
        fields: {
          fileName: 'نام فایل',
          status: 'وضعیت',
          phonebookId: 'شناسه دفترچه ',
          phonebookName: 'نام دفترچه',
          progressPercent: 'درصد پیشرفت',
          totalCount: 'تعداد کل',
        },
      },
      customerClubDevice: {
        title: 'تنظیمات دستگاه',
        form: {
          addTitle: 'ایجاد تنظیمات دستگاه',
          editTitle: 'ویرایش تنظیمات دستگاه',
          detailTitle: 'جزئیات تنظیمات دستگاه',
          legends: {
            generalInformation: 'اطلاعات کلی',
            details: 'پاسخ',
            phonebooksList: 'لیست دفترچه تلفن ها',
          },
          fields: {
            deviceId: 'شناسه دستگاه',
            webhookUrl: 'آدرس وب هوک',
            phonebookIdList: 'لیست شناسه های دفترتلفن',
            delayType: 'نوع تاخیر در ارسال',
            delayValue: 'میزان تاخیر در ارسال',
            isShowDetail: 'نمایش فرم جزئیات',
          },
        },
      },
      customerClubDeviceNumbers: {
        title: 'شماره های دستگاه',
      },
      frontAudits: {
        title: 'لاگ های فرانت',
      },
      calendarEvent: {
        title: 'مناسبت های تقویمی',
        calendarEvents: 'مناسبت های تقویمی',
        calenderOrganizationEvents: 'مناسبت های ایجاد شده سازمانی',
        form: {
          addTitle: 'ایجاد مناسبت',
          editTitle: 'ویرایش مناسبت',
          deleteTitle: 'حذف مناسبت',
          detailTitle: 'جزئیات مناسبت',
          filterTitle: 'فیلتر مناسبت ها',
          fields: {},
        },
      },

      smartSmsCampaigns: {
        title: 'لیست خاکستری',
        form: {
          addTitle: 'ایجاد لیست خاکستری ',
        },
      },
      smartSmsClubs: {
        title: 'لیست باشگاه مشتریان ',
        form: {
          addTitle: 'ایجاد باشگاه مشتریان مکان محور',
          addNumbersTitle: 'افزودن شماره به باشگاه',
        },
      },
      numbersAggregator: {
        title: 'استعلام اپراتور شماره ها',
        numbersAggregatorList: 'لیست استعلام اپراتور شماره ها',
      },
      numbersBlackLists: {
        title: 'استعلام لیست سیاه',
        numbersBlackListsList: ' استعلام لیست سیاه شماره ها',
      },
      contactsByCellPhone: {
        title: 'لیست مخاطبین',
        form: {
          editTitle: 'ویرایش مخاطبین',
          legend: 'اطلاعات مخاطب',
          fields: {
            contactCreateType: 'نوع ایجاد',
            job: 'شغل',
            phonebookTypes: 'نوع دفترچه تلفن',
          },
          messages: {
            description:
              'توجه: با ویرایش اطلاعات، مقادیر جدید جایگزین مقادیر قبلی میشوند.',
          },
        },
      },
      queuesStatistics: {
        title: 'آمار صف های ربیت',
        fields: {},
      },
      smartSmsClubFileProgresses: {
        form: {
          fields: {
            smartSmsClubTitle: 'عنوان ',
            progressPercent: 'درصد پیشرفت',
            failedReason: 'علت خطا',
            totalCount: 'تعداد کل',
            status: 'وضعیت',
          },
        },
      },
      fieldsManagement: {
        title: 'مدیریت فیلدها',
        form: {
          addTitle: 'ایجاد فیلد',
          editTitle: 'ویرایش فیلد',
          legend: 'اطلاعات فیلد',
          fields: {
            fieldType: 'نوع فیلد',
            maxValue: 'حداکثر مقدار',
            minValue: 'حداقل مقدار',
            maxLength: 'حداکثر تعداد کاراکتر',
            minLength: 'حداقل تعداد کاراکتر',
            regexValidation: 'Regex',
            maxFileSizeByMegabyte: 'حداکثر سایز فایل(مگابایت)',
          },
        },
      },
      formsManagement: {
        title: 'مدیریت فرم ها',
        newFormBuilderVersion: 'ورژن جدید ',
        form: {
          addTitle: 'ایجاد فرم',
          editTitle: 'ویرایش فرم',
          legend: 'اطلاعات فرم',
          fields: {
            fieldType: 'نوع فیلد',
            maxValue: 'حداکثر مقدار',
            minValue: 'حداقل مقدار',
            maxLength: 'حداکثر طول',
            minLength: 'حداقل طول',
            regexValidation: 'Regex',
            maxFileSizeByMegabyte: 'حداکثر سایز فایل(مگابایت)',
            theme: 'تم',
            field: 'فیلد',
            order: 'ترتیب',
          },
        },
      },
      ussdMenus: {
        title: 'لیست ussd',
        form: {
          addTitle: 'ایجاد',
          editTitle: 'ussd ویرایش',
          legend: 'ussd اطلاعات',
          changeStatusTitle: 'تغییر وضعیت ussd',
        },
        modal: {
          addSubmenu: 'اضافه کردن منو',
          operationType: 'نوع عملیات',
          submenuForExisting: 'زیرمنو برای گزینه موجود',
          newOption: 'گزینه جدید',
          selectOption: 'انتخاب گزینه:',
          select: '-- انتخاب کنید --',
          submenuTitle: 'عنوان زیرمنو:',
          submenuTitlePlaceholder: 'مثال: گزینه‌های شارژ',
          optionsCount: 'تعداد گزینه‌ها:',
          value: 'مقدار',
          optionTitle: 'عنوان گزینه',
          createSubmenu: 'ایجاد زیرمنو',
          newOptionWillBeAdded:
            'یک گزینه به منوی <b>{{ menu }}</b> اضافه میشود',
          newOptionTitle: 'عنوان گزینه جدید:',
          newOptionTitlePlaceholder: 'مثال: خدمات ویژه',
          optionNumber: 'شماره گزینه:',
          optionNumberPlaceholder: 'مثال: 9',

          submenuTitlePlaceholder2: 'مثال: انتخاب خدمت',
          submenuOptionsCount: 'تعداد گزینه‌های زیرمنو:',
          createOption: 'ایجاد گزینه جدید',
          duplicateError: 'شماره وارد شده تکراری است.',
          cannotBeThisValue: 'مقدار نمیتواند با صفر شروع شود.',
        },
        items: {
          addUSSDResponse: 'افزودن پاسخ USSD',
          option: 'گزینه',
          menuTitle: 'عنوان منو',
          menuOptions: 'لیست گزینه ها',
          title: 'عنوان',
          value: 'مقدار',
          currentOption: ' تعداد گزینه ها(<b>{{ length }}</b>) ',
          optionTitlePlaceholder: 'عنوان گزینه',
          optionValuePlaceholder: 'شماره گزینه',
          selectMenuToEdit: 'برای ویرایش یک منو باید انتخاب شود',
          menuTitlePlaceholder: 'عنوان منو انتخاب شده',
          sendSmsAsResponseToUser: 'ارسال پاسخ به کاربر',
          sendSmsToOtherNumber: ' ارسال به شماره دیگر',
          applyChanges: 'اعمال تغییرات',
          hasBackItem: 'دارای دکمه بازگشت',
        },
        messages: {
          valueCannotBeEmpty: 'پر کردن این فیلد الزامیست.',
          valueCannotBeValueEmpty: 'پر کردن فیلد مقدار الزامیست.',
          hasMenuSubMenu: 'این منو شامل صفحه بندی می شود',
          messageDelete:
            'آیا از حذف منوی "<strong>{{title}}</strong>" و تمام زیرمنوهای آن اطمینان دارید؟<br><br>⚠️ این عملیات قابل بازگشت نیست!',
          helpUssd:
            'برای ایجاد یا مدیریت ساختار USSD، ابتدا یک منو را انتخاب کنید.',
          helpEdit:
            'پس از انتخاب، جزئیات مربوط به منو در بخش "مشخصات " قابل مشاهده و ویرایش است.',
          addToMenu:
            'همچنین با انتخاب <b class="bg-primary p-[1px] mx-1 items-center inline-flex  pr-1 rounded-[3px] !text-white "><span>جدید</span><i class="mdi mdi-plus mdi-14px !text-white "></i> </b> میتوانید زیر منو جدید یا گزینه جدید برای منو انتخاب شده ثبت کرده و ساختار دلخواه خود را تکمیل کند.',
          reservedValue: 'مقدار 03 رزرو شده است و قابل استفاده نیست.',
          duplicatedValue: 'مقدار {{newValue}} قبلاً استفاده شده است!',
          selectedValueRequired:
            'مقادیر (03) و (00) برای ناوبری منو استفاده شده اند و قابل استفاده نیستند.',
          cantStartWithZero: 'مقدار نمیتواند با 0 شروع شود.',
          ussdSubmenuResponse:
            'این زیر منو دارای پاسخ ussd است بعد از اضافه کردن زیر منو پاسخ ussd حذف خواهد شد',
        },
      },

      smartSmsNumberClasses: {
        title: 'لیست کلاس ها',
        form: {
          addTitle: 'افزودن کلاس',
          editTitle: 'ویرایش کلاس',
          legend: 'اطلاعات کلاس',
          fields: {
            operatorClasses: 'کلاس های اپراتور',
          },
        },
      },
      checkNumberClassResponses: {
        title: 'لیست درخواست ها',
        form: {
          addTitle: '',
          editTitle: '',
          fields: {
            checkTime: 'زمان بررسی',
          },
        },
      },
      onlineSurveyList: {
        title: 'لیست نظرسنجی',
      },
      onlineSurveyResponses: {
        title: 'پاسخ های نظرسنجی',
      },
      onlineSurveyStatistics: {
        title: 'آمار نظرسنجی',
      },
      createSmsInformation: {
        title: 'ارسال خبر',
      },
      processTextResults: {
        title: 'تحلیل متن پیامک',
      },
      userNotificationSettings: {
        title: 'تنظیمات اعلان کاربر',
      },
      organizationNotificationSettings: {
        title: 'تنظیمات اعلان سازمان',
      },
      confirmationHistories: {
        title: 'تاریخچه تایید سازمانی ارسال ها',
        form: {
          fields: {
            scheduledMessageId: 'شناسه',
            confirmedBy: 'تایید کننده',
            confirmationLevel: 'سطح تایید',
          },
        },
      },
      buyNumberShahkarAuthorization: {
        title: 'احرازهویت خرید خط',
        description:
          'لطفاً برای تأیید هویت خریدار، فرآیند احراز هویت را انجام دهید تا مالکیت شماره تلفن همراه با اطلاعات هویتی مطابقت داده شود.',
        addAuthorization: 'احرازهویت خرید خط',
        editAuthorization: 'ویرایش احرازهویت خرید خط',
      },
    },
    enums: {
      Desktop: {
        MainDesktop: 'محیط کار پایه',
        OrangeDesktop: 'محیط کار نارنجی',
        WindowsDesktop: 'محیط کار ویندوز',
        AndroidDesktop: 'محیط کار اندروید',
        Default: 'پیش فرض',
        Dark: 'مشکی',
      },
      LoginTheme: {
        Default: 'پیش فرض',
        Dark: 'مشکی',
      },
      ComparisonOperator: {
        EqualTo: 'برابر با',
        NotEqualTo: 'به جز',
        GreaterThan: 'بیشتر از',
        GreaterThanOrEqual: 'برابر یا بیشتر از ',
        LessThan: 'کمتر از ',
        lessThanOrEqual: 'برابر یا کمتر از',
        Contains: 'شامل',
        NotContains: 'شامل نشود',
        StartsWith: 'شروع با',
        EndsWith: 'خاتمه با',
      },
      SenderAgentType: {
        SMS: 'SMS',
        MMS: 'MMS',
        Email: 'ایمیل',
        Voice: 'voice',
      },
      SmsCp: {
        Magfa: 'مگفا',
        Asanak: 'آسانک',
        Armaghan: 'ارمغان',
        RahyabRG: 'رهیاب رایانه گستر',
        RahyabPG: 'رهیاب پیام گستران',
        SLS: 'سرزمین هوشمند',
        Shreeweb: 'بین الملل (Shreeweb)',
        SocialNetworks: 'شبکه های اجتماعی',
        Avanak: 'آوانک',
        Gama: 'گاما',
        PishgamRayan: 'پیشگام رایان ',
      },
      TypePrivateNumber: {
        Bulk: 'Bulk',
        InteractiveBulk: 'InteractiveBulk',
        SmsMT: 'SmsMT',
        SmsMO: 'SmsMO',
        USSDMT: 'USSDMT',
        USSDMO: 'USSDMO',
        OPT: 'OPT',
      },
      SendPriority: {
        Lowest: 'بی اهمیت',
        VeryLow: 'خیلی کم',
        Low: 'کم',
        Normal: 'متوسط',
        AboveNormal: 'بالاتر از حد معمول',
        High: 'زیاد',
        VeryHigh: 'خیلی زیاد',
        Highest: 'فوری',
      },
      PrivateNumberUseForm: {
        OneNumber: 'تک شماره',
        Mask: 'نام تجاری',
        RangeNumber: 'شماره بازه ای',
      },
      ZoneType: {
        Country: 'کشور',
        Province: 'استان',
        City: 'شهر',
        Area: 'منطقه',
      },
      PeriodTypeValue: {
        Minute: 'دقیقه',
        Hour: 'ساعت',
        Daily: 'روز',
        Weekly: 'هفته',
        Monthly: 'ماه',
        Yearly: 'سال',
      },
      SmsSentPeriodType: {
        Minute: 'دقیقه ای',
        Hour: 'ساعتی',
        Daily: 'روزانه',
        Weekly: 'هفته ای',
        Monthly: 'ماهیانه',
        Yearly: 'سالیانه',
      },
      PeriodType: {
        Minute: 'دقیقه',
        Hour: 'ساعتی',
        Daily: 'روزانه',
        Second: 'ثانیه ',
      },
      SendSubTypes: {
        Direct: 'مستقیم',
        Gradual: 'تدریجی',
        Periodic: 'دوره ای',
        GradualPeriodic: 'تدریجی دوره ای',
        Voice: 'صوتی',
      },
      TypeBanks: {
        EghtesadNovin: 'اقتصاد نوین',
        Pasargad: 'پاسارگاد',
        Parsian: 'پارسیان',
        Tat: 'آینده',
        Tejarat: 'تجارت',
        Saman: 'سامان',
        Sepah: 'سپه',
        Shahr: 'شهر',
        Saderat: 'صادرات',
        Mehr: 'مهر',
        Keshavarzi: 'کشاورزی',
        Gardeshgari: 'گردشگری',
        Maskan: 'مسکن',
        Mellat: 'ملت',
        Melli: 'ملی',
      },
      SmartSmsStatus: {
        Done: 'تکمیل شده',
        Failed: 'ناموفق',
        InternalError: 'خطای داخلی',
        NotFound: 'پیدا نشد',
        Stored: 'ذخیره شده',
        Unknown: 'نامشخص',
        Waiting: 'در انتظار',
      },
      TypeIpGs: {
        Sadad: 'سداد',
        BehPardakht: 'به‌پرداخت',
        Aap: 'آپ',
        Top: 'تاپ',
        Saman: 'سامان',
        Sepehr: 'سپهر',
        IdPay: 'آیدی پی',
        IranKish: 'ایران کیش',
        Melli: 'ملی',
        ParbadVirtual: 'پرباد',
        Parsian: 'پارسیان',
        Pasargad: 'پاسارگاد',
        ZarinPal: 'زرین پال',
        PayIr: 'پی',
        Mellat: 'ملت',
        AsanPardakht: 'آسان پرداخت',
      },
      DeliveryStatus: {
        Unknown: 'نامشخص',
        SentAndReceivedbyPhone: 'ارسال موفق و دریافت توسط گوشی ',
        HaveNotReceivedToPhone: 'نرسیده به گوشی ',
        SentToItc: 'ارسال به مخابرات',
        ReceivedByItc: 'رسیده به مخابرات',
        DidNotReceiveToItc: 'نرسیده به مخابرات',
        NotReceivebyServer: 'توسط سرور دریافت نشده',
        ErrorInSending: 'خطا در ارسال',
        WaitingForSend: 'منتظر ارسال',
        Sent: 'ارسال شده',
        NotSent: 'ارسال نشده',
        Expired: 'منقضی',
        IsSending: 'در حال ارسال',
        IsCanceled: 'کنسل شده',
        BlackList: 'لیست سیاه',
        SmsIsFilter: 'متن پیامک فیلتر شده',
        IsDeleted: 'حذف شده',
        WatingForConfirmation: 'منتظر برای تایید',
        NotEnoughBalance: 'کمبود اعتبار',
        IsPreparing: 'درحال آماده سازی',
        IsPreparedForSending: 'آماده برای ارسال',
        AccessDenied: 'عدم دسترسی',
        TextIsEmpty: 'متن پیام خالی',
        InvalidInputXml: 'xml ورودی نامعتبر است',
        InvalidUserOrPassword: 'کاربر یا کلمه عبور نامعتبر',
        InvalidUsedMethod: 'متد استفاده شده نامعتبر ',
        InvalidSender: 'فرستنده نامعتبر',
        InvalidMobile: 'موبایل نامعتبر',
        InvalidReciption: 'هیچ گیرنده ای مشخص نشده',
        Stored: 'ذخیره شده',
        BlackListTable: 'وجود شماره در جدول بلک لیست ',
        GetDeliveryStatus: 'تقاضا جهت دریافت آخرین وضعیت',
        InvalidPrivateNumber: 'خط نامعتبر',
        NotReceiveByPhone: 'نرسیده به گوشی',
        NotReceivedByItc: 'نرسیده به مخابرات',
        DidNotReceivedByItc: 'نرسیده به مخابرات',
        ReceivedByPhone: 'رسیده به گوشی ',
      },
      SendStatus: {
        Unknown: 'نامشخص',
        Sent: 'به اپراتور ارسال شده',
        SentAndGiveBackCredit: 'ارسال شده و برگشت هزینه بررسی شده',
        ErrorInSending: 'خطا در ارسال',
        ErrorInGetItc: 'خطا در دریافت مخابرات',
        BlackList: 'لیست سیاه',
        Stored: 'ذخیره شده',
      },
      MainSettings: {
        SendSmsAlertMessage: ' هشدار ارسال پیامک',
        AppPath: 'مسیر نرم افزار',
        RemoteQueueIp: 'آی پی صف از راه دور',
        DefaultNumber: 'شناسه شماره پیش فرض ',
        IsRemoteQueue: 'صف از راه دور',
        VasRegisterSmsText: 'متن پیامک ثبت خدمات ارزش افزوده',
        MaximumFailedTryCount: 'حداکثر تعداد تلاش ناموفق',
        RetrievePasswordSmsText: 'متن پیامک بازیابی کلمه عبور',
        RegisterFishMobiles:
          'موبایل هایی که باید بعد از ثبت فیش برای آن ها پیامک ارسال شود',
        OnlinePaymentSmsText: ' پیامک پرداخت آنلاین',
        UserExpireSmsText: ' پیامک انقضا کاربر',
        RegisterFishSmsText: ' پیامک ثبت فیش',
        ExportFileAddress: 'آدرس فایل خروجی',
        Tax: 'مالیات',
        AuthenticatedMobileSmsText: 'متن پیامک احراز هویت موبایل',
        LowestCreditOfUser: 'کمترین میزان موجودی کاربر',
        ResolutionOfParliament: 'مصوبه مجلس',
      },
      GenderType: {
        All: 'نامشخص',
        Man: 'مرد',
        Woman: 'زن',
      },
      SimType: {
        All: 'هیچکدام',
        Credits: 'اعتباری',
        Permanent: 'دائمی',
      },
      FailureCode: {
        None: 'بدون خطا',
        UserCreditNotEnough: 'کمبود موجودی',
        AdminCreditNotEnough: 'کمبود موجودی مدیریت',
        PrivateNumberIsExpired: 'خط منقضی شده  ',
        UserIsInactive: 'کاربر غیر فعال ',
        AdminIsInactive: 'نام کاربری مدیر غیرفعال  ',
        PrivateNumberNotValid: 'خط معتبر نیست ',
        NotDefineSmsRateType: 'تعرفه ارسال پیامک  تعیین نشده  ',
        SendError: 'خطا در ارسال پیامک',
        UserCancelRequest: 'کاربر از انجام تراکنش منصرف شده ',
        SystemIsOutOfService: 'سرویس ارسال در دسترس نمی باشد',
        SendTimeNotValid: 'زمان ارسال خارج از بازه مجاز ارسال می باشد',
        SmsTextIsFilter: 'متن پیامک فیلتر می باشد',
        UserIsExpired: 'حساب کاربری منقضی شده ',
        AdminIsExpired: 'حساب مدیریت منقضی شده ',
        LinkIsNotAllowed: 'مجوز ارسال لینک برا شما فعال نمی باشد',
        RecipientNotExist: 'خطا در ارسال گیرندگان',
        ErrorCalculate: 'خطا در شناسایی ارسال',
        ErrorSelectNumber: ' خطای انتخاب شماره ',
        ErrorInSaveJob: ' خطا در ذخیره پیام برای ارسال',
        ScheduledMessageNotFound: 'پیام برنامه ریزی شده یافت نشد',
        OrganizationOrHierarchyIsInactive:
          'سازمان جاری یا یکی از سازمان های پدر غیرفعال است',
        GroupPriceIsNull: 'تعرفه وجود ندارد',
        OrganizationCreditNotEnough: 'کمبود موجودی سازمان',
        OperatorNumberCountIsNull: 'تعداد اپراتور صفر است',
        OrganizationNotFound: 'سازمان یافت نشد',
        NotSended: 'ارسال نشده',
        OrganizationIsExpired: 'سازمان منقضی شده',
        PrivateNumberIsInactive: 'خط غیرفعال',
        OrganizationIsInactive: 'سازمان غیرفعال',
      },
      SendTypes: {
        Bulk: 'انبوه',
        Dynamic: 'پویا',
        P2P: 'نظیر به نظیر',
        Single: 'تکی',
        PhoneBook: 'دفترچه تلفن',
        Api: 'Api',
      },
      QueueStatus: {
        Completed: 'تکمیل شده',
        Confirmed: 'تایید شده',
        Extracted: 'استخراج شده',
        Extracting: 'استخراج کردن',
        Failed: 'ناموفق',
        FailedExtract: 'استخراج ناموفق',
        Ready: 'آماده ارسال',
        Rejected: 'رد شده',
        Stored: 'ذخیره شده',
        Updating: 'در حال بروزرسانی',
        WatingForConfirm: 'در انتظار تایید',
      },
      SmsAggregator: {
        NotValid: 'نامعتبر',
        MCI: 'همراه اول',
        MCI2: 'MCI2',
        Irancell: 'ایرانسل',
        Rightel: 'رایتل',
        Other: 'سایر',
        International: 'بین الملل',
        // Taliya: 'تالیا',
        // MTCE: 'اسپادان',
        // KishTCI: 'همراه کیش',
      },
      SmsLanguage: {
        Farsi: 'فارسی',
        Latin: 'لاتین',
      },
      UseTypes: {
        Unknown: 'نامشخص',
        Normal: 'معمولی',
        WebService: 'وب سرویس',
      },
      NumberType: {
        Public: 'عمومی',
        Private: 'خصوصی',
        PrivateWithKeyword: 'خصوصی با کلمه ی کلیدی',
      },
      TypeCreditChanges: {
        Manage: 'مدیریت',
        BuyPanel: 'خرید پنل',
        ExtendedPanel: 'تمدید پنل',
        Fish: 'فیش بانکی',
        OnlinePayment: 'پرداخت آنلاین',
        PriceNumber: 'هزینه خط اختصاصی',
        ActivationService: 'فعال سازی سرویس ها',
        GiveBackCostOfUnsuccessSent: 'برگشت هزینه ارسال های ناموفق',
        ActivationGeneralPhoneBook: 'فعال سازی گروه های ویژه',
        SendSms: 'ارسال پیامک',
        DeleteUser: 'حذف کاربر',
        TransferPrivateNumber: 'انتقال خط',
      },
      TypeTransactions: {
        Increase: 'افزایشی',
        Decrease: 'کاهشی',
      },
      UserDocuments: {
        BirthCertificate: 'شناسنامه',
        NationalCard: 'کارت ملی',
        OptionalField1: 'فیلد دلخواه 1',
        OptionalField2: 'فیلد دلخواه 2',
      },
      OrganizationDocuments: {
        BusinessLicense: 'مجوز کسب و کار',
        CeoBirthCertificate: 'شناسنامه مدیر عامل',
        CeoNationalCard: 'کارت ملی مدیرعامل',
        FoundedAnnounce: 'اطلاعیه ی تاسیس',
        LatestChangesAnnounce: 'اعلام آخرین تغییرات',
        OptionalField1: 'فیلد دلخواه 1',
        OptionalField2: 'فیلد دلخواه 2',
      },
      DocumentStatus: {
        NotCheckedYet: 'هنوز تایید نشده',
        Accepted: 'تایید شده',
        NotAccepted: 'رد شده',
      },
      CustomFieldTypes: {
        Boolean: 'مقدار فعال / غیرفعال',
        Datetime: 'تاریخ و زمان',
        Float: 'عدد اعشاری',
        Integer: 'عدد صحیح',
        String: 'متن',
      },
      TypePayments: {
        Cash: 'نقدی ',
        Cheque: 'پرداخت چک ',
        Card: 'کارت به کارت/شبا',
        Account: 'پایا/ساتنا/پل',
        OnLine: 'پرداخت آنلاین ',
      },
      TypePaymentStatus: {
        Confirmed: 'تایید شده',
        Rejected: 'رد شده',
        Checking: 'درحال بررسی',
        Lending: 'نسیه',
        WatingForPay: 'در انتظار پرداخت',
      },
      OutBoxStatus: {
        Stored: 'ذخیره شده',
        WatingForSend: 'در انتظار ارسال',
        IsBeingSent: 'در حال ارسال',
        Sent: 'ارسال شد',
        SentAndGiveBackCredit: 'ارسال و گرفتن اعتبار',
        Archived: 'بایگانی شد',
        ErrorInSending: 'خطا در ارسال',
        ErrorInGetItc: 'خطا در گرفتن مخابرات',
        BlackList: 'لیست سیاه',
        WatingForConfirm: 'در انتظار تایید',
        Archiving: 'بایگانی کردن',
      },
      Encoding: {
        English: 'انگلیسی',
        Persian: 'فارسی',
      },
      ExportDataStatus: {
        None: 'هیچکدام',
        Get: 'Get',
        Complete: 'Complete',
        Refresh: 'Refresh',
      },
    },
    common: {
      timeRangeSelector: {
        label: 'انتخاب بازه زمانی',
        oneMonth: '۱ ماه',
        threeMonths: '۳ ماه',
        sixMonths: '۶ ماه',
        oneYear: '۱ سال',
      },
      fa: 'فارسی',
      en: 'انگیسی',
      lang: 'زبان',
      icon: 'آیکن',
      dateTime: {
        minute: 'دقیقه',
        hour: 'ساعت',
        day: 'روز',
        week: 'هفته',
        month: 'ماه',
        year: 'سال',
      },
      seasons: {
        Spring: 'فروردین',
        Summer: 'اردیبهشت',
        Fall: 'خرداد',
        Winter: 'تیر',
      },
      daysOfTheWeek: {
        saturday: 'شنبه',
        sunday: 'یکشنبه',
        monday: 'دوشنبه',
        tuesday: 'سه شنبه',
        wednesday: 'چهارشنبه',
        thursday: 'پنجشنبه',
        friday: 'جمعه',
      },
      calenderDate: {
        solar: 'هجری شمسی',
        ad: 'میلادی',
        lunar: 'هجری قمری',
      },
      color: {
        red: 'قرمز',
        blue: 'آبی',
        purple: 'بنفش',
        gray: 'طوسی',
        navyBlue: 'سرمه ای',
        white: 'سفید',
        green: 'سبز',
        yellow: 'زرد',
        pink: 'صورتی',
      },
      preview: 'پیش نمایش',
      files: 'فایل‌ها',
      replace: 'جایگذاری',
      manual: 'دستی',
      noDataFound: 'اطلاعاتی برای نمایش وجود ندارد!',
      rial: 'ریال',
      isRial: 'ریال میباشد.',
      allCount: 'تعداد کل',
      sentCount: 'تعداد ارسال شده',
      sendedCount: 'تعدد ارسال شده',
      row: 'ردیف',
      mobileNumbersCount: 'تعداد شماره موبایل ها ',
      changeMobileNumber: 'تغییر شماره موبایل',
      name: 'نام',
      newName: 'نام جدید',
      firstName: 'نام',
      lastName: 'نام خانوادگی',
      fatherName: 'نام پدر',
      fullName: 'نام و نام خانوادگی ',
      nationalCode: 'کد ملی',
      messageCancelText: 'متن لغو',
      level: 'سطح',
      nationalId: 'شناسه ملی',
      showCalender: 'نمایش تقویم',
      selectedDaysCount: 'تعداد روزهای انتخاب شده',
      chooseSendDays: 'انتخاب روزهای ارسال',
      previewImage: 'تصویر پیش نمایش ',
      inPageImage: 'تصویر درون صفحه ',
      inPageVideo: 'ویدیو درون صفحه ',
      formatLink: 'فرمت لینک',
      email: 'ایمیل',
      street: 'خیابان',
      campaignInfo: 'مشخصات کمپین',
      dehestan: 'دهستان',
      neighbourhood: 'محله',
      highway: 'بزرگراه',
      freeway: 'آزادراه',
      tunnel: 'تونل',
      square: 'میدان',
      boulevard: 'بلوار',
      university: 'دانشگاه',
      county: 'شهرستان',
      park: 'پارک',
      captcha: 'کد امنیتی',
      receiverCount: 'گیرندگان',
      chosen: 'انتخاب شده',
      retry: 'تلاش مجدد',
      newImage: 'تصویر جدید',
      SMSSignatureIsEnabled: 'امضای پیامک فعال است',
      faxNumber: 'شماره فکس',
      phone: 'تلفن ثابت',
      referenceId: 'شناسه مرجع',
      occasionScheduledMessageId: 'شناسه ارسال مناسبتی',
      identityNumber: 'شماره شناسنامه',
      birthDate: 'تاریخ تولد',
      gender: 'جنسیت',
      title: 'عنوان',
      group: 'گروه',
      projectName: 'نام پروژه',
      dateExpire: 'تاریخ انقضا',
      dateStart: 'تاریخ شروع',
      projectVersion: 'نسخه پروژه',
      projectConfig: 'تنظیمات پروژه',
      assignDate: 'تاریخ تخصیص',
      financialGuarantee: 'تضمین مالی',
      financialGuaranteeCredit: 'اعتبار تضمین مالی',
      totalCredit: 'مبلغ کل اعتبار',
      usedCredit: 'مبلغ استفاده‌شده',
      openPaymentsList: 'لیست پرداخت‌های باز',
      searchByUserName: 'جستجو بر اساس نام کاربری',
      plansHistory: 'تاریخچه پلن ها',
      planName: 'نام پلن',
      activationTime: 'تاریخ فعال‌سازی',
      deactivationTime: 'تاریخ غیرفعال‌سازی',
      searchByPlanName: 'جستجو بر اساس نام پلن',
      inactive: 'غیرفعال',
      noResultFound: 'نتیجه‌ای یافت نشد',
      payerCustomerHistory: 'تاریخچه کاربر پرداخت کننده',
      latestPayments: 'آخرین پرداخت‌ها',
      latestOutboxMessages: 'آخرین پیامک‌های ارسالی',
      lastMonthTotalOutboxMessagesCount: 'تعداد پیامک ارسالی ماه گذشته',
      lastMonthTotalReceiversCount: 'تعداد گیرندگان ماه گذشته',
      payerOrganization: 'سازمان پرداخت‌کننده',
      receiverOrganization: 'سازمان دریافت‌کننده',
      reservedCredit: 'اعتبار رزرو‌شده',
      paymentDate: 'تاریخ پرداخت',
      historyCreated: 'تاریخ ثبت سابقه',
      typePayment: 'نوع پرداخت',
      paymentStatus: 'وضعیت پرداخت',
      PrivateNumberCreated: 'تاریخ ثبت خط اختصاصی',
      claimGroup: 'لیست دسترسی ها',
      active: 'فعال',
      count: 'تعداد',
      file: 'فایل',
      activeSend: 'ارسال فعال',
      sendWithDuplicateNumbers: 'ارسال با شماره های تکراری',
      credit: 'اعتبار',
      mobile: 'شماره موبایل',
      select: 'انتخاب',
      public: 'عمومی',
      private: 'خصوصی',
      parentPublic: 'والد عمومی',
      year: 'سال',
      firstYear: 'سال اول',
      secondYear: 'سال دوم',
      month: 'ماه',
      day: 'روز',
      text: 'متن',
      uploadDocumentStatus: 'وضعیت آپلود مدارک',
      downloadLink: 'لینک دانلود',
      tourGuide: 'راهنمای گام به گام',
      voiceFileDownloadLink: 'لینک دانلود فایل صوتی',
      voiceFile: 'فایل صوتی',
      voiceMessage: 'پیام صوتی',
      socialMediaApplication: 'برنامه شبکه اجتماعی',
      socialMedia: ' شبکه اجتماعی',
      socialMediaMessage: 'فایل شبکه اجتماعی',
      withSignature: 'امضا دار',
      patch: 'مسیر',
      receipt: 'دریافتی',
      sender: 'ارسالی',
      farsi: 'فارسی',
      latin: 'لاتین',
      nonFarsi: 'غیرفارسی',
      data: 'داده',
      sms: 'پیامک',
      part: 'بخش',
      requestsList: 'لیست درخواست ها',
      binary: 'باینری',
      userName: 'نام کاربری',
      password: 'کلمه عبور',
      activePlan: {
        title: 'پلن فعلی',
        noActivePlan: 'پلنی فعال نیست',
        noActivePlanDescription: 'برای استفاده از امکانات، یک پلن انتخاب کنید.',
        free: 'رایگان',
        freePlan: 'پلن پایه با امکانات محدود',
        baseFeatures: 'پلن پایه با امکانات محدود',
        validUntil: 'اعتبار تا',
        expiringSoon: 'در حال انقضا',
        remainingDays: '{{count}} روز مانده تا انقضا',
        remainingHours: '{{count}} ساعت مانده تا انقضا',
        expired: 'پلن منقضی شده',
        upgradePlan: 'ارتقا پلن',
      },
      rePassword: 'تکرار کلمه عبور',
      newRePassword: 'تکرار کلمه عبور جدید',
      show: 'مشاهده',
      publicMap: 'منطقه انتخابی',
      oldPassword: 'کلمه عبور فعلی',
      newPassword: 'کلمه عبور جدید',
      price: 'قیمت',
      number: 'خط',
      save: 'ذخیره',
      maxSendCount: 'حداکثر تعداد ارسال',
      allRecords: 'تعداد کل رکوردها:',
      amount: 'مبلغ',
      notValid: 'معتبر نمی‌باشد.',
      validMobile: 'شماره همراه معتبر می‌باشد',
      notValidMobile: 'شماره همراه نامعتبر می‌باشد',
      setting: 'تنظیمات',
      privateNumber: 'شماره اختصاصی',
      privateNumbers: 'شماره های اختصاصی',
      buyNumber: {
        title: 'خرید خط اختصاصی',
        subtitle: 'خط مناسب کسب‌وکارتان را پیدا و انتخاب کنید.',
        search: 'جستجوی شماره خط',
        all: 'همه خطوط',
        available: 'آماده خرید',
        compare: 'مقایسه',
        selected: 'خط انتخاب‌شده',
        clear: 'پاک کردن انتخاب‌ها',
        price: 'قیمت خرید',
        renewal: 'تمدید سالانه',
        maintenance: 'هزینه نگهداری',
        pattern: 'الگوی شماره',
        digits: 'تعداد رقم',
        action: 'رزرو ۱۵ دقیقه‌ای',
        requestPrice: 'درخواست پیشنهاد قیمت',
        unavailablePrice: 'استعلام قیمت',
        noResults: 'خطی با این مشخصات پیدا نشد.',
        compareHint: 'برای مقایسه، حداکثر ۳ خط را انتخاب کنید.',
        compareCount: 'از ۳ خط انتخاب شده',
        limitReached: 'برای مقایسه فقط می‌توانید ۳ خط انتخاب کنید.',
        badges: {
          lucky: 'رند',
          link: 'لینک',
          receive: 'دریافت',
          golden: 'طلایی',
          nonLucky: 'غیررند',
          ordinary: 'عادی',
        },
      },
      isAuthenticated: 'احراز هویت',
      isAuthenticatedMobile: 'تایید موبایل',
      organizationName: 'نام سازمان',
      isForeigner: 'اتباع خارجی',
      id: 'شناسه',
      login: 'ورود',
      lockOut: 'مسدود',
      unblock: 'رفع مسدودی',
      sendSubType: 'ارسال',
      sendSubDateType: 'نوع زمان ارسال ',
      loginToUserAccount: 'ورود به حساب کاربر',
      loginOrganization: 'ورود به سازمان',
      loginToAccount: 'ورود به حساب ',
      loginWithIdentity: 'ورود با سامانه احراز هویت',
      signUpWithIdentity: 'ثبت نام با سامانه احراز هویت',
      rememberMe: 'مرا بخاطر بسپار',
      forgetPassword: 'فراموشی کلمه عبور',
      callsCount: 'تعداد فراخوانی ها',
      editPassword: 'تغییر کلمه عبور',
      signUp: 'ثبت نام',
      ussdId: 'شناسه ussd',
      goToLogin: 'رفتن به صفحه ورود',
      tempUrlLink: 'مدت زمان اعتبار لینک',
      equalToSeconds: 'معادل به ثانیه',
      selectedValue: 'مقدار انتخابی',
      durationTime: 'مدت زمان',
      unitTime: 'واحد زمان',
      redirectionDurationUrl: 'مدت زمان انتظار ',
      constantPath: 'آدرس دلخواه',
      account: 'حساب',
      receivers: 'گیرندگان',
      fastSend: 'ارسال سریع',
      testSend: 'ارسال تست',
      tableSetting: 'سفارشی‌سازی ستون‌ها',
      defaultGroupPrice: 'تعرفه پیش فرض',
      PhonebookRecipient: 'گیرندگان ارسال دفترچه تلفن',
      startDate: 'تاریخ شروع',
      endDate: 'تاریخ پایان',
      description: 'توضیحات',
      minPrice: 'حداقل قیمت',
      maxPrice: 'حداکثر قیمت',
      typeBank: 'بانک ',
      operation: 'عملیات',
      createDate: 'تاریخ ثبت',
      pattern: 'قالب',
      messageInformation: 'مشخصات پیامک',
      sendDateTimeType: 'تنظیمات ارسال',
      confirmSmartSmsRequest: 'ارسال پیامک',
      createRecepientForPeriodicSmartSms: 'ایجاد کمپین',
      periodic: 'دوره ای',
      justSendToWhiteList: 'فقط ارسال به لیست سفید',
      scheduledMessageId: 'شناسه ارسال',
      lastModifiedDate: 'تاریخ ویرایش',
      expireDate: 'تاریخ انقضا',
      expireTime: 'ساعت انقضا',
      authenticated: 'احراز هویت',
      addSingle: 'افزودن تکی مخاطب',
      addListNumber: 'افزودن شماره مخاطب لیستی',
      addFromFile: 'افزودن مخاطب از فایل',
      authenticatedMobile: 'تایید شماره موبایل',
      deleteAllContact: 'حذف تمامی مخاطبین',
      deleteImage: 'حذف تصویر',
      columns: 'لیست ستون ها',
      key: 'کلید',
      creditPayment: ' پرداخت اعتباری',
      onlinePayment: 'پرداخت آنلاین',
      value: 'مقدار',
      customText: 'متن دلخواه',
      searchFilter: 'فیلتر جستجو',
      userInfo: 'اطلاعات کاربری',
      userId: 'شناسه کاربری',
      userManual: 'راهنمای استفاده',
      createTemplate: 'طراحی قالب',
      numberList: 'لیست شماره',
      generalIndexes:
        'در صورت وارد نمودن اندیس گذاری کلی، اندیس های بالا در نظر گرفته نمی شود .',
      bulkSendDetail: 'جزئیات ارسال انبوه',
      merchantId: 'شماره پذیرنده',
      terminalNumber: 'شماره ترمینال',
      terminalId: 'شناسه ترمینال',
      androidPreview: 'پیش نمایش اندروید',
      iosPreview: 'پیش نمایش ios',
      terminalKey: 'کلید ترمینال',
      userPassword: 'کلمه عبور کاربر',
      shaKey: 'کلید sha',
      loginAccount: 'ورود به حساب کاربری',
      merchantCode: 'کد پذیرنده',
      privateKey: 'کلید خصوصی',
      privatePlace: 'مکان شخصی',
      activationDate: 'تاریخ فعال شدن',
      organizationsUploadedDocumentsCount:
        'مدارک کامل / بدون احراز هویت (سازمان)',
      usersUploadedDocumentsCount: 'مدارک کامل / بدون احراز هویت (کاربر)',
      acceptorId: 'کد پذیرنده',
      passPhrase: 'عبارت عبور',
      timeFrame: 'بازه زمانی',
      publicKey: 'کلید عمومی',
      sendPrice: 'هزینه ارسال کل',
      privateCode: 'کد خصوصی',
      merchantConfigurationId: 'شماره پیکربندی پذیرنده',
      creditNotEnough: 'اعتبار شما کافی نمی باشد!',
      generalUse: 'استفاده عمومی',
      usingTheInvoice: 'استفاده از فاکتور',
      generalIndexing: 'اندیس گذاری کلی',
      invoice: 'پیش فاکتور',
      orderId: 'شماره سفارش',
      resellerName: 'فروشنده',
      ussdName: 'نام ussd',
      diagram: 'دیاگرام',
      date: 'تاریخ',
      hour: 'ساعت',
      appVersion: 'ورژن سامانه ',
      smartSmsPreview: 'پیش نمایش کلی درخواست ارسال مکان محور',
      minute: 'دقیقه',
      pishgamRayanDadehPajoohCo: 'شرکت پیشگام رایان داده پژوه',
      esfahan: 'اصفهان',
      phoneNumberFax: 'شماره تلفن / نمابر',
      postalCode: 'کد پستی',
      pishgamRayanAddress:
        'حد فاصل چهار راه آپادانا و سپهسالار، جنب بانک تجارت، ساختمان تندیس، طبقه ۴، واحد۴۱',
      organization: 'سازمان',
      getterOrganization: 'سازمان گیرنده',
      getterUser: 'کاربر گیرنده',
      currentOrganization: 'سازمان فعلی',
      organizations: 'لیست سازمان ها',
      shortcuts: 'دسترسی سریع',
      operator: 'اپراتور',
      setNowTimeDate: 'استفاده از زمان حال',
      smartSmsRequestTitle: 'عنوان درخواست ارسال مکان محور',
      smartSmsRequestId: 'شناسه درخواست ارسال مکان محور',
      numberOfCells: 'تعداد دکل ها :',
      priceOf50000Cells: 'حداکثر 50000 دکل',
      smsEncoding: 'نوع پیام',
      domainId: 'شناسه دامنه',
      domainName: 'نام دامنه',
      parentId: 'شناسه والد',
      parentOrganization: 'سازمان والد',
      user: 'کاربر',
      chosenPhonebooks: 'دفترچه تلفن های انتخاب شده',
      deleteSelectedFile: 'حذف فایل انتخابی',
      users: 'کاربران',
      userList: 'لیست کاربران',
      organizationList: 'لیست سازمان ها',
      senderNumberId: 'ارسال کننده',
      characterCount: 'تعداد کاراکتر',
      smsBody: 'متن پیام',
      claimsCount: 'تعداد کل دسترسی ها',
      menusCount: 'تعداد کل منوها',
      selectedCount: 'انتخاب شده',
      domainHeader: 'هدر',
      convertToPersianNumbers: 'تبدیل ارقام به فارسی',
      realPerson: 'حقیقی',
      legalPerson: 'حقوقی',
      sendHour: 'ساعت ارسال',
      sendDay: 'روز ارسال',
      startDay: 'روز شروع',
      position: 'محل قرارگیری',
      permissions: 'مجوز ها',
      openSelector: 'باز کردن پنجره انتخاب',
      closeSelector: 'بستن پنجره انتخاب',
      organSignatureAtFirst: 'امضای سازمان در ابتدا',
      privateNumberSignatureAtFirst: 'امضای ارسال کننده در ابتدا',
      organSmsHeaderAtFirst: 'سرتیتر سازمان در ابتدا',
      privateNumberSmsHeaderAtFirst: 'سرتیتر ارسال کننده در ابتدا',
      headerPosition: 'محل قرارگیری سرتیتر ارسال کننده',
      startTime: 'زمان شروع',
      trustMark: 'نماد اعتماد',
      startHour: 'ساعت شروع',
      endDay: 'روز پایان',
      endTime: 'زمان پایان',
      endHour: 'ساعت پایان',
      partCount: 'تعداد بخش',
      campaign: 'کمپین',
      campaignId: 'شناسه کمپین',
      groupPriceCategory: 'تعرفه',
      environmentInfo: 'اطلاعات محیط',
      logInfo: 'اطلاعات لاگ',
      hello: 'سلام',
      selectedTheme: 'انتخاب تم',
      selectedTemplate: 'انتخاب قالب',
      privateNumberList: 'لیست خطوط فعال',
      from: 'از',
      to: 'تا',
      groupDeletion: 'حذف گروهی',
      groupEdit: 'ویرایش گروهی',
      new: 'جدید',
      clickToShow: 'برای مشاهده کلیک کنید',
      clickForAdd: 'جهت افزودن کلیک کنید',
      phonebook: 'دفترچه تلفن',
      phonebooks: 'دفترچه تلفن ها',
      accountInformation: 'شماره حساب',
      accountInformationCardNo: 'شماره کارت',
      numberOfRecords: 'تعداد رکورد :',
      numberOfViews: 'تعداد نمایش',
      page: 'صفحه',
      panelPrice: 'قیمت پنل',
      username: 'نام کاربری ',
      loading: 'در حال بارگذاری',
      type: 'نوع',
      ipAddress: 'آدرس آی پی',
      browser: 'مرورگر',
      device: 'دستگاه',
      fromDate: 'از تاریخ',
      toDate: 'تا تاریخ',
      os: 'سیستم عامل',
      refreshToken: 'refresh Token',
      refreshTokenExpiration: 'تاریخ انقضا refresh Token',
      isActive: 'فعال',
      isVisible: 'نمایش فعال',
      second: 'ثانیه ',
      deActive: 'غیرفعال',
      personType: 'نوع شخص',
      yourCredit: 'اعتبار شما',
      isPublic: 'عمومی',
      isActiveSend: 'ارسال فعال',
      isDefault: 'پیش فرض',
      contactsCount: 'تعداد مخاطبین',
      changeDefault: 'تغییر پیش فرض',
      myOrganizations: 'سازمان‌های من',
      senderNumber: 'فرستنده',
      defaultOrganization: 'سازمان پیش فرض :',
      activeOrganization: 'سازمان فعال :',
      currentOrganizations: 'سازمان فعلی :',
      detail: 'جزئیات',
      mediaDetail: 'جزئیات شبکه های اجتماعی',
      male: 'مرد',
      female: 'زن ',
      mci: 'همراه اول',
      mtn: 'ایرانسل',
      rightel: 'رایتل',
      confirmSend: 'تایید ارسال',
      rejectSend: 'عدم تایید ارسال',
      organizationId: 'شناسه سازمان',
      currentStatus: 'وضعیت فعلی',
      changeStatusTo: 'تغییر وضعیت به',
      deliveryStatus: 'وضعیت تحویل',
      partLength: 'تعداد بخش',
      sendTo: 'ارسال به ',
      unknown: 'نامشخص',
      dynamicTemplate: 'قالب پویا',
      selectField: 'انتخاب فیلد',
      defineDynamicTemplate: 'تعریف قالب پویا',
      customField: 'فیلد سفارشی',
      customFields: 'فیلدهای سفارشی',
      showDetails: 'نمایش جزئیات',
      selectFilter: 'انتخاب فیلتر',
      English: 'انگلیسی',
      Persian: 'فارسی',
      format: 'قالب',
      increase: 'افزایشی',
      decrease: 'کاهشی',
      paymentId: 'شناسه پرداخت',
      typeTransaction: 'نوع تراکنش',
      whiteMessageId: 'شناسه باشگاه ',
      delete: 'حذف',
      edit: 'ویرایش',
      transferNumber: 'انتقال مالکیت',
      maxDailySendCount: 'حداکثر تعداد ارسال روزانه',
      authenticate: 'احراز هویت',
      uploadDocuments: 'آپلود مدارک',
      fromIndex: 'از اندیس',
      aggregator: 'اپراتور',
      toIndex: 'تا اندیس',
      documentation: 'مدارک',
      textBody: 'متن پیام',
      editStatus: 'ویرایش وضعیت',
      editStatusAll: 'ویرایش وضعیت همه',
      editStatusAllReceivers: 'ویرایش وضعیت تحویل گیرندگان',
      getNewDeliveryStatus: 'درخواست آخرین وضعیت تحویل',
      editReceiversStatus: 'ویرایش وضعیت تحویل گیرندگان',
      editDeliveryStatus: ' ویرایش وضعیت تحویل گیرندگان',
      selectiveEditDeliveryStatus: ' ویرایش انتخابی وضعیت تحویل گیرندگان',
      editDeliveryStatusByExcelFile:
        'ویرایش وضعیت تحویل گیرندگان با آپلود فایل',
      fileUpload: 'آپلود فایل',
      isUploaded: 'آپلود شده',
      yes: 'بله',
      no: 'خیر',
      ok: 'متوجه شدم',
      payment: 'پرداخت',
      discountCode: 'کد تخفیف',
      discount: 'تخفیف',
      success: 'موفق',
      error: 'خطا',
      periodicSendDetails: 'جزییات ارسال کمپین',
      info: 'توجه',
      warning: 'هشدار',
      nonSuccess: 'ناموفق',
      total: 'مجموع',
      signature: 'امضای پیامک',
      header: 'سرتیتر پیامک',
      smsCp: 'عامل ارسال پیامک',
      privateNumberSignature: 'امضای ارسال کننده ',
      privateNumberHeader: 'سرتیتر ارسال کننده ',
      organizationSignature: 'امضای سازمان ',
      organizationHeader: 'سرتیتر سازمان ',
      selectFile: 'انتخاب فایل',
      userOrganizations: 'سازمان های کاربر',
      cancel: 'انصراف',
      selectAll: 'انتخاب همه',
      all: 'همه موارد',
      allDayOfWeeK: 'همه روزهای هفته',
      every: 'همه',
      lat: 'عرض (lat)',
      lon: 'طول (lon)',
      distance: 'فاصله',
      importanceLevel: 'سطح اهمیت',
      notificationType: 'نوع پیام',
      distanceOnKm: 'فاصله (کیلومتر)',
      size: 'تعداد',
      closeAll: 'بستن همه',
      nextStep: 'مرحله بعد',
      previousStep: 'مرحله قبل',
      close: 'بازگشت',
      roles: 'نقش ها',
      roleTemplate: 'قالب نقش ها',
      smsParts: 'بخش',
      ageTo: 'تا سن',
      residenceState: 'محل سکونت',
      joberState: 'محل فعالیت شغلی',
      smsText: 'پیامک',
      smsBodyText: 'متن پیامک',
      keyword: 'کلمه کلیدی',
      resendSMS: 'ارسال مجدد',
      twoFactorEnabled: 'تایید دو مرحله ای ',
      resendSMSByDeliverStatus: 'ارسال مجدد بر اساس وضعیت',
      resendDetail: 'جزئیات ارسال مجدد',
      address: 'آدرس',
      visitsCount: 'تعداد بازدید کننده',
      zipCode: 'کد پستی',
      myCredit: 'اعتبار من',
      currentUserCredit: 'اعتبار فعلی کاربر',
      organizationCredit: 'اعتبار سازمان',
      updateCredit: 'بروزرسانی اعتبار',
      status: 'وضعیت',
      submit: 'ثبت',
      confirm: 'تایید',
      back: 'بازگشت',
      up: 'بالا',
      down: 'پایین',
      sentDateTime: 'تاریخ ارسال',
      groupPriceList: 'تعرفه ها',
      rangeList: 'بازه‌ ها',
      endOfSmsBody: 'انتهای پیامک',
      startOfSmsBody: 'ابتدای پیامک',
      reporting: 'گزارش گیری',
      reportBuilder: 'گزارش ساز',
      report: 'گزارش',
      search: 'جستجو',
      searchPlace: 'مکان های اجتماعی',
      advanceSearch: 'جستجوی پیشرفته',
      groupPrice: 'بازه',
      add: 'افزودن',
      privateNumberPurchaseRules: 'قوانین خرید خط',
      currency: 'ریال',
      currencyWithParentheses: '(ریال)',
      addUser: 'افزودن کاربر جدید',
      toman: ' تومان',
      iranianToman: ' تومان',
      millionToman: ' میلیون تومان',
      nextLevel: 'مرحله بعد',
      previousLevel: 'مرحله قبل',
      sendAuthCode: 'ارسال کد تایید',
      increaseCredit: 'افزایش اعتبار',
      decreaseCredit: 'کاهش اعتبار',
      creditTransfer: 'انتقال اعتبار',
      play: 'پخش',
      pause: 'متوقف',
      downloadFile: 'دانلود فایل',
      download: 'دانلود',
      downloadExcel: 'دانلود اکسل',
      downloadExcelWithMoreDetail: 'دانلود اکسل با جزئیات بیشتر',
      generalDisplay: 'نمایش کلی',
      groupPriceDetail: 'جزئیات تعرفه',
      displayMode: 'نحوه نمایش',
      displayWithDetails: 'نمایش با جزئیات',
      udhLen: 'وضعیت طول جدا کننده کاراکتر فارسی',
      print: 'چاپ',
      downloadAll: 'دانلود همه',
      saveToCampaign: 'ذخیره به عنوان کمپین',
      authCode: 'کد تایید',
      clearAll: 'پاک کردن همه',
      clear: 'پاک کردن',
      removeAll: 'حذف همه',
      empty: 'موردی یافت نشد!',

      confirmation: 'تایید',
      priority: 'اولویت',
      notConfirmation: 'عدم تایید',
      clipBoard: 'کلیپ بورد',
      onBackToPreviousAccount: 'بازگشت به حساب قبلی',
      language: 'زبان',
      darkMode: 'حالت شب',
      lightMode: 'حالت روز',
      privateNumberId: 'شناسه فرستنده',
      notifications: 'اعلان ها',
      logout: 'خروج از حساب',
      unreadMessages: 'پیام‌های خوانده‌نشده',
      allMessages: 'همه پیام‌ها',
      notificationPopup: {
        newNotification: 'اعلان جدید',
        now: 'همین حالا',
      },
      token: 'توکن',
      resend: 'ارسال مجدد',
      continuation: 'ادامه',
      sendSubmit: 'ثبت و ارسال',
      quickLinks: 'دسترسی سریع',
      newQuickLink: 'دسترسی سریع جدید',
      editQuickLink: 'ویرایش دسترسی سریع',
      refresh: 'بازیابی مجدد',
      refreshMenus: 'بازیابی منوها',
      menus: 'منوها',
      modules: 'ماژول ها',
      buy: 'خرید',
      filters: 'فیلترها',
      cpType: 'عامل ارسال',
      claims: 'دسترسی ها',
      sendSms: 'ارسال پیامک',
      editSendSms: 'ویرایش ارسال',
      specifications: 'مشخصات',
      titleAndTextHelp: 'عنوان و متن راهنما ',
      wordList: 'لیست کلمات',
      send: 'ارسال',
      changePassword: 'تغییر کلمه عبور',
      useType: 'نوع استفاده',
      changeOrganization: 'تغییر سازمان',
      country: 'کشور',
      state: 'استان',
      province: 'استان',
      city: 'شهر',
      area: 'منطقه',
      mobilePrefix: 'پیش شماره',
      bank: 'بانک',
      field: 'فیلد',
      dailyStatistics: 'آمار روزانه',
      operatorStatistics: 'آمار اپراتورها',
      depositPrice: 'مبلغ پرداختی',
      originalPrice: 'میزان شارژ',
      purchaseDate: 'تاریخ خرید',
      remainingCredit: 'اعتبار باقیمانده',
      newFiled: 'فیلد جدید',
      defineNewField: 'تعریف فیلد جدید',
      owner: 'مالک',
      SelectedPhonebooks: 'دفترچه تلفن های انتخاب شده',
      clickForMoreInfo: 'جهت نمایش اطلاعات بیشتر کلیک کنید',
      disableItem: 'این مورد غیر فعال است',
      help: 'راهنما',
      editHelp: 'ویرایش راهنما',
      attachment: 'پیوست',
      notFoundHelp: 'راهنما یافت نشد',
      example: 'مثال : ',
      mainClaim: 'دسترسی اصلی',
      class: 'کلاس ',
      minuteBetweenTries: 'مدت تاخیر',
      transferPrivateNumber: 'اختصاص خطوط',
      maxTryCount: 'تعداد تلاش',
      parent: 'والد',
      zero: 'صفر',
      parentName: 'والد',
      database: 'پایگاه داده',
      paymentAmount: 'مبلغ پرداختی',
      chargeRateCredit: 'میزان شارژ',
      table: 'جدول',
      tableStatistic: 'جدول گزارشات',

      recipientCount: 'تعداد گیرندگان',
      apiAddress: 'آدرس Api',
      finalConfirmation: 'تایید نهایی',
      startDateSearch: 'از تاریخ',
      startTimeSearch: 'از ساعت',
      cancellation: 'لغو',
      cancellationRequest: 'لغو درخواست',
      stayRequest: 'منتظر می مانم',
      receiverNumber: 'شماره گیرنده',
      link: 'لینک',
      fileLink: 'لینک فایل',
      endDateSearch: 'تا تاریخ',
      endTimeSearch: 'تا ساعت',
      dateExit: 'تاریخ خروج',
      totalSum: 'مجموع کل',
      requestName: 'عنوان درخواست',
      ageFrom: 'از سن',
      currentPageTotalSum: 'مجموع کل صفحه جاری',
      openDateFilter: ' فیلتر تاریخ',
      deleteFilter: 'حذف فیلتر',
      addRule: 'افزودن شرط',
      addField: 'افزودن فیلد',
      removeRule: 'حذف شرط',
      copyContent: 'کپی کردن محتوا',
      copyTemplate: 'کپی کردن قالب فعلی',
      deviceTypes: 'نوع دستگاه',
      deviceBrands: 'برند دستگاه',
      pasteContent: 'جای‌گذاری محتوا',
      copy: 'کپی ',
      atFirst: 'نمایش در ابتدا',
      expandAll: 'بازکردن همه منوها',
      payable: 'قابل پرداخت',
      collapseAll: 'بستن همه منوها',
      paste: 'جای‌گزاری',
      loginToPanel: 'ورود به پنل',
      fieldRequired: 'این فیلد الزامی است',
      nameFa: 'نام فارسی',
      nameEn: 'نام انگلیسی',
      transactions: 'تراکنش ها',
      transactionKind: 'گروه تراکنش',
      sendType: 'نوع ارسال',
      nowNo: 'اکنون نه',
      succeed: 'عملیات موفق',
      publicPlace: 'مکان عمومی',
      shortLinkList: 'لیست لینک های کوتاه',
      smsTemplateList: 'لیست الگوهای پیامک',
      emoji: 'ایموجی',
      optional: 'اختیاری',
      savePolygon: 'ذخیره محدوده جغرافیایی منتخب',
      extraReceivers: 'گیرندگان اضافی',
      reseller: 'فروشنده',
      addPublicPlace: 'افزودن مکان عمومی',
      resetPassword: 'تغییر کلمه عبور',
      reset: 'تنظیم مجدد',
      isSignOut: 'خروج',
      removeSelectedItems: 'حذف موارد انتخابی',
      signInSignOut: 'ورود/خروج',
      emptyReceivers: 'لیست گیرندگان خالی است.',
      emptyReceiversOrWrongIndex:
        'لیست گیرندگان خالی است یا اندیس گذاری صحیح نمی‌باشد. ',
      uploadFile: 'آپلود فایل',
      uploadDocument: 'آپلود مستندات',
      uploadImage: 'آپلود عکس',
      uploadBackground: 'آپلود تصویر زمینه',
      isConfirmed: 'تایید شده',
      notConfirmed: 'تایید نشده',
      inboxGroup: 'گروه صندوق دریافت',
      saveNow: 'اکنون ذخیره شود',
      saveNowAfterSend: 'بعد از ارسال ذخیره شود',
      check: 'بررسی',
      myOrganizationPackages: 'بسته های من',
      getNewStatus: 'دریافت آخرین وضعیت',
      guildName: 'گروه مشاغل',
      subGuildName: 'زیرگروه مشاغل',
      addToJob: 'اضافه شدن به فرآیند ارسال',
      frontAudits: 'لاگ های فرانت',
      pollParserInboxes: 'ارسال کنندگان',
      receiveDateTime: 'تاریخ دریافت',
      smsCount: 'تعداد پیامک',
      priceRial: 'هزینه (ریال)',
      statistics: 'مشاهده آمار',
      pollParserLottery: 'قرعه کشی',
      winnerList: 'لیست برندگان',
      winnerCount: 'تعداد برندگان',
      addToQueue: 'ثبت مجدد در صف ارسال',
      ip: 'آی پی',
      ipRange: 'رنج آی پی',
      currentIp: 'آی پی جاری',
      appearanceSettings: 'تنظیمات ظاهری',
      formDetails: 'مشخصات فرم',
      exportRecepient: 'ذخیره ارسال مکان محور',
      importRecepients: 'ایجاد ارسال مکان محور از فایل',
      ImportRequestName: 'ایجاد درخواست ارسال مکان محور از فایل',
      selectRequestId: 'انتخاب شناسه ارسال مکان محور',
      requestId: 'شناسه ارسال',
      useToCreateToken: 'استفاده برای ساخت توکن',
      useToLoginPanel: 'استفاده برای ورود به پنل',
      running: 'فعال',
      paused: 'غیر فعال',
      doDisable: 'غیر فعال کردن',
      doEnable: 'فعال کردن',
      persianPrice: 'قیمت فارسی',
      startDateTime: 'تاریخ و زمان شروع',
      endDateTime: 'تاریخ و زمان پایان',
      expireDateTime: 'تاریخ و زمان انقضا',
      englishPrice: 'قیمت انگلیسی',
      chosenSmartSmsDetail: 'جزئیات ارسال مکان محور',
      numbersCount: 'تعداد شماره ها',
      statusDatetime: 'تاریخ و ساعت آخرین وضعیت',
      lastUpdateDatetime: 'تاریخ و ساعت آخرین بروزرسانی',
      sendP2PSmart: 'ارسال مکان محور نظیربه نظیر',
      isNeedUserConfirmation: 'نیاز به تایید کاربر',
      category: 'دسته بندی',
      addNumbers: 'افزودن شماره همراه',
      numbers: 'شماره ها',
      previousMonth: 'ماه قبل',
      nextMonth: 'ماه بعد',
      deliveryStatusStats: 'آمار وضعیت گیرندگان پیام',
      messageDeliveryStatusStats: 'آمار وضعیت گیرندگان پیام',
      groupConfirmation: 'تایید گروهی',
      travellerState: 'ارسال به مسافرین',
      travellerProvinces: 'استان مبدا مسافر',
      buyPlan: 'خرید پلن',
      occasion: 'مناسبت',
      calendar: 'تقویم',
      holiday: 'تعطیل رسمی',
      organExpireDate: 'تاریخ انقضای سازمان',
      userExpireDate: 'تاریخ انقضای کاربر',
      chart: 'نمودار',
      userStatus: 'وضعیت کاربر',
      simType: 'نوع سیم کارت',
      requestDetail: 'جزئیات درخواست',
      smsSendingNumber: 'سرشماره ارسال پیامک',
      isRandomSend: 'ارسال به صورت تصادفی',
      smsPreview: 'پیش نمایش پیامک',
      addToPublicPlace: 'افزودن به مکان شخصی',
      balance: 'اعتبار',
      isCountTargetPassed: 'رسیده به تعداد',
      isCreditTargetPassed: 'رسیده به مبلغ نهایی',
      creditTargetValue: 'مبلغ نهایی',
      countTargetValue: 'تعداد پیامک',
      times: 'دفعات',
      commission: 'کمیسیون',
      partsCount: 'تعداد بخش',
      target: 'هدف',
      encoding: 'کدینگ',
      stats: 'آمار',
      justCurrentOrganization: 'فقط سازمان جاری',
      geometryType: 'نوع مکان',
      grayList: 'لیست خاکستری',
      airports: ' فرودگاه ها',
      airport: ' فرودگاه ',
      requestType: 'نوع درخواست',
      requestProperties: 'مشخصات درخواست',
      requestSpecifications: 'مشخصات درخواست',
      smartRequestDetails: 'جزئیات درخواست ارسال مکان محور',
      isRead: 'خوانده شد',
      filterForm: 'فیلتر گزارشات',

      informationUsersSeen: 'کاربران مشاهده کننده اخبار',
      receivedMessage: 'پیام دریافتی',
      startTimeAtDay: 'ساعت شروع ارسال',
      endTimeAtDay: 'ساعت پایان ارسال',
      update: 'بروزرسانی',
      priceFa: 'قیمت(FA)',
      priceEn: 'قیمت(EN)',
      totalPriceFa: 'قیمت کل(FA)',
      totalPriceEn: 'قیمت کل(EN)',
      messageCount: 'تعداد پیام ها',
      messageInConsumeCount: 'تعداد پیام ها در پردازش',
      regex: 'regex',
      linkLocation: 'لینک لوکیشن',
      setSchedules: 'زمانبندی',
      expandMap: 'گسترش نقشه',
      collapseMap: 'کوچک شدن نقشه',
      incomeRatePerSecond: 'نرخ ورود به صف',
      consumersCount: 'تعداد مصرف کنندگان',
      consumeRatePerSecond: 'نرخ خروج از صف',
      duplicatedNumbersCount: 'تعداد شماره های تکراری',
      archive: 'آرشیو',
      colorCode: 'کد رنگ',
      smartSmsPercent: 'درصد تعرفه ارسال مکان محور',
      mtnSmartPercent: 'درصد تعرفه ارسال مکان محور ایرانسل',
      rightelSmartPercent: 'درصد تعرفه ارسال مکان محور رایتل',
      mciSmartPercent: 'درصد تعرفه ارسال مکان محور همراه اول',
      smartSmsClubTitle: 'عنوان باشگاه',
      club: 'باشگاه',
      smartSmsCampaignTitle: 'عنوان کمپین',
      periodType: 'نوع دوره فراخوانی',
      period: 'دوره فراخوانی',
      calls: 'فراخوانی ها',
      totalCalls: 'تعداد کل فراخوانی ها',
      sessionId: 'شناسه نشست',
      organizationUssdStats: 'آمار کدهای USSD سازمان',
      ussdStats: 'آمار کد USSD',
      ussdCodeStatistics: 'آمار کدهای USSD',
      userInput: 'ورودی کاربر',
      systemResponse: 'پاسخ سیستم',
      periodValue: 'مقدار دوره فراخوانی',
      smartRequestType: 'نوع درخواست ارسال مکان محور',
      grayListExpireHour: 'تا چند ساعت، شماره ای تکراری در نظر گرفته شود؟',
      cellList: 'لیست شناسه دکل ها',
      isSmartCountAsPercent: 'درصدی',
      smartSmsClubOperationType: 'نوع عملیات باشگاه ارسال مکان محور',
      downloadPDF: 'دانلود PDF',
      downloadPowerPoint: 'دانلود Powerpoint',
      downloadImage: 'دانلود تصویر',
      smartRequestId: 'شناسه درخواست: ',
      content: 'محتوا',
      megabyte: 'مگابایت',
      kilobyte: 'کیلوبایت',
      chooseTemplate: 'انتخاب قالب',
      chooseTheme: 'انتخاب تم',
      titleOfReport: ' عنوان گزارش',
      logoUpload: 'آپلود لوگو',
      imageUpload: 'آپلود تصاویر',
      campaignReport: 'گزارش کمپین',
      editTitleOfReport: ' ویرایش عنوان گزارش',
      createReport: 'ساخت گزارش',
      editBackground: 'ویرایش پس زمینه',
      operators: 'اپراتورها',
      sendStatus: 'وضعیت ارسال ها',
      readNotification: 'خوانده شد',
      percentage: 'درصد',
      addTitle: 'افزودن عنوان',
      showFile: 'نمایش فایل',
      addRow: 'افزودن ردیف',
      socialMediaGroupPriceDetail: 'جزئیات بازه شبکه های اجتماعی ',
      groupRejection: 'عدم تایید گروهی',
      financialBalance: 'تراز مالی',
      paymentImage: 'تصویر پرداخت',
      passwordOrToken: 'کلمه عبور یا توکن',
      url: 'لینک',

      aggregatorInquiry: 'استعلام اپراتورها',
      blackListInquiry: 'استعلام لیست سیاه',
      isBlackList: 'لیست سیاه',
      isExternalBlackList: 'لیست سیاه خارجی',
      totalCount: 'تعداد کل',
      getTotalCount: 'دریافت تعداد کل',
      startDatetime: 'تاریخ شروع',
      endDatetime: 'تاریخ پایان',
      isCanSendVoice: 'امکان ارسال صدا',
      activePeriodicSmartSmsRequests: 'کمپین های درحال اجرا',
      showMore: 'نمایش بیشتر...',
      fields: 'فیلد ها',
      isUseSeparator: 'جداکننده در فیلدهای عددی',
      scheduledMessagePartsCount: 'تعداد کل پارت ها',
      platform: 'پلتفرم',
      endOfSessions: 'پایان نشست',
      currentMeeting: 'نشست فعلی',
      notYet: 'فعلا نه',
      numberType: 'نوع خط',
      sendToBlackList: 'خط خدماتی',
      deleteFilters: 'حذف فیلترها',
      voiceMessageId: 'شناسه فایل صوتی',
      avanakVoiceMessageId: 'شناسه آوانک',
      isQuickSend: 'ارسال سریع',
      quickSendId: 'شناسه ارسال سریع',
      sendAddress: 'منطقه ارسال',
      zoomIn: 'بزرگ نمایی',
      zoomOut: 'کوچک نمایی',
      reversePolygon: 'جا به جا کردن مختصات',
      desiredPolygon: 'مختصات مناطق مورد نظر',
      isFlashSms: 'ارسال فلش',
      checkCell: 'بررسی اعتبار منطقه',
      season: 'فصل',
      aggregateStats: 'گزارش مقایسه ای تجمیعی',
      seasonsStats: 'گزارش مقایسه ای فصل به فصل',
      firstTimeRange: 'بازه زمانی اول',
      secondTimeRange: 'بازه زمانی دوم',
      firstMonth: 'ماه اول',
      secondMonth: 'ماه دوم',
      firstSeason: 'فصل اول',
      secondSeason: 'فصل دوم',
      checkingPleaseWait: 'در حال بررسی لطفا شکیبا باشید ...',
      cellsByName: 'دریافت شناسه ها',
      names: 'نام ها',
      voice: 'صوتی',
      stopSending: 'توقف ارسال',
      cellListIds: 'لیست شناسه دکل ها',
      isCanSendSmartWithoutConfirmation: 'امکان ارسال مکان محور بدون تایید',
      region: 'منطقه',
      pricePerPart: 'تعرفه هر پارت پیامک',
      calculatingTariffSMS: 'محاسبه تعرفه هر پارت پیامک',
      calculate: 'محاسبه',
      smartSmsClubFileProgresses: 'وضعیت فایل های آپلود شده',
      downloadResellerExcel: 'دانلود اکسل فروشندگان',
      isPercentageBenefitForInternational: 'آیا تعرفه بین الملل، درصدی است؟',
      internationalBenefitValue: ' و مقدار سود بین الملل',
      campaignStatusInGateway: ' استعلام ایجاد لیست خاکستری در گت وی',
      clubStatusInGateway: ' استعلام ایجاد باشگاه در گت وی',
      isCreated: 'ایجاد شده',
      creationLocation: 'روش ثبت',
      startLocation: 'محل اجرای کمپین',
      updateGroup: 'ویرایش گروه',
      voiceGroup: 'گروه صدا',
      continueSendIfAnyOperatorHaveError:
        'اگر یکی از اپراتور ها خطا داشت، ارسال ادامه یابد؟',
      continueSendingOnAnyOperatorError:
        'در صورت بروز خطا در یکی از اپراتورها، ارسال ادامه یابد.',
      kibanaDashboard: 'داشبورد کیبانا',
      authorizationScheme: 'نوع احرازهویت',
      organizationsBlackListExceptions: 'لیست استثناها',
      reject: 'رد کردن',
      loginAudits: 'لاگ های ورود کاربران',
      alertSetting: 'تنظیم اعلان',
      fileSetting: 'تنظیم فایل',

      isEnableSendNotification: 'ارسال اعلان فعال باشد؟',
      daysOfSendFrequencyPeriod: 'تعداد روزهای دوره',
      fromDaysMoreThanSendFrequently: 'از چند روز بیشتر از تناوب',
      toDaysMoreThanSendFrequently: 'تا چند روز بیشتر از تناوب ',
      create: 'ایجاد',
      newMenu: 'منو جدید',
      updateMenu: 'ویرایش منو',
      route: 'مسیر',
      order: 'ترتیب',
      endpoints: 'اندپوینت‌ها',
      newEndpoint: 'اندپوینت جدید',
      updateEndpoint: 'ویرایش اندپوینت',
      methods: 'متدها',
      baseUrl: 'آدرس‌ پایه',
      methodType: 'نوع متد',
      request: 'درخواست',
      response: 'پاسخ',
      responses: 'پاسخ ها',
      userResponses: 'پاسخ‌های کاربران',
      smsResponses: 'پاسخ‌های پیامکی',
      formsManagementSmsResponses: 'پاسخ های پیامکی فرم ساز',
      tips: 'نکات',
      sampleCodes: 'نمونه‌های کد',
      headerList: 'لیست هدرها',
      paramsList: 'لیست پارامترها',
      danger: 'خطا',
      isRequired: 'اجباری',
      statusCode: 'کد وضعیت',
      version: 'نسخه',
      tryIt: 'امتحان کنید',
      htmlContent: 'محتوای html',
      showDashboard: 'نمایش داشبورد ',
      smartSmsClubNumbers: ' شماره های باشگاه مشتریان مکان محور',
      strategies: 'استراتژی ها',
      pointStrategies: 'استراتژی های امتیازات',
      pointStrategiesDetail: 'جزئیات استراتژی های امتیازات',
      deviceNumbers: 'شماره های دستگاه',
      histories: 'تاریخچه',
      sendSmsHistory: 'تاریخچه ارسال پیامک',
      strategyTitle: 'استراتژی',
      backgroundImage: 'تصویر پس زمینه',
      form: 'فرم',
      submitForm: 'ثبت اطلاعات',
      items: 'گزینه‌ها',
      newMobileNumber: 'شماره همراه جدید',
      showForm: 'نمایش فرم',
      zoomToFit: 'تمام صفحه',
      reload: 'بارگزاری مجدد',
      if: 'اگر :',
      then: 'آنگاه :',
      mainUrlForCreateShortLinks: 'آدرس لینک کوتاه',
      singleDelete: 'حذف تکی',
      deleteWithChildren: 'حذف با زیرمجموعه',
      ifValue: 'مقدار :',
      fieldType: 'نوع فیلد',
      answerResponse: 'پاسخ به پیام',
      duplicationResponse: 'پیام تکراری',
      mobiles: 'شماره موبایل ها',
      myQuestionnaires: 'پرسشنامه‌های من',
      newQuestionnaire: 'پرسشنامه جدید',
      newSurvey: 'نظرسنجی جدید',
      farvardin: 'فروردین',
      ordibehesht: 'اردیبهشت',
      khordad: 'خرداد',
      tir: 'تیر',
      mordad: 'مرداد',
      shahrivar: 'شهریور',
      mehr: 'مهر',
      aban: 'آبان',
      azar: 'آذر',
      dey: 'دی',
      bahman: 'بهمن',
      esfand: 'اسفند',
      onlineSurvey: 'نظرسنجی',
      default: 'پیش فرض',
      blue: ' آبی',
      green: ' سبز',
      yellow: ' زرد',
      red: ' قرمز',
      purple: ' بنفش',
      white: 'سفید',
      orange: ' نارنجی',
      pink: ' صورتی',
      gray: ' خاکستری',
      introPage: 'صفحه شروع',
      outroPage: 'صفحه پایان',
      newQuestion: 'پرسش جدید',
      questionList: 'لیست پرسش‌ها',
      textInput: 'متنی',
      selectListInput: 'چندگزینه ای',
      answerCount: 'تعداد پاسخ',
      answer: 'پاسخ  ',
      question: 'پرسش',
      query: 'سوال',
      runtime: 'دوره اجرا',
      newAnswer: 'پاسخ جدید',
      editQuestion: 'ویرایش پرسش',
      answers: 'پاسخ‌ها',
      nextQuestion: 'پرسش بعدی',
      prevQuestion: 'پرسش قبلی',
      visitCount: 'تعداد بازدید',
      answerPattern: 'الگوی پاسخ',
      minLength: 'حداقل تعداد حروف ',
      maxLength: 'حداکثر تعداد حروف',
      onlineSurveyStatistics: 'آمار ',
      onlineSurveyResponses: 'لیست پاسخ ها',
      responseList: 'لیست پاسخ‌ها',
      created: 'تاریخ ثبت',
      finalQuestion: 'سوال پایانی',
      firstQuestion: 'اولین سوال',
      onlineSurveyTitle: 'عنوان نظرسنجی',
      responseCount: 'تعداد پاسخ',
      persianYear: 'سال شمسی',
      persianMonth: 'ماه شمسی',
      persianDay: 'روز شمسی',
      statisticsDateTime: 'تاریخ و ساعت',
      start: ' شروع',
      end: ' پایان',
      updateSurvey: 'ویرایش نظرسنجی',
      emptyMobiles: 'لیست شماره موبایل ها خالی است',
      surveyList: 'نظرسنجی آنلاین',
      addFromExistingFields: 'افزودن از فیلدهای آماده',
      questionTitle: 'متن سوال',
      copyLink: 'کپی کردن لینک',
      isPostPaid: 'پس پرداخت',
      word: 'کلمه',
      score: 'امتیاز',
      rank: 'رتبه',
      method: 'نوع تحلیل',
      addMobile: 'افزودن شماره موبایل',
      notValidAnswersResponse: 'پاسخ های نامعتبر',
      totalRecipients: 'مجموع گیرندگان انتخابی',
      expiringOrganizationsCount: ' سازمان‌های در حال انقضا',
      expiringUsersCount: ' کاربران در حال انقضا',
      expiringPrivateNumbersCount: ' خطوط در حال انقضا',
      suspendedUsersCount: ' کاربران مسدود شده',
      unAuthorizedUsersCount: ' کاربران احراز هویت نشده ',
      waitForConfirmApiTokensCount: 'توکن‌های بررسی نشده',
      notActiveLandingPagesCount: 'صفحات وب غیرفعال',
      notActiveShortLinksCount: 'لینک های کوتاه غیرفعال',
      waitForConfirmOtpsCount: ' قالب‌های پیامک احرازهویت بررسی نشده',
      waitForConfirmPaymentsCount: 'پرداخت‌های غیرآنلاین در حال بررسی',
      waitForConfirmSafeIpsCount: ' آی‌پی‌های بررسی نشده',
      waitForConfirmScheduledMessagesCount: ' ارسال‌های منتظر برای تایید',
      waitForConfirmSocialMediaFilesCount:
        ' فایل های شبکه اجتماعی منتظر برای تایید',
      canceledNotResentLocalNetworkOutboxMessageCount:
        ' ارسال های ثبت شده با سرشماره 999999',
      suggestedStrategies: 'استراتژی پیشنهادی',
      marketingAchievement: 'هدف بازاریابی',
      groups: 'گروه‌ها',
      menu: 'منو',
      requestBody: ' درخواست (Request Body)',
      apiResponse: 'پاسخ‌ها (Responses)',
      parameters: 'پارامترها (Parameters)',
      location: 'مکان',
      chequeImage: 'تصویر چک',
      logoUploader: 'آپلود لوگو',
      completeOperation: 'اتمام عملیات',
      recordVoice: 'ضبط صدا',
      delayType: 'نوع تاخیر در ارسال',
      delayValue: 'میزان تاخیر در ارسال',
      mobileNumberFieldName: 'ستون شماره موبایل',
      showsForChildrenOrganizations: 'نمایش برای سازمان های زیرمجموعه',
      organizationIdsForHide: 'سازمان‌های غیرمجاز برای مشاهده ی درگاه‌',
      organizationIdsForShow: 'سازمان های مجاز',
      googleSheetsSettings: 'تنظیمات google sheets',
      spreadSheetId: 'شناسه spreadSheet',
      crmAccessKey: 'کلید دسترسی CRM',
      crmUserName: 'نام کابری CRM',
      enableSaveResponseInCrm: 'ذخیره پاسخ در CRM',
      crmField: 'فیلد CRM',
      lostUsersPercent: ' مشتریان رویگردان',
      strategiesStatistics: 'دسته بندی مشتریان به گروه های مختلف',
      usersStatistics: 'آمار کاربران',
      totalUsersCount: 'تعداد کل مشتریان',
      customerCount: 'تعداد مشتری',
      person: 'نفر',
      buttonTitle: 'عنوان دکمه',
      firstPartOfGradualOrPeriodic: 'پارت اول ارسال تدریجی',
      userNotificationSettings: 'تنظیمات اعلان کاربر',
      organizationNotificationSettings: 'تنظیمات اعلان سازمان',
      notificationSetting: 'تنظیمات اطلاع رسانی',
      notificationSettingDescription:
        'تنظیمات دریافت اعلان‌ها را مدیریت کرده و با انتخاب هر مورد، جزئیات آن را ویرایش کنید.',
      enableSmsNotification: 'فعالسازی اعلان پیامکی',
      enablePanelNotification: 'فعال سازی اعلان پنل',
      mobilesForReceiveSmsNotification: 'شماره موبایل ها برای دریافت اعلان',
      senderPrivateNumber: 'شماره فرستنده',
      botId: 'شناسه‌ی بازو',
      isSendBulk2: 'ارسال انبوه ',
      isSendBulk: 'ارسال انبوه (آپدیت شماره)',
      fuzzyMatch: 'تطابق فازی',
      forPreProcess: 'برای پیش پردازش',
      semanticMatch: 'تطابق معنایی',
      newChat: 'چت جدید',
      isShortLinkCustomPage: 'قالب لینک کوتاه',
      chatList: 'لیست چت‌ها',
      newConversation: 'گفتگوی جدید',
      changeTitle: 'تغییر عنوان',
      updatePanel: ' به‌روزرسانی پنل',
      today: 'امروز',
      daysAgo: '{{day}} روز اخیر',
      monthsAgo: '{{month}} ماه اخیر',
      weeksAgo: '{{week}} هفته اخیر',
      functionality: 'خلاصه عملکرد',
      customDate: 'تاریخ دلخواه',
      assignStatusToUser: 'تخصیص وضعیت کاربر',
      isHaveCells: 'دارای دکل',
      isValidArea: 'منطقه معتبر',
      ussdCode: 'کد Ussd',
      ussdCallCost: ' هزینه کد ussd',
      rejectionDescription: 'توضیحات رد کردن',
      linkUrlForGenerateShortLink: 'آدرس لینک برای ساخت لینک کوتاه',
      showChat: 'نمایش چت',
      shortLinkReceivers: 'گیرندگان لینک کوتاه',
      shortLink: ' لینک کوتاه',
      createCampaign: ' ایجاد کمپین',

      toNumber: 'گیرنده',
      chooseDate: 'انتخاب تاریخ',
      regenerateApiTokenSecretKey: 'تولید مجدد کلید خصوصی',
      shortLinkCampaignPublicReport: 'آمار کمپین لینک کوتاه',
      closeTab: 'بستن',
      CloseOthers: 'بستن تب های دیگر',
      httpType: 'Http type',
      httpMethod: 'Http method',
      isGatewayCredit: 'اعتبار عامل',
      smsSetting: 'تنظیمات پیامک',
      groupUpdate: 'ویرایش گروهی',
      videoLink: 'لینک ویدئو',
      validate: 'اعتبارسنجی',
      validateIp: 'اعتبارسنجی آی پی',
      groupOrganizationConfirmation: 'تایید گروهی توسط سازمان ',
      organizationConfirmSend: 'تایید توسط سازمان ',
      updateSendTypesToConfirm: 'نوع ارسال ها برای تایید',
      landingPageShortUrl: 'لینک کوتاه صفحه وب',
      applyReadyTemplate: 'در حال اعمال قالب',
      antiSpam: 'ضد هرزنامه',
      mostAppendQueryString: 'انتقال کوئری استرینگ‌ها',
      shortLinkStats: 'آمار لینک کوتاه',
      map: 'نقشه',
      anotherMethodOfPayment: 'روش های دیگرِ پرداخت',
      newVersion: 'نسخه جدید',
      oldVersion: 'نسخه قدیمی',
      dateTimes: 'تاریخ و زمان',
      inquiryStartDate: 'تاریخ شروع استعلام',
      inquiryEndDate: 'تاریخ پایان استعلام',
      inquiryStartTime: 'زمان شروع استعلام',
      inquiryEndTime: 'زمان پایان استعلام',
      createRequest: 'ایجاد درخواست',
      enableCampaign: 'اجرای کمپین',
      disableCampaign: 'متوقف کردن کمپین',
      serverResponses: 'پاسخ های سرور',
      submitReport: 'گزارش وضعیت',
      refreshStatus: 'بروز‌رسانی وضعیت',
      sendDetail: 'جزئیات ارسال',
      sendSmartSms: 'ارسال مکان محور',
      newDomain: 'دامنه جدید',
      customerDomains: 'دامنه‌های مشتری',
      loginPageMode: 'صفحه لاگین',
      primaryColor: 'رنگ اصلی',
      secondaryColor: 'رنگ دوم',
      tertiaryColor: 'رنگ سوم',
      primaryForegroundColor: 'رنگ متن رنگ اصلی',
      darkPrimaryColor: 'حالت تیره رنگ اصلی',
      secondaryForegroundColor: 'رنگ متن رنگ دوم',
      tertiaryForegroundColor: 'رنگ متن رنگ سوم',
      sliderImages: 'تصاویر اسلایدر',
      desLink: 'لینک مقصد',
      templateType: 'نوع قالب',
      loginTheme: 'صفحه اصلی',
      resellerDomain: 'دامنه ی مشتری',
      resellerIdentityDomain: ' دامنه ی احرازهویت مشتری',
      agentLogo: 'لوگو',
      agentLogoDark: 'لوگوی حالت تیره (اختیاری)',
      lastModified: 'تاریخ آخرین ویرایش',
      resellerLink: 'لینک',
      dashboardMode: 'نوع نمایش داشبورد',
      eNamad: 'اینماد',
      userAccountInfo: 'مشخصات کاربری',
      userLocationInfo: 'مشخصات محل اقامت',
      userPersonalInfo: 'مشخصات فردی',
      profile: 'پروفایل',
      profileImage: 'تصویر پروفایل',
      dashboardCards: 'کاردهای داشبورد',
      dashboardSettings: 'تنظیمات داشبورد',
      card: 'کارت',
      cardDisplay: 'نوع نمایش',
      imagePath: 'لینک  تصویر',
      redirectLink: 'لینک هدایت',
      videoPath: 'لینک  ویدیو',
      confirmationStatus: 'وضعیت تایید',
      processTextResultStatus: 'وضعیت تحلیل',
      processTextResults: 'تحلیل متن پیامک',
      sendSpecifications: 'مشخصات ارسال',
      submitRequest: 'ثبت درخواست',
      aiAssistant: 'دستیار هوشمند',
      aiExperimental: 'نسخه آزمایشی',
      smartEditor: 'ویراستار هوشمند',
      aiGenerate: 'تولید متن',
      aiRewrite: 'بازنویسی متن ',
      aiTone: 'لحن پیام',
      aiLength: 'طول پیام',
      aiFidelity: ' وفاداری به متن اصلی ',
      aiGenerateAction: 'تولید متن',
      aiRewriteAction: 'بازنویسی متن',
      aiResult: 'متن تولید شده',
      aiCharacterCount: 'تعداد کاراکتر',
      aiCopy: 'کپی متن',
      aiCopied: 'کپی شد',
      aiUseResult: 'استفاده از این متن',
      aiDescription: 'توضیحات متن',
      aiDescriptionPlaceholder:
        'موضوع یا توضیحات پیام مورد نظر خود را وارد کنید...',
      aiAssistantDescription:
        'پیام خود را ایجاد کنید یا با حفظ مفهوم بازنویسی کنید',
      aiGenerateDescription: 'موضوع، هدف یا نکات اصلی پیام را بنویسید',
      aiRewriteDescription:
        'متن فعلی را وارد کنید تا نسخه‌ای روان‌تر دریافت کنید',
      aiRewritePlaceholder: 'متن پیام برای بازنویسی را وارد کنید...',
      aiOptional: 'اختیاری',
      aiSelect: 'انتخاب کنید',
      aiNone: 'هیچ‌کدام',
      aiFidelityCreativeDescription: 'آزادی بیشتر برای تغییر ساختار و واژه‌ها',
      aiFidelityBalancedDescription: 'تعادل میان تازگی متن و حفظ مفهوم',
      aiFidelityFaithfulDescription: 'بیشترین شباهت به متن و مفهوم اولیه',
      addEmoji: 'افزودن ایموجی',
      aiEmojiDescription: 'در صورت مناسب بودن، از ایموجی در متن استفاده شود',
      aiOptionsLoading: 'در حال آماده‌سازی گزینه‌های پیام...',
      aiOptionsUnavailable:
        'برخی گزینه‌ها بارگذاری نشدند؛ همچنان می‌توانید ادامه دهید.',
      aiProcessing: 'دستیار هوشمند در حال آماده‌سازی پیام است',
      aiTryAgain: 'تلاش دوباره',
      aiGenerateAgain: 'تولید دوباره',
      aiRewriteAgain: 'بازنویسی دوباره',
      aiBusinessCategory: 'حوزه فعالیت',
      aiBusinessCategoryPlaceholder: 'برای مثال: پوشاک، گردشگری یا آموزش',
      aiBusinessCategoryDescription:
        'حوزه فعالیت به تولید متن دقیق‌تر و متناسب‌تر کمک می‌کند.',
      aiFeedbackTitle: 'این پیشنهاد چقدر مفید بود؟',
      aiFeedbackDescription:
        'با ثبت بازخورد به بهبود پیشنهادهای بعدی کمک کنید.',
      aiFeedbackScore: 'امتیاز بازخورد',
      aiFeedbackScoreValue: 'امتیاز {{score}} از ۵',
      aiFeedbackTerrible: 'افتضاح بود',
      aiFeedbackBad: 'بد بود',
      aiFeedbackNotBad: 'بد نیست',
      aiFeedbackGood: 'خوبه',
      aiFeedbackExcellent: 'خیلی عالیه',
      aiFeedbackPlaceholder: 'توضیح بیشتر درباره این پیشنهاد (اختیاری)...',
      aiFeedbackSubmit: 'ثبت بازخورد',
      aiFeedbackThanks: 'بازخورد شما ثبت شد',
      aiFeedbackSubmitted:
        'از اینکه نظرتان را با ما به اشتراک گذاشتید، سپاسگزاریم.',
      aiFeedbackError: 'ثبت بازخورد انجام نشد؛ دوباره تلاش کنید.',
      aiTodayRemainingRequests: ' درخواست‌های باقیمانده امروز:',
      aiTodayUsedRequests: 'تعداد درخواست‌های استفاده‌شده امروز:',
      aiDailyLimit: 'سقف استفاده: ۵ درخواست در روز',
      aiDailyLimitWithFeedback: 'سقف استفاده: ۶ درخواست در روز',
      aiDailyLimitDescription:
        'با ثبت حداقل یک بازخورد، محدودیت روزانه از <b>{{currentLimit}}</b> به  <b>{{increasedLimit}}</b> افزایش می‌یابد.',
      proformaPayment: 'پرداخت پیش فاکتور',
      paymentRegistration: ' ثبت اطلاعات پرداخت',
      paymentFile: 'فایل رسید واریز',
      updateUserOrganizationalRole: 'تعیین تضمین',
      maximumCreditForGuarantee: 'سقف اعتبار ضمانتی',
      isHaveOrganizationalRole: 'دارای تضمین',
      liquidatePaymentByManagement: 'تسویه‌ی اعتبار بلوکه شده',
      userOrganizationalRole: 'جزئیات نقش میان سازمانی',
      organizationSendLimit: 'محدودیت ارسال',
      dailySendLimit: 'محدودیت ارسال روزانه',
      monthlySendLimit: 'محدودیت ارسال ماهانه',
      upgradeLevel: 'ارتقا سطح',
      authorizationLevel: {
        confirmedByShahkar: 'تایید شده توسط شاهکار',
        shahkarAdditionalInfoCompleted: 'اطلاعات تکمیلی شاهکار تکمیل شده',
        documentsConfirmed: 'مدارک تایید شده',
        enterprise: 'سازمانی',
      },
      continuePayment: 'ادامه‌ی پرداخت',
      totalAmount: 'مبلغ کل',
      confirmAuthenticated: 'تایید احراز هویت',
      rejectAuthenticated: 'رد احراز هویت',
      isHaveRegister: 'نمایش دکمه ثبت‌ نام',
      organizationWhichCanUse: 'سازمان‌های مجاز به استفاده',
      verifyDiscountCode: 'بررسی کد',
      digitsCount: 'تعداد ارقام',
      editPrice: 'ویرایش قیمت',
      rondRules: 'قوانین رند',
      rondCoefficient: 'تعریف سطح',
      free: 'رایگان',
    },
    messages: {
      dashboardCard: {
        bannerHint:
          'در صورت وارد کردن هم‌زمان لینک ویدیو و لینک تصویر، تصویر به‌عنوان پوستر ویدیو نمایش داده خواهد شد.',
        defaultHint:
          'در این حالت، کارت پیش‌فرض پروژه نمایش داده می‌شود که شامل اطلاعات کاربر و سازمانِ جاری است.',
        noneHint: 'در این حالت، این کارت نمایش داده نمی‌شود.',
        redirectLink:
          'برای لینک‌دهی به صفحات داخلی سایت، لینک را با # شروع کرده و نام صفحه را وارد کنید . نمونه :sendsms#',
      },
      clipboard: {
        message: 'جهت کپی کردن کلیک کنید',
        copied: 'کپی شد',
        copy: 'کپی',
        copyCardNo: 'کپی شماره کارت',
        copyIban: 'کپی شماره شبا',
        copyAccountNo: 'کپی شماره حساب',
        copyAmount: 'کپی مبلغ قابل پرداخت',
      },
      htmlStatus: {
        code400: 'درخواست ناصحیح',
        code401: 'عدم دسترسی',
        code403: 'عدم دسترسی',
        code404: '404',
        code405: 'خطا',
        code500: 'خطای سرور',
        code400Msg: 'درخواست شما با مشکل مواجه شده است..',
        code401Msg: 'جهت ادامه فرآیند لازم است ابتدا وارد سیستم شوید.',
        code403Msg: 'کاربر گرامی شما مجوز دسترسی به این قسمت را ندارید .',
        code405Msg: 'متد مجاز نیست',
        code500Msg: 'در برقراری ارتباط با سرور مشکلی رخ داده است.',
      },
      validationError: {
        minLength:
          ' <b>{{title}}</b> باید حداقل <b>{{minLength}}</b> کاراکتر باشد',
        maxLength:
          ' <b>{{title}}</b> باید حداکثر <b>{{maxLength}}</b> کاراکتر باشد',
        min: 'مقدار <b>{{title}}</b> نباید از <b>{{min}}</b> کمتر باشد',
        max: 'مقدار <b>{{title}}</b> نباید از <b>{{max}}</b> بیشتر باشد',
        mobileNumberIsInvalid: 'شماره موبایل نامعتبر است',
        invalid: ' <b>{{title}}</b> نامعتبر است',
        required: 'پر کردن فیلد <b>{{title}}</b> الزامی می باشد',
        globalRequired: 'پر کردن این فیلد الزامی می باشد',
        invalidEmail: 'آدرس ایمیل معتبر نمی باشد',
        maxFileSizeInMb:
          'حداکثر حجم مجاز فایل جهت آپلود {{size}} مگابایت می باشد',
        maxFileSizeInKb:
          'حداکثر حجم مجاز فایل جهت آپلود {{size}} کیلوبایت می باشد',
        allowedFilTypes: 'فایل هایی با پسوند های {{types}} مجاز می باشند',
        confirmPassword: 'تکرار کلمه عبور با کلمه عبور مطابقت ندارد',
        allowedFilTypesTip: 'فرمت های مجاز',
        fileMaxLengthInKB: 'حداکثر سایز فایل {{ size }} کیلوبایت می باشد',
        fileMaxLengthInGB: 'حداکثر سایز فایل {{ size }} گیگابایت می باشد',
        validFileTypes: 'فایل هایی با پسوند های {{types}} مجاز می باشند',
        fileMaxLength:
          'حداکثر حجم مجاز فایل جهت آپلود {{ size }} مگابایت می باشد. ',
        maxFileCount: 'حداکثر تعداد مجاز فایل جهت آپلود {{ count }} می باشد.',
        addAtLeastOneOption: 'حداقل یک پاسخ اضافه کنید',
        endDateShouldBiggerThanStartDate:
          'تاریخ پایان باید بزرگتر از تاریخ شروع باشد.',
      },
      filterHelp: {
        gender: 'جنسیت مخاطبان را مشخص کنید.',
        age: 'محدوده سنی دلخواه خود را انتخاب کنید',
        mobilePrefix: 'طول پیش‌ شماره باید بین ۴ تا ۸ رقم باشد.',
        deviceType: 'نوع دستگاه مخاطب را تعیین کنید.',
        deviceBrand:
          'ابتدا برند و سپس مدل‌های خاص دستگاه مخاطب را انتخاب کنید.',
        eghamatgah: 'وضعیت سکونت و وضعیت شغلی مخاطب را مشخص کنید.',
        residenceState: 'وضعیت سکونت مخاطب را مشخص کنید.',
        joberState: 'وضعیت شغلی مخاطب را مشخص کنید.',
        vacation:
          'وضعیت مسافرتی مخاطب و در صورت نیاز استان مبدا را تعیین کنید.',
        jobs: 'از لیست مشاغل مرتبط با هنر و فرهنگ انتخاب کنید.',
        irancellOperatorOnly: 'صرفا مختص اپراتور ایرانسل',
      },
      operatorSelectionRule:
        'اپراتور مورد نظر خود را انتخاب کنید، انتخاب حداقل یک اپراتور اجباری است.',
      timeoutError:
        'عملیات به دلیل تاخیر در اتصال، انجام نشد. لطفاً دوباره تلاش کنید یا با پشتیبانی تماس بگیرید.',
      noItemsToDisplay: 'موردی برای نمایش وجود ندارد',
      sendMessageHelp:
        '<p class="mt-3 mb-1">⁃ در صورت نیاز به تگ HTML، آن را در پرانتز بنویسید. مثل: (p)</p><p class="my-1"> ⁃ جهت مشاهده متن پیامک نهایی روی کلید <b>پیش نمایش پیامک</b> کلیک نمایید.</p><p class="my-1">⁃ الگوی پیامک، قالبی از پیش‌تعریف‌شده برای ارسال پیام با ساختاری مشخص است. برای مشاهده، ویرایش یا افزودن الگوهای جدید، از لیست <b>الگوهای پیامک</b> استفاده نمایید.</p>',
      sendMessageHelpExceptPattern:
        '<p class="my-1">⁃ برای درج سریع و دقیق لینک در متن پیامک، از لیست<b> لینک‌های کوتاه</b> استفاده نمایید.</p><p class="my-1">⁃ سرتیتر پیامک متنی است که در ابتدای پیامک نمایش داده می‌شود ؛ جهت افزودن آن از گزینه <b>سرتیتر پیامک</b> استفاده نمایید.</p><p class="my-1">⁃ امضای پیامک متنی ثابت است که در انتهای پیامک نمایش داده می‌شود؛ جهت درج آن، از گزینه <b>امضای پیامک</b> استفاده نمایید.</p>',
      sendVoiceMessageHelp:
        ' <p class="my-1">    ⁃ ابتدا <b> گروه صدا</b> را انتخاب کنید تا لیست پیام های صوتی مرتبط نمایش داده شود، سپس <b> پیام صوتی</b> موردنظر را برای پخش هنگام تماس انتخاب نمایید.  </p>  <p class="my-1">    ⁃ در صورت عدم پاسخ‌گویی گیرنده، سیستم تا تعداد مشخص‌شده <b> تلاش مجدد</b> که حداکثر 3بار می‌باشد،برای برقراری تماس انجام می‌دهد.  </p>  <p class="my-1">    ⁃ <b> مدت تاخیر</b> بین هر تلاش تماس را تعیین کنید تا تماس‌ها به‌صورت پی‌درپی انجام نشوند.  </p>',
      selectedFilters: 'فیلترهای انتخاب شده',
      socialMediaMessageHelp:
        'فایل انتخابی جهت ارسال شبکه اجتماعی به گیرندگان را تعیین نمایید.',
      socialMediaApplicationsHelp:
        'پیام‌رسان مورد نظر جهت ارسال پیام را انتخاب نمایید.',
      selectedLoginPageTemplate:
        'لطفا قالب صفحه ورود مورد نظر خود را انتخاب کنید :',
      fewMinutesAgoWithMin: '{{min}} دقیقه پیش',
      hoursAndMinutesAgo: '{{hours}} ساعت و {{minutes}} دقیقه پیش',
      hoursAgo: '{{hours}} ساعت پیش',
      daysAndHoursAndMinutesAgo: '{{days}} روز و {{hours}} ساعت پیش',
      daysAgo: '{{days}} روز پیش',
      monthsAgo: '{{month}} ماه پیش',
      yearsAgo: '{{year}} سال پیش',
      momentsAgo: 'لحظاتی پیش',
      fewMinutesAgo: 'چند دقیقه پیش',
      allowedFilTypesMsg:
        'فرمت‌های مجاز شامل موارد زیر هستند: png, jpg, jpeg, mp3, wav.',
      markReadAllNotifications: 'خواندن همه اعلان ها',
      sendTicketToSupport: 'ارسال تیکت به پشتیبانی',
      chooseReportTimeRange: 'بازهٔ زمانی گزارش را انتخاب کنید.',
      statisticsDoughnutChartText: 'تعداد کل پیام های ارسال شده',
      statisticsBarChartText: 'تعداد پیام های ارسال شده به تفکیک زمان ارسال',
      clipBoardAndFileUploadWarning:
        'توجه داشته باشید امکان استفاده از حالت های <b>آپلود فایل</b> و <b>کلیپ بورد</b>بصورت ترکیبی وجود ندارد. <br> <br> در حالت <b class="text-red-500 dark:text-red-400">{{modeWithDataTitle}}</b> اطلاعاتی ثبت شده است .با رفتن به حالت <b class="text-red-500 dark:text-red-400">{{modeTitle}}</b> این اطلاعات حذف خواهند شد. با این وجود از رفتن به حالت <b class="text-red-500 dark:text-red-400">{{modeTitle}}</b> مطمئن هستید؟',
      minlengthValidationError:
        'طول {{title}} نباید از {{minLength}} رقم کمتر باشد.',
      maxValidationError: ' {{title}} نباید از {{max}} رقم بیشتر باشد.',
      minValidationError: ' {{title}} نباید از {{min}} کمتر باشد.',
      maxlengthValidationError: ' {{title}} نباید از {{maxLength}} بیشتر باشد.',
      minNumberValidationError: ' {{title}} نباید از {{min}} کمتر باشد.',
      maxNumberValidationError: ' {{title}} نباید از {{max}} بیشتر باشد.',
      maxMobileNumbers:
        'حداکثر می توانید {{maxMobileNumbers}}شماره موبایل ثبت کنید . ',
      maxMobileNumbersInManualMode:
        ' در حالت دستی حداکثر می توانید {{maxMobileNumbersInManualMode}} شماره موبایل ثبت کنید. ',
      maxMobileNumbersInClipBoardMode:
        ' در حالت کلیپ بورد حداکثر می توانید {{maxMobileNumbersInClipBoardMode}} شماره موبایل ثبت کنید. ',
      deleteMessage: 'آیا از حذف این مورد مطمئن هستید ؟',
      deleteMenuMessage: 'آیا از حذف این منو مطمئن هستید ؟',
      deleteEndPointMessage: 'آیا از حذف این اندپوینت مطمئن هستید ؟',
      confirmByWritingTextMessage:
        'با حذف این مورد تمامی زیرگروه‌ها و داده‌های ذخیره شده مرتبط حذف می شوند . ',
      confirmByWritingTextMessageForStopSending:
        'در صورتی که ارسال متوقف شود، ادامه ارسال متوقف می شود ',
      directLineTargets:
        'در این بخش می‌توانید تعیین کنید کدام یک از موارد زیر برای ارسال پیام‌ها از خط سیستم استفاده کنند.',
      cellListMessage:
        'در منطقه انتخاب شده اپراتور های زیر پشتیبانی می شود ، اگر اپراتور مورد نظر شما در لیست زیر وجود ندارد پیشنهاد می شود نسبت به تغییر یا بزرگ تر کردن مختصات خود اقدام کنید. ',
      confirmText: 'برای تایید عدد زیر را وارد کنید ',
      confirmPayment: 'آیا از تایید کردن این پرداخت مطمئن هستید ؟',
      rejectPayment: 'آیا از رد کردن این پرداخت مطمئن هستید ؟',
      cancelProformaInvoice: 'آیا از لغو این پیش فاکتور مطمئن هستید ؟',
      rejectSend: 'آیا از عدم تایید این ارسال مطمئن هستید ؟',
      allExcelReport: 'دانلود همه با فرمت Excel',
      pageExcelReport: 'دانلود صفحه بصورت Excel',
      pageTxtReport: 'دانلود صفحه با فرمت Text',
      allTxtReport: 'دانلود همه بصورت Text',
      numberOfItemsEnteredExceedsTheAllowedLimit:
        'تعداد آیتم‌های وارد شده بیش از حد مجاز (50000) است!',
      changePasswordMsg:
        'کاربر گرامی نیاز است جهت حفظ امنیت حساب کاربری خود، کلمه عبور خود را تغییر دهید.',
      verificationCodeIsInvalid: 'کد تایید نامتعبر است',
      textMaxLength: 'حداکثر سایز متن {{ size }} مگابایت می باشد',
      textMaxLengthInManualMode:
        'حداکثر حجم متن در حالت دستی  {{ size }} مگابایت می باشد. جهت جای گذاری با حجم بیشتر از حالت کلیپ بورد استفاده نمائید.',
      textMaxCorrectMobileNumberCountInManualMode:
        'در حالت دستی حداکثر می توانید {{size}} شماره موبایل ثبت کنید .',
      validMediaTypes: 'فایل هایی با پسوندهای زیر مجاز میباشند: ',
      successfulOperation: 'عملیات موفق',
      isDateTimeInvalid: 'اعتبار تاریخ گذشته است',
      periodDateTimeErrorMsg:
        ' هنگامی که تاریخ شروع و تاریخ پایان برابر هستند ، ساعت شروع نمی تواند بیشتر از ساعت پایان باشد.',
      failedOperation: 'عملیات {{ operation }}  ناموفق',
      cannotBeDisplayed: 'فایلی برای نمایش وجود ندارد',
      OptimalSearch: 'برای جستجو حداقل سه حرف الزامی است',
      currencyAlert: 'قیمت ها  بر اساس  {{ currency }} می باشد .  ',
      contentIsInvalid: 'محتوا نامعتبر است',
      EndDateNotBeforeStartDate: 'تاریخ پایان نباید قبل از تاریخ شروع باشد.',
      SelectedTimePeriodShouldNotExceed3Months:
        'بازه زمانی انتخابی نباید بیشتر از ۳ ماه باشد.',
      StartDateNotBeforeToday: 'تاریخ شروع نباید از امروز بزرگ‌تر باشد.',
      chooseItem:
        '* با زدن کلید  <i class="mdi mdi-text-box-plus-outline text-blue-500 dark:text-blue-400 mdi-22px"></i> می توانید آیتم موردنظر خود را انتخاب کنید.',
      searchInOrganizations: 'جستجو در سازمان ها',
      searchInRoles: 'جستجو در نقش ها',
      insertMobile: 'شماره موبایل خود را وارد کنید',
      sliderTimeErr: 'خطا: حداقل نمی‌تواند بیشتر از حداکثر باشد',
      searchAggregator:
        'لطفا شماره موبایل را وارد کنید و سپس روی جستجو کلیک کنید',
      isValidNumber: 'لطفا شماره موبایل را وارد کنید و سپس روی تایید کلیک کنید',
      searchInUsers: 'جستجو در کاربران',
      internationalTariffisaPercentage:
        'کاربر گرامی تعرفه بین المللی <b>درصدی است</b>',
      internationalTariffisNotPercentage:
        'کاربر گرامی تعرفه بین المللی <b>درصدی نیست</b>',
      searchInPrivateNumbers: 'جستجو در خطوط اختصاصی',
      searchInPhonebooks: 'جستجو در دفترچه تلفن',
      searchInContacts: 'جستجو در مخاطبین',
      searchInTargetPrivateNumbers: 'جستجو در خط فرستنده',
      searchText: 'متن جستجو',
      smartRequestTypesDescription:
        'برای ارسال مکان محور لطفاً نوع درخواست مورد نظر خود را انتخاب نمایید.',
      phoneNumberPlaceholder: 'شماره موبایل بدون صفر',
      enterSocialnetworkIdPlaceHolder: 'آیدی شبکه اجتماعی را وارد کنید',
      showSearch: 'نمایش فیلترها',
      isAddSignature: 'امضا به متن پیامک اضافه شود',
      quitMsg: 'آیا قصد خروج از حساب کاربری خود را دارید؟',
      logoutConfirmMsg: 'آیا از خروج خود اطمینان دارید؟',
      hideSearch: 'بستن فیلترها',
      imageNotUploaded: 'تصویری آپلود نشده',
      simpleSmartRequestType:
        'در این نوع ارسال، پیامک به صورت تکراری و بدون محدودیت دفعات، به یک گیرنده فرستاده می‌شود.',
      welcomeSmartRequestType:
        ' در این نوع ارسال با ورود هر فرد برای اولین بار به یک محدوده جغرافیایی مشخص، یک بار پیامک برای او ارسال می‌شود.',
      clubSmartRequestType:
        'در این نوع ارسال، پیام صرفاً به اعضای باشگاه مشتریان انتخابی که در زمان مشخص در محدوده تعیین شده حضور داشته باشند، ارسال خواهد شد.',
      welcomeWithCellsSmartRequestType:
        'در این نوع ارسال افراد حاضر در محدوده موردنظر از طریق لیست شناسه دکل های مخابراتی منطقه شناسایی شده و پیام برای آن‌ها ارسال می‌گردد.',
      welcomeForCitySmartRequestType:
        ' این نوع ارسال برای همه افراد حاضر (شهروند یا مسافر) در یک یا چند شهر خاص  انجام می‌شود.',
      welcomeForProvinceSmartRequestType:
        'این نوع ارسال برای همه افراد حاضر (شهروند یا مسافر) در یک یا چند استان خاص انجام می‌شود.',
      welcomeForAirportsSmartRequestType:
        ' این نوع ارسال، فقط برای مسافرانی انجام می‌شود که مقصد سفرشان فرودگاه انتخاب‌شده باشد و در زمان حضور در همان فرودگاه، پیام را دریافت می‌کنند.',
      entireClubSmartRequestType:
        ' در این نوع درخواست، پیام بدون نیاز به تعیین موقعیت مکانی، برای تمامی اعضای باشگاه مشتریان انتخاب‌ شده ارسال می‌شود.',
      ResidentialSmartRequestType:
        'در این نوع ارسال، پیام‌ها به صورت مکان محور و بر اساس موقعیت جغرافیایی ساکنین ارسال می‌شوند.',
      sustainabilityPresentSmartRequestType:
        'در این نوع ارسال، پیامک فقط به افرادی ارسال می‌شود که طی مدت‌زمان مشخصی در محدوده تعیین‌شده حضور مستمر داشته‌اند و از رهگذران صرف نظر می‌گردد.',
      fileNotUploaded: 'فایلی آپلود نشده',
      fileIsInvalid: ' فایلی یافت نشد',
      maxIpTotalCount: '*حداکثر میتوانید 15 آی پی انتخاب کنید',
      guideToUsingSignatureAndHeader:
        '* کاربر گرامی جهت مشاهده و ویرایش امضای پیامک، از گزینه  <i class="mdi mdi-draw-pen mdi-20px  text-blue-500 dark:text-blue-400 mt-1 bg-blue p-1  rounded-circle bg-blue-50 hover:bg-blue-500 hover:text-white"></i> و به منظور مشاهده و ویرایش سرتیتر پیامک، از گزینه <i class="mdi mdi-message-reply-text-outline mdi-20px text-blue-500 dark:text-blue-400 mt-1 bg-light-info p-1  rounded-circle"></i> استفاده فرمایید.',
      uneditableSignature:
        '* امضای ارسال کننده غیر قابل ویرایش و امضای سازمان قابل ویرایش می‌باشد.',
      isExistSignatureInSmsBody:
        '* در صورتی که امضای ارسال کننده در متن پیام وجود داشته باشد، امضای سازمان در ابتدا نوشته می شود.',
      editableOrganizationSignature: '* امضای سازمان قابل ویرایش می‌باشد.',
      noExistOrganization: 'سازمانی یافت نشد !',
      filterByGroup: 'فیلتر بر اساس گروه',
      updateCreditMessage: 'جهت بروزرسانی کلیک کنید',
      separateByEnter: 'جداکننده با کلید enter',
      separateByCommaAndEnter: 'جداکننده با کاما یا کلید enter',
      removeContactFromAllPhonebook: 'حذف از همه گروه ها',
      chipListPlaceholder: 'جداکننده با کاما یا کلید enter',
      confirmPassword: 'تکرار کلمه عبور با کلمه عبور مطابقت ندارد.',
      invalidDateErrorMsg: 'زمان استفاده از این سرویس به پایان رسیده است.',
      invalidDateErrorMsgInSend:
        'کاربر گرامی تاریخ یا زمان ارسال ثبت شده از موعدش گذشته است. جهت ارسال پیامک ، تاریخ و زمان ارسال را مجدداً تنظیم نمائید.',
      invalidMinDate:
        'تاریخ باید از تاریخ جاری بیشتر یا برابر تاریخ انتخاب شده قبلی باشد',
      maxOpenTab: 'حداکثر می‌ توانید {{ count }} تب باز کنید .',
      unblockUserMessage: 'آیا از رفع مسدودی این کاربر اطمینان دارید؟',
      noConnectionToServer: 'در برقراری ارتباط با سرور مشکلی رخ داده است',
      accountDeactivatedTitle: 'حساب کاربری شما غیرفعال شده است',
      accountDeactivatedDescription:
        'به دلیل عدم تأیید احراز هویت، حساب کاربری شما غیرفعال شده است. برای پیگیری و دریافت راهنمایی، لطفاً با پشتیبانی تماس بگیرید.',
      planExpiredTitle: 'پلن شما منقضی شده است',
      planExpiredDescription:
        'پلن شما منقضی شده و دسترسی شما به خدمات محدود شده است. برای ادامه استفاده از خدمات و رفع محدودیت دسترسی، لطفاً نسبت به تهیه پلن جدید اقدام کنید.',
      accessRestricted: 'دسترسی شما محدود شده است',
      planExpiringSoonTitle: 'پلن فعلی شما به‌زودی منقضی می‌شود',
      planExpiringSoonMessage:
        'اعتبار پلن شما در حال پایان است. در صورت انقضای پلن، دسترسی شما به خدمات محدود خواهد شد. برای جلوگیری از وقفه در روند کاری، لطفاً پیش از پایان اعتبار، پلن خود را تمدید یا پلن جدیدی تهیه کنید.',
      planRemainingDays:
        'تنها {{count}} روز تا پایان اعتبار پلن شما باقی مانده است.',
      planRemainingHours:
        'تنها {{count}} ساعت تا پایان اعتبار پلن شما باقی مانده است.',
      notOrganization: 'کابر گرامی در حال حاضر شما عضو سازمانی نیستید.',
      expired: 'منقضی شده',
      expiredAccountMessage: 'کاربر گرامی، حساب شما منقضی شده است.',
      maxRangeMonth: 'حداکثر بازه قابل فیلتر برای تاریخ 30 روز است.',
      expireDateTime: 'اعتبار تاریخ یا زمان به پایان رسیده است',
      globalConfirmationMessage: 'آیا از انجام این عملیات مطمئن هستید ؟',
      archiveConfirmationMessage: 'آیا از آرشیو کردن این مورد مطمئن هستید ؟',
      notAuthenticated: 'سازمان فعلی شما احراز هویت نشده است.',
      fullTextDisplay: 'برای نمایش کامل متن کلیک کنید',
      fullText: 'متن کامل',
      clickToSeeDetails: 'جهت مشاهده جزئیات کلیک کنید.',
      notUploadFileCustom:
        'کاربر گرامی ، برای لینک کوتاه با صفحه اختصاصی نیاز به بارگذاری فایل نیست.',
      notUploadFileShortLink:
        'کاربر گرامی ، برای لینک کوتاه موقت نیاز به بارگذاری تصویر و ویدیو درون صفحه نیست.',
      successSend: 'با موفقیت ارسال شد',
      minimumVisibleColumnsMessage: 'حداقل دو ستون باید نمایش داده شود.',
      resendMessageConfirmation: 'آیا از ارسال مجدد پیام های زیر مطمئن هستید ؟',
      groupDeletionConfirmation: 'آیا از حذف  موارد زیر مطمئن هستید ؟',
      deleteAllContactConfirmation: 'آیا از حذف  تمامی مخاطبین مطمئن هستید ؟',
      apiTokenconfirmation: 'آیا از تایید کردن این توکن مطمئن هستید ؟',
      apiTokenUndoconfirmation: 'آیا از عدم تایید این توکن مطمئن هستید ؟',
      selectItems: 'سطری را انتخاب کنید',
      eventTitle: 'توضیحی برای این مناسبت وجود ندارد',
      mapHelp:
        '<b>ابزارهای نقشه</b> </br> Zoom in (بزرگنمایی نقشه)</br> zoom out (کوچک کردن نقشه) </br> ذخیره محدوده جغرافیایی (ثبت منطقه ی انتخاب شده) </br> polygon tool (ابزار انتخاب محدوده روی نقشه که حداقل به انتخاب 3 نقطه برای تعیین محدوده نیاز است) </br> delete (حذف محدوده ی انتخاب شده) </br>جهت ویرایش، روی محدوده انتخاب شده کلیک کرده و به وسیله نقاطی که ظاهر میشوند محدوه را ویرایش نمایید.   </br> همچنین می‌توانید با انتخاب نقاط وسطی، مناطق (نقاط) بیشتری به محدوه خود اضافه نمایید.',
      excelColListError:
        'فرمت ستون های فایل حتماً باید از نوع Text و با حروف انگلیسی و بدون فاصله باشد.',
      notRegistered: 'هنوز عضو نشده اید ؟',
      loginToYourAccount: 'به حساب کاربری خود وارد شوید',
      loginPageWelcome: 'پیام‌رسانی حرفه‌ای در یک پلتفرم',
      secureLogin: 'ورود امن',
      fastAccess: 'دسترسی سریع',
      notLoggedIn: 'حساب کاربری دارید ؟',
      isValidIfConditionType:
        'ارسال از قالب با شرایط انتخابی امکان پذیر نمی باشد',
      isInvalidNumber: 'ارسال از خط انتخاب شده امکان پذیر نمی باشد',
      forgetPassword: ' جهت بازیابی کلمه عبور نام کاربری خود را وارد نمائید.',
      passwordRole:
        'کلمه عبور باید ترکیبی از اعداد و حروف بزرگ و کوچک انگلیسی و کاراکترهای ^£$%&*()}{@#~?><>,|=_+- باشد.',
      minLengthField:
        'طول  {{ formFieldName }} نباید از {{minLength}} کاراکتر کمتر باشد.',
      selectFileFromFileManager: 'لطفا فایلی را انتخاب کنید',
      emptyWordList: 'لیست کلمات خالی است ',
      notSelectAnyOrganization: 'هیج سازمانی انتخاب نشده است',
      notSelectAnyMenu: 'هیج منویی انتخاب نشده است',
      ifNumberIsNotServiceSmsWillNotBeSentToBlackList:
        '  در صورتی که خط انتخابی خدماتی نباشد ، پیامک برای شماره تلفن هایی که در لیست سیاه هستند ارسال نمی شود.',
      deActiveAuthentication:
        'در صورت ادامه ی ویرایش احرازهویت {{userName}} غیرفعال می‌شود و مدیر باید حساب {{userName}} را دوباره تایید کند. آیا مطمئن هستید؟',
      selectPrivateNumberForPhonebooks:
        'جهت مشاهده مخاطبین، ارسال کننده را انتخاب نمائید.',
      selectPrivateNumberForAllNotificationSettings:
        'برای همه موارد تنظیمات اعلان، شماره فرستنده را انتخاب نمائید.',
      selectPrivateNumberForNotificationSetting:
        'برای این مورد از تنظیمات اعلان، شماره فرستنده را انتخاب نمائید.',
      selectOrganizationForRoles: 'جهت مشاهده نقش ها سازمان را انتخاب نمائید.',
      contactImportFromExcelMaxLength:
        'حداکثر تعداد کاربران مجاز برای ثبت، {{maxLength}} می‌باشد.',
      inGroup: 'در گروه',
      requiredUserIds: 'فیلد شناسه کاربری الزامی است',
      requiredPrivateNumbers: ' فیلد شناسه خط اختصاصی الزامی است',
      requiredMsg: 'انتخاب حداقل یک مورد الزامی است.',
      deleteFromPhonebooks:
        'دقت بفرمایید اگر شماره همراه وارد شده در گروه‌ دیگری نیز وجود داشته باشد، درصورت انتخاب آن گروه‌، شماره‌ی درحال ثبت در گروه جاری اضافه نمی‌شود.',
      sendingSms: 'در حال ارسال پیامک',
      isHaveNotExpiredPlan:
        'به دلیل داشتن پلن فعال، تاریخ و ساعت انقضا قابل تغییر نیست.',
      creatingCampaign: 'در حال ایجاد کمپین',
      generateRandomPassword: 'ایجاد کلمه عبور تصادفی',
      calcSmsPrice: 'در حال محاسبه هزینه',
      pleaseWaiting: 'لطفاً شکیبا باشید',
      err404Msg: ' صفحه موردنظر یافت نشد !',
      enterYourText: 'متن موردنظر خود را وارد کنید',
      isExistFilePatch:
        '<p>جهت تکمیل فرآیند تبدیل متن به صوت روی کلید پخش کلیک کنید.</p> <p>فایل صوتی موردنیاز است .</p>',
      maxReceiversMsg: 'حداکثر می توانید {{number}} شماره اضافه کنید.',
      statusListMsg: 'وضعیت هایی که شامل این گزینه می شوند عبارتند از',
      onlyJpegAndPngAreAllowed:
        'تنها فایل هایی با پسوند {{allowedFiles}} مجاز میباشند',
      maxSizeIs1mb: 'حداکثر حجم هر فایل نباید از 1 مگابایت بیشتر باشد',
      uploadInfo:
        'فقط فایل‌های {{allowedFiles}} مجاز هستند.حداکثر حجم فایل ۱ مگابایت است.',
      receiversExcel: 'لطفا عنوان فایل اکسل را وارد کنید',
      successfulPurchase: 'خرید شما با موفقیت انجام شد.',
      successfulDiscount: 'کد تخفیف اعمال شد.',
      notEnoughCredit: 'اعتبار شما کافی نمی باشد.',
      ruleConfirmation:
        ' ضمن مطالعه دقیق وآگاهی از شرایط و مقررات اقدام به خرید کرده و شرایط را می پذیرم',
      privateNumberPurchaseRulesTitr:
        'محتوای پیامک‌ها باید با اصول و ضوابط زیر مطابق باشد',
      organizationInfo: 'مشخصات سازمان',
      userInfo: 'مشخصات کاربری',
      userLocationInfo: 'مشخصات محل اقامت',
      userPersonalInfo: 'مشخصات فردی',
      planInfo: 'مشخصات پلن',
      daysLeftUntilExpires: 'روز مانده تا انقضا ',
      hoursLeftUntilExpires: 'ساعت مانده تا انقضا ',
      buyPlanUserInfoNotice:
        'کاربر گرامی جهت خرید پلن لازم است به حساب کاربری خود وارد شود . اگر حساب کاربری ندارید روی کلید ثبت نام کلیک کنید.',
      enterAuthCode: 'کد تایید را وارد کنید',
      filterDescription:
        'در این بخش، فیلترهای دلخواه خود را فعال و مقداردهی کنید ، همچنین امکان استفاده همزمان از چند فیلتر وجود دارد.',
      cancelRequest:
        '<span>درخواست شما در حال پردازش است،<br>ممکن است کمی زمانبر باشد.</span>',
      noTextForShow: 'هیچ متنی برای نمایش وجود ندارد!',
      sendersListAlert:
        '<span><span>● کاربر گرامی جهت مشاهده ارسال کنندگان گزینه مورد نظر خود را انتخاب نمایید.</br>● در صورتی که هیچ گزینه ای را انتخاب نکرده باشید ، لیست تمامی ارسال کنندگان نمایش داده می شود.</span></span>',
      lotteryAlert:
        '<span> کاربر گرامی جهت انجام قرعه کشی ، می توانید گزینه مورد نظر خود را انتخاب کنید تا قرعه کشی بین افرادی که این گزینه را انتخاب کرده اند صورت گیرد.</span>',
      lotteryNotStart:
        ' جهت انجام قرعه کشی تعداد برندگان را مشخص کنید ، سپس بر روی دکمه قرعه کشی کلیک کنید .',
      numberOfWinnersLessThanNumberOfParticipants:
        'تعداد برندگان وارد شده از تعداد شرکت کنندگان بیشتر است',
      numberOfParticipants: 'جهت انجام قرعه کشی شرکت کننده ای وجود ندارد.',
      addToQueue: 'آیا از اضافه کردن مجدد پیام زیر به صف ارسال مطمئن هستید؟',
      getCurrentIpHelp1: '* برای اطلاع از آی پی جاری خود میتوانید',
      getCurrentIpHelp2: 'را انتخاب کنید',
      wrongIndex: 'اندیس گذاری اشتباه است',
      pleaseEnterRequestNameToContinue:
        'لطفاً نام یکتا درخواست خود را وارد نمایید',
      rangeDetail:
        'دقت داشته باشید برای رنج آی پی باید رقمی بزرگتر از آخرین رقم آدرس آی پی انتخاب کنید',
      selectPolygon: 'لطفا یک محدوده را انتخاب کنید.',
      disableMapInSmartSms:
        ' در این نوع درخواست ارسال مکان محور ، انتخاب محدوده از روی نقشه غیر فعال است',
      disableMapInSmartSmsDetail:
        ' در این نوع درخواست ارسال مکان محور ، نقشه غیر فعال است',
      smartPeriodicMessage:
        'کاربر گرامی،      توجه داشته باشید درصورت انتخاب بیش از یک منطقه و یا بیش از یک اپراتور، تعداد ارسالی که در فیلد مربوطه وارد می‌کنید به صورت مجزا برای هر منطقه درنظر گرفته می‌شود.',
      socialMediaSizeRangeMessage: ' حجم فایل‌ها بر اساس کیلوبایت',
      dragFile: 'فایلی را درگ یا انتخاب کنید',
      pasteInfinite: 'جهت جایگذاری بینهایت،روی دکمه کلیک کنید.',
      mapOfTheCampaignLocation: 'نقشه محل اجرای کمپین',
      theNumberOfSMSSentByOperator: 'تعداد پیامک هاي ارسالی به تفکیک اپراتور',
      theNumberOfSMSSentByStatus: 'تعداد پیامک هاي ارسالی به تفکیک وضعیت',
      smsBodyContainsHeaderOrSignature:
        '⁃ توجه داشته باشید برای این ارسال کننده امضا یا سرتیتر پیامک تعریف شده است.',
      messageAdditionalItemsLabel:
        'کاربر گرامی موارد زیر به متن پیام اضافه می‌شود (جهت مشاهده روی&nbsp;هر مورد کلیک کنید).',
      clickToShowFile: 'جهت مشاهده روی فایل کلیک کنید',
      forbiddenCharacters:
        'در متن پیام، استفاده از کاراکتر {{forbiddenCharacters}} غیر مجاز می‌باشد.',
      activePeriodicSmartSmsRequestsDescription:
        'جدول زیر لیست آخرین کمپین های فعال در حال اجرای کاربر را نمایش می دهد. ',
      isUseSeparatorChangeMessage:
        'با تغییر این گزینه، صفحه مجدداً بارگذاری می‌شود.',
      flashSmsDescription:
        'در این نوع ارسال به محض دریافت پیام، بدون نیاز به باز کردن برنامه پیامک به صورت تمام‌صفحه روی گوشی گیرنده نمایش داده می‌شود و پس از بستن، معمولاً در حافظه ذخیره نمی‌شود.',
      noRecipientsMessage:
        'برای ارسال پیام، نیاز است که حداقل یک گیرنده اضافه کنید.',
      reversePolygonAlert:
        'در صورت انتخاب گزینه ی زیر، اگر نیازی به مختصات فعلی روی نقشه ندارید، ابتدا آن را حذف کنید',
      searchPublicPlacesPlaceholder:
        'برای نمایش مکان‌های عمومی شهر و استان را انتخاب کرده و نام مکان مورد نظر را در فیلد جستجوی عمومی وارد کنید.',
      noCellMessage: 'منطقه با توجه به اپراتور انتخابی دارای دکل نمی‌باشد.',
      wrongCellList: 'مقدار وارد شده برای لیست دکل ها صحیح نمی باشد',
      emptyMobileNumbers: 'لیست شماره های همراه خالی است.',
      periodicPatterns:
        'لیست الگوها در زیر ارائه شده است شما می توانید الگوی انتخاب روز مدنظر خود را انتخاب نمائید.',
      changePeriodicPatterns:
        'توجه داشته باشید انتخاب حداقل یک روز الزامی می باشد و درصورتی که روزی انتخاب نشده باشد بصورت پیش فرض تمامی روزهای بازه‌ی انتخابی در نظر گرفته می‌شود.',
      choosePeriodicPattern: 'انتخاب الگو و روزهای ارسال',
      showCalender:
        'جهت نمایش تقویم لازم است در ابتدا تاریخ شروع و تاریخ پایان را انتخاب نمائید',
      chooseDaysFromCalender:
        'به منظور نمایش و انتخاب روزهای ارسال بر‌روی دکمه نمایش تقویم کلیک کنید.',
      defaultDaysOfWeekIsSelected:
        'بصورت پیش فرض تمامی روزهای بازه‌ی انتخاب شده در نظر گرفته می شود.',
      rejectUserSafeIp: 'آیا از رد کردن این آی پی مطمئن هستید؟',
      confirmUserSafeIp: 'آیا از تایید این آی پی مطمئن هستید ؟',
      useTag: 'در صورت نیاز به تگ HTML، آن را در پرانتز بنویسید. مثل: (p)',
      enterDescription: 'توضیحات را وارد کنید',
      inputCodeInEditor: 'نمونه کد موردنظر خود را وارد کنید',
      inputBodyCodeInEditor: 'نمونه کد Body را وارد کنید',
      searchInModels: 'برای جستجو در مدل‌ها، از حروف بزرگ استفاده کنید.',
      isForceSearchOrganization:
        'برای مشاهده  ی نتایج در این منو ، لطفا ابتدا سازمان خود را انتخاب کنید',
      isForceSearch:
        'برای مشاهده ی نتایج در این منو، لطفا ابتدا جستجو انجام دهید.',
      selectNumberFirst:
        'جهت مشاهده متن پیام لطفا ابتدا ارسال کننده را انتخاب کنید.',
      patternFieldHint:
        'لطفاً در صورت استفاده از الگو، از قرار دادن کاراکتر «/» در ابتدای آن خودداری کنید. برای مثال: <b>^d+$</b>',
      changeThenConditionTypeMessage:
        'با تغییر این مورد تمامی زیرمجموعه ها حذف میشوند.',
      bulkRecipientsLimitation:
        'تعداد محدوده های ارسال باید کمتر از {{count}} باشد.',
      onlineSurveyStatisticsMsg:
        'جهت نمایش آمار بازه شروع و پایان را انتخاب کنید.',
      messageTemplateGuide:
        'برای انتخاب الگوی پیامک، ابتدا گروه پیامک را انتخاب کنید.',
      onlineSurveyResponsesMsg:
        'جهت نمایش لیست پاسخ‌ها نظرسنجی را انتخاب کنید.',
      redirectUrlMessage: 'پس از اتمام به چه مسیری منتقل شود ؟',
      required: 'پاسخ به این سوال الزامی می‌باشد.',
      maxLength: 'حداکثر تعداد حروف پاسخ می بایست {{maxLength}} رقم باشد.',
      minLength: 'حداقل تعداد حروف پاسخ می بایست {{minLength}} رقم باشد.',
      pattern: 'پاسخ شما نامعتبر است ',
      selectThemeType: 'نوع تم را انتخاب کنید',
      enterQuestion: 'متن سوال را وارد کنید. ',
      selectQuestionType: 'نوع سوال را انتخاب کنید. ',
      enterAnswerLength: 'در‌صورت تمایل محدودیت تعداد حروف پاسخ را وارد کنید. ',
      isRequiredQuestion: 'پاسخ به سوال اجباری',
      notfoundSurvey: 'نظرسنجی یافت نشد!',
      backToHomepage: 'بازگشت به صفحه اصلی',
      enterPasswordHere: 'پاسخ را اینجا بنویسید',
      smartSignatureMessage:
        'در صورتی که امضای خط را از متن پیام حذف کنید، هنگام ارسال امضا به صورت سیستمی به متن اضافه میشود.',
      forbiddenVoiceAndSocialSend:
        'امکان ارسال صوتی و شبکه اجتماعی در این نوع ارسال وجود ندارد.',
      clipBoardAndManualCells:
        'توجه داشته باشید امکان استفاده از حالت های دستی و کلیپ بورد بصورت ترکیبی وجود ندارد. با تغییر حالت، داده های قبلی حذف میشوند. ',
      u11ConflictError:
        'امضا در متن مجدداً درج شده است ، برای جلوگیری از تغییر تعداد بخش‌ها، متن پیام را اصلاح کنید.',
      namesRegistered:
        '<span class="text-green-500 dark:text-green-400"> <b class="text-[14px] font-black">{{namesCount}}</b> نام ثبت شد.',
      cellsWidgetMessage:
        'جهت مشاهده شناسه دکل های ثبت شده ابتدا روی جستجو سپس <span class="font-medium"> {{downloadFile}} <i class="mdi mdi-tray-arrow-down mdi-18px text-gray"></i> </span> کلیک کنید .',
      pasteNames:
        '<p class="text-muted-foreground">برای جایگذاری نام‌ها می‌توانید روی کلید <i class="mdi mdi-clipboard-arrow-down-outline text-muted-foreground mdi-20px mt-1 mx-1"></i> کلیک نمایید یا از کلیدهای ترکیبی <kbd class="kbd mx-0.5">v</kbd>+<kbd class="kbd mx-0.5">Ctrl</kbd> استفاده کنید.</p>',
      cellNamesMaxLengthInManualMode:
        'حداکثر تعداد نام ها در حالت دستی  {{ size }}  می باشد. جهت جای گذاری با تعداد بیشتر از حالت کلیپ بورد استفاده نمائید.',
      outboxAdvancedSearchHelp:
        '*برای جست وجوی پیشرفته بر روی فیلدهای شماره گیرنده یا وضعیت ارسال یا وضعیت تحویل گیرندگان یا متن پیام، تاریخ شروع و پایان اجباری هستند.</br> *فیلتر تاریخ ارسال اجباری است و باید کمتر از 90 روز باشد.',
      selectRowFirst:
        'برای تعیین و انتخاب استراتژی لازم است ابتدا سطر یا سطرهای جدول انتخاب شوند.',
      editEndpointMsg:
        '  جهت نمایش جزئیات یا ویرایش اندپوینت روی آن کلیک کنید.  ',
      noMobileErrMsg: 'شماره موبایل تایید شده ای برای این کاربر وجود ندارد.',
      quickLinksMsg:
        'برای ذخیره تب به همراه فیلترهای مربوطه، کافی‌ست آدرس آن را کپی و با نام دلخواه ثبت کنید.توجه داشته باشید که با پاک کردن کش مرورگر، این اطلاعات نیز حذف خواهند شد.',
      formBuilderDescription:
        'لطفاً در فرم زیر اطلاعات درخواستی را وارد نمایید.',
      chooseThemeAndLogo:
        'لطفاً رنگ تم را انتخاب کرده و لوگوی مورد نظر را بارگذاری نمایید.',
      formBuilderReloadAfterFinish:
        ' صفحه فرم پس از اتمام مجدداً بارگذاری گردد',
      mobileNumberRequired:
        'وارد نمودن شماره موبایل الزامی است (جهت ارسال پیامک، فعال بودن این گزینه ضروری می‌باشد).',
      dynamicSmsBodyGuide:
        'برای تنظیم پیامک، کافی است ستون‌های موردنظر خود را با کلیک از لیست ستون‌ها انتخاب کنید تا به پیام افزوده شوند. همچنین می‌توانید با نگه داشتن و کشیدن ستون‌ها در ناحیه آبی، ترتیب نمایش آن‌ها را تغییر دهید.<br>چنانچه بخواهید متن دلخواهی نیز به پیام اضافه کنید، کافی است عبارت موردنظر خود را در فیلد «متن دلخواه» وارد کرده و روی دکمه «افزودن» کلیک کنید تا متن به پیامک افزوده شود.<br>همچنین در این نوع ارسال، امکان درج متن به‌ صورت یکپارچه و مشخص‌ کردن محل پارامترهای متغیر با استفاده از [ ] نیز فراهم است.',
      redirectToOnlineGateway:
        'در حال انتقال به درگاه بانکی. لطفا کمی صبر کنید.',
      newChatDescription:
        ' لطفاً قبل از شروع چت، موضوع گفت‌وگو را مشخص کنید تا بهتر راهنمایی‌تان کنیم.',
      selectOperators: 'لطفا اپراتور های مورد نظر خود را انتخاب کنید : ',

      enterMessage: 'پیام خود را بنویسید',
      updatePanel:
        'پنل به‌روزرسانی شده است. برای ادامه و استفاده از آخرین تغییرات لازم است صفحه را مجدد بازیابی کنید.',
      webhookDescription:
        'متد وب‌هوک باید GET باشد و پارامترهای To، From و Text از طریق QueryString ارسال شوند.',
      chatBotLoadingMessages: {
        msg1: 'در حال آماده‌سازی پاسخ 📝',
        msg2: 'در حال پردازش ...⚡',
        msg3: 'در حال بررسی ... 🚀',
        msg4: 'در حال بررسی اطلاعات ... ⏳',
        msg5: 'در حال تحلیل درخواست شما 🔍',
      },
      confirmChatBotSwitch:
        'پاسخ فعلی هنوز کامل نشده است. در صورت ورود به چت دیگر، روند پاسخ‌دهی متوقف می‌شود. با این وجود آیا مطمئن هستید؟',
      prefixHint: 'طول پیش‌ شماره باید بین ۴ تا ۸ رقم باشد.',
      enterDates: 'تاریخ و زمان پایان را انتخاب کنید',
      regenerateApiTokenSecretKeyMessage:
        'این کلید فقط یک‌بار نمایش داده می‌شود. لطفاً آن را کپی کنید.',
      confirmSaveRandomPassword: 'آیا مایل هستید رمز عبور ذخیره شود؟',
      phonebookAndManualWarning:
        'توجه داشته باشید امکان استفاده از حالت های <b>دستی</b> و <b>دفترچه تلفن </b>بصورت ترکیبی وجود ندارد. <br> <br> در حالت <b class="text-red-500 dark:text-red-400">{{modeWithDataTitle}}</b> اطلاعاتی ثبت شده است.با رفتن به حالت <b class="text-red-500 dark:text-red-400">{{modeTitle}}</b> این اطلاعات حذف خواهند شد. با این وجود از رفتن به حالت <b class="text-red-500 dark:text-red-400">{{modeTitle}}</b> مطمئن هستید؟',
      mainUrlTip:
        '<ul><li>• لینک باید با <b dir="ltr">http://</b> یا <b dir="ltr">https://</b> شروع شود.</li><li>• وجود www اختیاری است.</li><li>• دامنه باید شامل حروف انگلیسی یا عدد باشد.</li><li>• امکان وارد کردن مسیر یا پارامتر بعد از دامنه وجود دارد.</li></ul>',
      shortLinkMediaValidation:
        'افزودن حداقل یک تصویر یا یک ویدئو درون صفحه الزامی است. فرمت‌های مجاز برای تصاویر JPG و JPEG هستند و حداکثر حجم مجاز هر فایل ۱۰ مگابایت است.',
      manualPolygonTip:
        '<ul>  <li>• می‌توانید مختصات را به‌صورت دستی در این کادر وارد کنید.</li>  <li>• همچنین امکان انتخاب منطقه موردنظر از روی نقشه وجود دارد.</li>  <li>• فرمت مختصات باید شامل طول و عرض جغرافیایی معتبر باشد.</li>  <li>• مختصات را می‌توان با جداکننده ویرگول وارد کرد.</li></ul>',
      emptyForSelect: 'موردی برای انتخاب وجود ندارد.',
      userPrivateNumberListDescription:
        'لیست زیر شامل خطوط فعال به همراه عامل ارسال آن‌ها است. خطوطی که با نماد <i class="mdi mdi-volume-high mdi-22px text-muted-foreground"></i> مشخص شده‌اند، از نوع ارسال صوتی هستند.',
      paymentRegistrationDescription:
        'برای تأیید رسید، لطفاً مبلغ دقیق اعلام‌شده را پرداخت کنید. پس از انجام پرداخت، تصویر رسید واریز را بارگذاری نمایید.',
      liquidatePaymentByManagementDescription:
        'آیا از تسویه اعتبار بلوکه‌شده اطمینان دارید؟',
      rejectAuthentication: 'آیا از رد احرازهویت این مورد مطمئن هستید؟',
      confirmAuthentication: 'آیا از تایید احرازهویت این مورد مطمئن هستید ؟',
      packageCatalogAmount:
        'ضریب قابل ویرایش نیست؛ از تقسیم مبلغ پرداختی بر مبلغ بسته محاسبه می‌شود و در انقضا و برگشت به کار می‌رود.',
    },

    components: {
      mobilesAnalysis: {
        addTitle: 'افزودن به لیست سیاه',
        wrongMobileNumbers: 'شماره موبایل های اشتباه',
        listOfMobileNumbers: 'شماره موبایل های صحیح',
        alertPart1:
          'حداکثر تعداد نمایش  {{ size }} شماره می باشد ، جهت مشاهده شماره های بیشتر روی',
        alertPart2: 'کلیک کنید .',
        downloadText: 'دانلود فایل با فرمت Text',
        downloadExcel: 'دانلود فایل با فرمت Excel',
        correctNumbers: 'شماره های صحیح',
        wrongNumbers: 'شماره های اشتباه',
        manualAddDescription:
          '<p class="mt-3 mb-1">⁃ جهت افزودن شماره‌های موبایل به‌صورت دستی، لطفاً شماره‌های مورد نظر خود را در فیلد زیر وارد نمایید.</p><p class="my-1">⁃ سامانه به‌صورت هوشمند شماره‌های معتبر را تشخیص داده و ثبت می‌نماید. شماره‌هایی که به‌صورت نادرست یا نامعتبر وارد شوند، در بخش «شماره‌های اشتباه» نمایش داده خواهند شد.</p><p class="my-1 text-red-500 dark:text-red-400 font-medium">⁃ شماره‌های تکراری به‌صورت خودکار حذف می‌شوند و نیازی به اقدام دستی نخواهد بود.</p><p class="my-1">⁃ لطفاً توجه داشته باشید که در حالت ورود دستی، امکان ثبت حداکثر <b>{{number}}</b> شماره موبایل وجود دارد.</p><p class="my-1">⁃ در صورت وارد کردن تعداد زیادی شماره، توصیه می‌گردد جهت سهولت از بخش <span class="text-blue-500 dark:text-blue-400 font-medium">{{clipBoard}}</span> برای جای‌گذاری استفاده نمایید.</p>',
        uploadAddDescription:
          '<p class="mt-3 mb-1">⁃تنها فایل‌هایی با پسوندهای <b>{{fileTypes}}</b> مجاز به بارگذاری می‌باشند.</p><p class="my-1">⁃حداکثر حجم مجاز برای هر فایل جهت بارگذاری <b>{{maxFileSize}} مگابایت</b> می‌باشد.</p><p class="my-1 text-danger font-medium">⁃لطفاً توجه فرمایید سطر اول فایل اکسل خوانده نمی‌شود؛ لذا توصیه می‌گردد از آن صرفاً جهت درج عنوان ستون‌ها استفاده شود.</p><div class="my-1">⁃در فرآیند آماده‌سازی فایل، ضروری است شماره تماس گیرندگان فقط در ستون اول وارد شوند <p class="text-danger">البته مهم است که فرمت موبایل ها فارسی <b>نباشد.</b></p></div><p class="my-1">⁃عناوین ستون‌ها می‌بایست از نوع متنی (Text) و با حروف انگلیسی تنظیم گردند.</p><p class="my-1">⁃جهت دریافت نمونه فایل، لطفاً <a class="font-bold cursor-pointer" href="/assets/media/sample/sample.xlsx" download="sampleMobiles.xlsx" id="linkIdSampleMobiles">اینجا</a> کلیک کنید.</p><p class="my-1 text-danger font-medium">⁃شماره‌های موبایل تکراری به‌صورت خودکار حذف خواهند شد.</p><p class="my-1">⁃ لازم به ذکر است حداکثر تعداد قابل ثبت برای شماره موبایل <b>{{maxMobileNumbers}}</b> عدد می‌باشد.</p>',
        clipBoardAddDescription:
          '<p class="my-1">⁃برای افزودن شماره‌های موبایل، می‌توانید شماره‌های موجود در کلیپ‌بورد خود را در فیلد زیر جای‌گذاری (Paste) نمایید.</p><p class="my-1">⁃ سامانه به‌صورت هوشمند شماره‌های معتبر را تشخیص داده و ثبت می‌نماید. شماره‌هایی که به‌صورت نادرست یا نامعتبر وارد شوند، در بخش «شماره‌های اشتباه» نمایش داده خواهند شد.</p><p class="my-1 text-danger font-medium">⁃ شماره‌های تکراری به‌صورت خودکار حذف می‌شوند و نیازی به اقدام دستی نخواهد بود.</p><p class="my-1">⁃ لطفاً توجه داشته باشید که  در حالت کلیپ بورد ، امکان ثبت حداکثر <b>{{maxMobileNumbers}}</b> شماره موبایل وجود دارد.</p>',
        pasteNumber:
          '<p class="text-muted-foreground">برای جایگذاری شماره‌ها می‌توانید روی کلید <i class="mdi mdi-clipboard-arrow-down-outline text-muted-foreground mdi-20px mt-1 mx-1"></i> کلیک نمایید یا از کلیدهای ترکیبی <kbd class="kbd mx-0.5">v</kbd>+<kbd class="kbd mx-0.5">Ctrl</kbd> استفاده کنید.</p>',
        numberRegistered:
          '<span class="text-success"> <b class="text-[14px] font-black">{{mobileNumbersCountInClipboardMode}}</b> شماره ثبت شد. </span><br>جهت مشاهده شماره موبایل های ثبت شده روی <span class="font-medium"> {{downloadFile}} <i class="mdi mdi-tray-arrow-down mdi-18px text-gray"></i> </span> کلیک کنید .',
      },
      dynamicGrid: {
        props: {
          fromIndex: 'شروع از',
          sendCount: 'تعداد ارسال',
          Count: 'تعداد شماره',
          age: 'سن',
        },
      },
      smartSendConfirmation: {
        sendProperties: 'مشخصات ارسال',
        price: 'مبلغ هر پیامک',
        irr: ' ریال',
        polygonCalculatedPrice: 'هزینه ارسال محدوده',
        sendTotalPrice: 'مجموع هزینه',
        sendTotalPriceDesc:
          'هزینه به صورت تقریبی و بر اساس طول یک پیامک محاسبه می شود ',
        NextStep: 'ارسال پیامک',
      },
      domainForm: {
        imageUploaderHelpForLoginWithCarousel:
          '<p class="mt-3 mb-1 text-base"> ⁃ عکس ارسالی الزاما باید تحت فرمت <b>jpg ، png و jpeg </b>باشد .</p> <p class="my-3 text-base"> ⁃ پیشنهاد می شود سایز عکس آپلودی در اندازه <b>4006px * 2116px</b> باشد.</p> <p class="my-3 text-base"> ⁃ حاشیه های عکس از بالا و پایین <b>378px</b> و از راست و چپ <b>756px</b> باشد.</p><p class="my-3 text-base">⁃ حداکثر حجم عکس <b>1MB</b> می‌باشد .</p>',
        imageUploaderHelpForLoginCarouselInCard:
          '<p class="mt-3 mb-1 text-base"> ⁃ عکس ارسالی الزاما باید تحت فرمت <b>jpg ، png و jpeg </b>باشد .</p> <p class="my-3 text-base"> ⁃ پیشنهاد می شود سایز عکس آپلودی در اندازه <b>835px * 835px</b> باشد.</p><p class="my-3 text-base">⁃ حداکثر حجم عکس <b>1MB</b> می‌باشد .</p>',
        imageUploaderHelpForRightOrCenterLogin:
          '<p class="mt-3 mb-1 text-base"> ⁃ عکس ارسالی الزاما باید تحت فرمت <b>jpg ، png و jpeg </b>باشد .</p> <p class="my-3 text-base"> ⁃ پیشنهاد می شود سایز عکس آپلودی در اندازه <b>1409px * 911px</b> باشد.</p><p class="my-3 text-base">⁃ حداکثر حجم عکس <b>1MB</b> می‌باشد .</p>',
      },
    },
    tour: {
      titles: {
        phonebook: 'دفترچه تلفن',
        senderNumber: 'ارسال کننده',
        dynamicTemplate: 'قالب پویا',
        directSendDateTime: 'ارسال مستقیم',
        receiversFile: 'فایل گیرندگان',
        smsCounter: 'تعداد کاراکتر و بخش',
        smsTools: 'ابزارهای پیام',
        smsPreview: 'پیش نمایش',
        smsTemplate: 'الگوهای پیامک',
        shortLink: 'لینک های کوتاه',
        emojiPicker: 'ایموجی',
        header: 'سرتیتر',
        signature: 'امضا',
        fastSend: 'ارسال سریع',
        periodicSendDateTime: 'ارسال دوره‌ای',
        gradualSendDateTime: 'ارسال تدریجی',
        extraReceivers: 'گیرندگان اضافی',
        manualReceivers: 'گیرندگان دستی',
        uploadFileReceivers: 'آپلود فایل',
        clipboardReceivers: ' کلیپ‌ بورد',
        description: ' فیلد توضیحات',
        filterRow: 'عنوان فیلتر',
        requestType: 'نوع درخواست',
        periodicDateTime: 'شروع و پایان زمان ارسال',
        manualPolygon: 'مختصات مناطق مورد نظر',
        smsCampaigns: 'زمان بندی تکراری ها',
        operators: 'اپراتور',
        map: 'نقشه',
        receiversPhone: 'دفترچه تلفن',
        toNumberFieldName: 'شماره موبایل',
        linkFieldName: 'عنوان فیلد لینک',
        trackingNumberFieldName: 'کد پیگیری',
        customText: 'متن دلخواه',
        addCustomText: 'افزودن متن دلخواه',
        pattern: 'قالب',
        columns: 'لیست ستون ها',
        state: 'استان',
        city: 'شهر',
        region: 'منطقه',
        businessGroup: 'گروه مشاغل',
        businessSubGroup: 'زیرگروه مشاغل',
        operatorType: 'اپراتور',
        mobileType: 'نوع شماره',
        mobilePrefix: 'پیش شماره',
        postalCode: 'کدپستی',
        gender: 'جنسیت',
        totalMobileNumber: 'تعداد کل شماره ها',
        startFrom: 'ارسال از شماره',
        countToSend: 'تعداد ارسال',
        howManyDaysSendItBeforeDueDate: 'ارسال قبل از تاریخ رویداد',
        type: 'نوع',
        phonebookCustomFieldNameEn: 'فیلدهای سفارشی',
        calenderOccasion: 'مناسبت تقویمی',
        calenderOrganizationOccasion: 'مناسبت سازمانی',
        sendDateTime: 'ساعت ارسال',
        phonebookAdvancedSearch: 'جستجوی پیشرفته',
        globalIndex: 'اندیس گذاری کلی',
        linkUrlForGenerateShortLink: 'آدرس لینک',
        add: 'افزودن',
        calculateTotalCount: 'محاسبه تعداد شماره',
        requestName: 'عنوان درخواست',
        grayList: 'لیست خاکستری',
        submit: 'ثبت',
        search: 'جستجو',
        addPublicPlace: 'افزودن مکان عمومی',
        addToPublicPlace: 'افزودن به مکان شخصی',
        periodicPattern: 'نمایش تقویم',
        periodicType: 'نوع ارسال',
        periodText: 'زمان پس از دریافت',
        sendCountType: 'نوع محاسبه تعداد ارسال',
        countAs: 'درصد/تعداد ارسال',
        maxSendCount: 'حداکثر تعداد ارسال',
        maxDailySendCount: 'سقف تعداد روزانه',
        createCampain: 'ایجاد و اجرای کمپین',
        reversePolygon: 'جا به جا کردن مختصات',
        indexingTable: 'جدول گیرندگان ارسال',
      },
      descriptions: {
        phonebookDescription: 'انتخاب گیرندگان از دفترچه تلفن.',
        senderNumberDescription:
          'انتخاب خط ارسال‌ کننده پیامک خود، که از این قسمت انجام می‌شود.',
        dynamicTemplateDescription:
          'لیست قالب‌های متن پویا شما در این بخش نمایش داده می‌‍شوند.',
        directSendDateTimeDescription:
          'تعیین زمان موردنظر جهت ارسال پیام به‌صورت همزمان.',
        receiversFileDescription:
          'در این قسمت می‌توانید فایل شامل شماره همراه های گیرندگان را آپلود کنید.',
        smsCounterDescription:
          'نمایش تعداد حروف و بخش متن پیام شما، جهت مدیریت هزینه ارسال.',
        smsToolsDescription:
          'از این ابزارها می‌توانید برای پیش‌ نمایش، قالب‌ها، لینک کوتاه و ایموجی استفاده کنید.',
        fastSendDescription:
          'با استفاده از ارسال سریع میتوانید پیامک‌ های خود را بدون انجام تنظیمات پیشرفته و در سریع‌ترین زمان ممکن ارسال نمایید.',
        periodicSendDateTimeDescription:
          'ارسال پیامک به‌ صورت خودکار و در بازه‌های زمانی تعیین‌ شده برای گیرندگان ثابت.',
        gradualSendDateTimeDescription:
          'ارسال پیامک به صورت مرحله ای و زمان بندی شده برای گیرندگان انتخابی',
        extraReceiversDescription:
          'شماره‌های اضافی که پیام، هم‌زمان برای آن‌ها ارسال می‌شود.',
        manualReceiversDescription:
          'جایگذاری شماره گیرندگان تا حداکثر 10000 عدد با استفاده از این روش انجام می‌شود.  ',
        uploadFileReceiversDescription:
          'افزودن شماره گیرندگان با بارگذاری فایل با استفاده از این روش انجام می‌شود.',
        clipboardReceiversDescription:
          'برای جایگذاری شماره گیرندگان به تعداد بالا از این روش استفاده نمایید.',
        filterRowSelectionSmartSms: 'دراین قسمت شما میتوانید بر اساس پیام ',
        smsPreviewDescription:
          'پیش نمایش متن پیام قبل از ارسال را از این بخش میتوانید مشاهده کنید.',
        smsTemplateDescription:
          'لیست الگوهای آماده شما در این بخش نمایش داده می‌شوند.',
        shortLinkDescription:
          'لیست لینک های کوتاه شده شما در این بخش نمایش داده می‌شوند.',
        emojiPickerDescription:
          'با استفاده از این بخش امکان ارسال شکلک در پیام‌های خود را دارید.',
        headerDescription:
          'سرتیتر تعیین شده برای سازمان و خط فرستنده در این بخش نمایش داده می‌شود.',
        signatureDescription:
          'امضا تعیین شده برای سازمان و خط فرستنده در این بخش نمایش داده می‌شود.',
        descriptionFieldDescription:
          'جهت یادداشت گذاری ارسال پیام ها استفاده می‌گردد.',
        filterRowDescription:
          'با استفاده از پارامترهای مختلف، مخاطبان هدف را بر اساس ویژگی‌های موردنظر خود انتخاب و محدود می‌کنید.',
        manualPolygonDescription:
          'مختصات جغرافیایی منطقه هدف (طول و عرض جغرافیایی) را طبق فرمت نمایشی وارد نمایید.',

        requestTypeSmartSmsDescription:
          'در این بخش نوع درخواست براساس هدف ارسال یا مخاطبین مشخص می‌شود.',
        periodicDateTimeDescription:
          'بازه زمانی از شروع تا پایان را در این قسمت انتخاب کنید',
        smsCampaingsDescriprtion:
          'تا چند ساعت، شماره ای تکراری در نظر گرفته شود؟',
        operatorsDescription:
          'لیست اپراتورها در این قسمت نمایش داده می‌شود، می‌توانید یک یا چند اپراتور را انتخاب کنید.',
        mapDescription: 'از روی نقشه می‌توانید منطقه مورد نظر را انتخاب کنید.',
        receiversPhoneDescription:
          'در این بخش گروه دفترچه‌های موجود جهت ارسال نمایش داده می‌شوند.',
        toNumberFieldNameDescription:
          'عنوان ستون حاوی شماره موبایل در فایل بارگذاری شده جهت انتخاب در این بخش نمایش داده می‌شود.',
        linkFieldNameDescription:
          'عنوانی برای فیلد حاوی لینک تعیین شده وارد نمایید تا در بخش لیست ستون ها نمایش داده شود.',
        trackingNumberFieldNameDescription:
          'عنوان ستون حاوی کد پیگیری در فایل بارگذاری شده جهت انتخاب در این بخش نمایش داده می‌شود.',
        customTextDescription: '',
        addCustomTextDescription:
          'با استفاده از این امکان بخش‌های ثابت به متن پیام، اضافه می‌گردد .',
        columnsDescription:
          'کلیه ستون های موجود در فایل بارگذاری شده جهت افزودن به متن در این بخش نمایش داده می‌شوند.',
        patternDescription:
          'قالب کامل متن پیامک تعریف شده در این قسمت نمایش داده می‌شود .',
        stateDescription:
          'ابتدا استان موردنظر جهت ارسال منطقه‌ای را انتخاب نمایید.',
        cityDescription:
          'سپس درصورت نیاز، شهر موردنظر جهت ارسال هدفمندتر را انتخاب نمایید.',
        regionDescription: 'لیست مناطق شهرداری در این بخش نمایش داده می‌شوند. ',
        businessGroupDescription:
          'در این بخش لیستی از گروه مشاغل متنوع نمایش داده می‌شود.',
        businessSubGroupDescription:
          'براساس گروه مشاغل انتخابی، لیست اصناف مرتبط نمایش داده می‌شود.',
        operatorTypeDescription:
          'در این بخش می‌توانید اپراتور مورد نظرتان جهت ارسال انتخاب نمایید.',
        mobileTypeDescription:
          'دائمی یا اعتباری بودن شماره موبایل در این بخش تعین می‌گردد.',
        mobilePrefixDescription:
          'در این فیلد به منظور ارسال هدفمند پیش‌شماره گیرندگان تا 6 رقم وارد می‌شود.',
        postalCodeDescription:
          'در این فیلد کدپستی منطقه موردنظر شما جهت دریافت پیامک وارد می‌شود.',
        genderDescription: '',
        addDescription:
          'پس از محاسبه تعداد، تعیین اندیس و تعداد گیرنده، با انتخاب این گزینه گیرندگان برای ارسال ثبت می‌گردند.',
        calculateTotalCountDescription:
          'پس از تعیین فیلترها، تعداد گیرندگان مطابق با شرایط انتخابی محاسبه و نمایش داده می‌شود.',
        totalMobileNumberDescription:
          'در این بخش، تعداد کل شماره‌ها بر اساس فیلترهای انتخاب‌شده محاسبه و نمایش داده می‌شود.',
        startFromDescription:
          'در این بخش، مشخص می‌کنید ارسال پیام‌ها از کدام شماره یا اندیس آغاز شود.',
        countToSendDescription:
          'در این بخش تعداد گیرندگان موردنظر را وارد می‌نمایید.',
        howManyDaysSendItBeforeDueDateDescription:
          'این فیلد مشخص می‌کند پیام چند روز قبل از تاریخ تعیین‌شده برای مخاطب ارسال گردد.',
        typeDescription:
          'در این بخش نوع ارسال مناسبتی مشخص می‌گردد؛ می‌تواند بر اساس مناسبت‌های تقویمی یا سازمانی، یا تاریخ‌های دلخواه ثبت‌شده برای گیرندگان (مانند تاریخ تولد) باشد.',
        phonebookCustomFieldNameEnDescription: ' ',
        calenderOccasionDescription: ' ',
        calenderOrganizationOccasion: ' ',
        sendDateTimeDescription: ' ',
        searchDescription: 'جهت جستجو مناطق مورد نظرتان استفاده می‌شود.',
        addToPublicPlaceDescription:
          'ذخیره منطقه انتخابی به‌عنوان مکان‌های شخصی یا موردعلاقه.',
        addPublicPlaceDescription:
          'انتخاب مکان های عمومی و یا مکان های شخصی ذخیره شده با استفاده از این ابزار انجام می‌شود.',
        submitDescription:
          'جهت ثبت نهایی درخواست مکان محور خود این گزینه را انتخاب نمایید.',
        grayListDescription:
          'لیست های تعریف شده جهت جلوگیری از ارسال تکراری در این بخش نمایش داده می‌شوند.',
        requestNameDescription:
          'به منظور نام‌گذاری و مدیریت درخواست‌های مکان محور استفاده می‌شود. ',
        linkUrlForGenerateShortLinkDescription:
          'آدرس کامل لینک موردنظرتان را در این بخش وارد نمایید.',
        globalIndexDescription:
          'تعیین اندیس و تعداد مخاطبین هدف به صورت گروهی درصورت انتخاب چند گروه دفترچه',
        phonebookAdvancedSearchDescription:
          'با استفاده از جستجوی پیشرفته می توانید براساس پارامترهای مختلف به مخاطبین موردنظرتان دست یابید.',
        periodicPatternDescription:
          ' روزهای مورد نظر جهت ارسال پیامک به صورت انتخابی در این قسمت تعیین می‌شوند.',
        periodicTypeDescription:
          'نوع بازه زمانی ارسال پیامک در این بخش مشخص می‌شود.',
        periodTextDescription:
          'مدت زمان مورد نظر جهت ایجاد پارت های پیامکی در این بخش تعیین می‌شود.',

        sendCountTypeDescription:
          'در این قسمت تعیین می‌کنید تعداد ارسال بر چه اساسی محاسبه گردد. ',
        countAsDescription:
          'تعداد گیرندگان جهت ارسال در هر پارت پیامکی در این فیلد تعیین می‌شود.',
        maxSendCountDescription:
          'حداکثر تعداد گیرندگان مربوط به کل کمپین را در این فیلد وارد نمایید.',
        maxDailySendCountDescription:
          'حداکثر تعداد گیرندگان در هر روز  را در فیلد وارد نمایید.',
        createCampainDescription:
          'به منظور ثبت نهایی ارسال کمپین مکان محور این گزینه را انتخاب نمایید.',
        reversePolygonDescription:
          'جهت جا به جایی طول و عرض جغرافیایی مختصات منطقه وارد شده استفاده می‌گردد.',
        indexingTableDescription:
          'در این جدول می‌توانید اندیس و تعداد گیرندگان موردنظر جهت ارسال پیامک را تعیین نمایید.',
      },
    },
  },
};
